webpackJsonp([5],{

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(839),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33f88de8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        cropUsername: function cropUsername(uname) {
            if (uname) {
                return uname.length > 20 ? uname.substring(0, 20) + "..." : uname;
            } else {
                return "";
            }
        }
    }
});

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      filterLocation: "Worldwide",
      filterViewType: "Everything is better ",
      tab: "all",
      spotTypes: ["all"],
      location: "worldwide",
      openLocations: false,
      selectorSpotTypes: [{
        label: "Hotels & Apartments",
        id: "hotel",
        search: ["hotel", "appartments"]
      }, {
        label: "Bars & Restaurants",
        id: "bar",
        search: ["bars", "restaurant", "reataurants", "bar"]
      }, {
        label: "Panoramic spots",
        id: "panaromic",
        search: ["all"]
      }],
      filterObject: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    var linkQuery = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$route.query));
    this.tab = linkQuery.tab ? linkQuery.tab : "all";
    if (this.tab && this.tab !== "all") {
      var obj = this.selectorSpotTypes.find(function (x, index) {
        if (x.id === _this.tab) {
          x["index"] = index;
          return x;
        }
      });
      // this.changespotType(obj.id, obj.search, obj.index);
    }
    this.location = linkQuery.loc ? linkQuery.loc : "Worldwide";
    this.filterLocation = linkQuery.loc ? linkQuery.loc : "worldwide";
    this.spotTypes = linkQuery.st ? linkQuery.st : "all";
  },

  methods: {
    changespotType: function changespotType(optionId, spotType, index) {
      this.tab = optionId;
      if (optionId === "all") {
        this.spotTypes = spotType;
        this.searchFilter();
      } else {
        if (index > 0) {
          var currentOption = this.selectorSpotTypes[index];
          this.selectorSpotTypes.splice(index, 1);
          this.selectorSpotTypes.unshift(currentOption);
        }
        this.spotTypes = spotType;
        this.searchFilter();
      }
    },
    searchFilter: function searchFilter() {
      localStorage.removeItem("homePageImages");
      var obj = {
        st: this.spotTypes,
        loc: this.location,
        filter: true,
        tab: this.tab
      };
      var filterObject = {
        filtered: true,
        st: this.spotTypes,
        loc: this.location,
        tab: this.tab
      };
      localStorage.setItem("filterSettings", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filterObject));
      this.$router.push({ path: "/", query: obj });
    },
    clearFilter: function clearFilter() {
      localStorage.removeItem("homePageImages");
      this.tab = "all";
      this.spotTypes = ["all"];
      this.location = "worldwide";
      var obj = {
        st: ["all"],
        loc: "worldwide",
        filter: true,
        tab: "all"
      };
      var filterObject = {
        filtered: false,
        st: ["all"],
        loc: "worldwide",
        tab: this.tab
      };
      localStorage.setItem("filterSettings", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filterObject));
      this.$router.push({ path: "/", query: obj });
    },
    setLocation: function setLocation(location) {
      this.filterLocation = location;
      this.location = location;
      this.openLocations = false;
      this.searchFilter();
    },
    toggleLocations: function toggleLocations() {
      this.openLocations = !this.openLocations;
    }
  }
});

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".search-container[data-v-1b0aece8]{color:#fff;width:90vw;font-family:MontSerrat-Regular;font-size:12px}@media screen and (min-width:769px){.search-container[data-v-1b0aece8]{width:100%;font-size:16px}}.search-container .search-overview[data-v-1b0aece8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.search-container .search-overview .what-with-a-view[data-v-1b0aece8]{font-weight:700;text-transform:capitalize}.search-container .search-overview .view-type-list[data-v-1b0aece8]{padding-left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow:scroll;-ms-overflow-style:none;scrollbar-width:none}.search-container .search-overview .view-type-list .view-type-list-item[data-v-1b0aece8]{padding-left:10px;padding-right:10px;cursor:pointer;font-weight:100;white-space:nowrap}.search-container .search-overview .view-type-list .all[data-v-1b0aece8]{border-right:.5px solid hsla(0,0%,100%,.5)}.search-container .search-overview .view-type-list .active[data-v-1b0aece8]{font-family:MontSerrat;border-bottom:.5px solid #f5a623;font-weight:900}.search-container .search-overview .view-type-list[data-v-1b0aece8]::-webkit-scrollbar{display:none}.search-container .search-overview .logo[data-v-1b0aece8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;color:#bd10e0;font-weight:700}.search-container .search-details[data-v-1b0aece8]{padding-top:5px;cursor:pointer;position:relative}.search-container .search-details .filter-container[data-v-1b0aece8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:36px;padding:10px 0;border-radius:23px;background-color:#1f1f1f}.search-container .search-details .filter-container .filter-location[data-v-1b0aece8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-transform:capitalize}.search-container .search-details .filter-container .filter-location .location-name[data-v-1b0aece8]{text-align:start;color:#b9b9b9;width:50%}.search-container .search-details .filter-container .filter-icon-select-dates[data-v-1b0aece8]{-ms-flex-negative:0;flex-shrink:0;display:-webkit-box;display:-ms-flexbox;display:flex;color:#b9b9b9;white-space:nowrap}.search-container .search-details .filter-container .filter-icon-select-dates .separator[data-v-1b0aece8]{border-left:.5px solid #b9b9b9}.search-container .search-details .filter-container .filter-icon-select-dates .filter-icon[data-v-1b0aece8]{color:#b9b9b9}.btn-style[data-v-1b0aece8]{padding:6px 12px;border-radius:6px}.cancel-btn[data-v-1b0aece8]{background-color:#000;color:#fff;width:38%}.update-btn[data-v-1b0aece8]{width:70%;background-color:#f5a623;color:#000}.location-dropdown[data-v-1b0aece8]{background-color:#000;color:#fff;border-radius:20px;position:absolute;font-family:MontSerrat-Regular;padding:6px;width:100%;top:36px;left:0;text-align:left;height:200px}.location-dropdown .location-list[data-v-1b0aece8]{padding:4px 35px}@media only screen and (min-width:768px){.location-dropdown[data-v-1b0aece8]{padding:5px}.location-dropdown .location-list[data-v-1b0aece8]{padding:5px 40px}}.location-dropdown li[data-v-1b0aece8]{margin:6px 0;font-weight:700}.location-dropdown .location-name[data-v-1b0aece8]{text-transform:capitalize;font-family:MontSerrat;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.location-dropdown ul[data-v-1b0aece8]{height:100%}.dates-dropdown[data-v-1b0aece8]{color:#fff;margin:5px 0;border-top:.5px solid #b9b9b9;border-bottom:.5px solid #b9b9b9;padding:0 12px;border-radius:6px;max-height:376px;overflow:auto;width:100%;text-align:left;display:-webkit-box;display:-ms-flexbox;display:flex}.dates-dropdown .check-in-date[data-v-1b0aece8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding:6px 0;display:-webkit-box;display:-ms-flexbox;display:flex;color:#b9b9b9;border-right:1px solid #b9b9b9;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.dates-dropdown .check-in-date label[data-v-1b0aece8]{margin-left:5px}.dates-dropdown .check-out-date[data-v-1b0aece8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding:6px 0;display:-webkit-box;display:-ms-flexbox;display:flex;color:#b9b9b9;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-left:10px}.dates-dropdown .check-out-date label[data-v-1b0aece8]{margin-left:5px}.no-of-guests[data-v-1b0aece8]{margin-top:2px;width:100%}.set-button[data-v-1b0aece8]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:10px;background-color:transparent;font-family:MontSerrat-Regular;font-weight:100;padding:5px 10px;border:1px solid #b9b9b9;color:#b9b9b9}.set-button[data-v-1b0aece8]:hover{font-weight:800;color:#fff}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/common/searchContainer.vue"],"names":[],"mappings":"AACA,mCACE,WAAe,AACf,WAAY,AACZ,+BAAkC,AAClC,cAAgB,CACjB,AACD,oCACA,mCACM,WAAY,AACZ,cAAgB,CACrB,CACA,AACD,oDACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,sEACM,gBAAkB,AAClB,yBAA2B,CAChC,AACD,oEACM,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,gBAAiB,AACjB,wBAAyB,AAEzB,oBAAsB,CAE3B,AACD,yFACQ,kBAAmB,AACnB,mBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,kBAAoB,CAC3B,AACD,yEACQ,0CAAmD,CAC1D,AACD,4EACQ,uBAA0B,AAC1B,iCAAmC,AACnC,eAAiB,CACxB,AACD,uFACM,YAAc,CACnB,AACD,0DACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,2BAA4B,AACxB,wBAAyB,AACrB,qBAAsB,AAC9B,cAAe,AACf,eAAkB,CACvB,AACD,mDACI,gBAAiB,AACjB,eAAgB,AAChB,iBAAmB,CACtB,AACD,qEACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAiB,AACjB,eAAkB,AAClB,mBAAoB,AACpB,wBAA0B,CAC/B,AACD,sFACQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA2B,CAClC,AACD,qGACU,iBAAkB,AAClB,cAAe,AACf,SAAW,CACpB,AACD,+FACQ,oBAAqB,AACjB,cAAe,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,cAAe,AACf,kBAAoB,CAC3B,AACD,0GACU,8BAAiC,CAC1C,AACD,4GACU,aAAe,CACxB,AACD,4BACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,6BACE,sBAA0B,AAC1B,WAAe,AACf,SAAW,CACZ,AACD,6BACE,UAAW,AACX,yBAA0B,AAC1B,UAAe,CAChB,AACD,oCACE,sBAA0B,AAC1B,WAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,+BAAkC,AAClC,YAAa,AACb,WAAY,AACZ,SAAU,AACV,OAAU,AACV,gBAAiB,AACjB,YAAc,CACf,AACD,mDACI,gBAAkB,CACrB,AACD,yCACA,oCACM,WAAa,CAClB,AACD,mDACQ,gBAAkB,CACzB,CACA,AACD,uCACI,aAAc,AACd,eAAiB,CACpB,AACD,mDACI,0BAA2B,AAC3B,uBAA0B,AAC1B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,uCACI,WAAa,CAChB,AACD,iCACE,WAAe,AACf,aAAgB,AAChB,8BAAgC,AAChC,iCAAmC,AACnC,eAAkB,AAClB,kBAAmB,AACnB,iBAAkB,AAClB,cAAe,AACf,WAAY,AACZ,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,gDACI,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,cAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,cAAe,AACf,+BAAgC,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC/B,AACD,sDACM,eAAiB,CACtB,AACD,iDACI,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,cAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,cAAe,AACf,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAkB,CACrB,AACD,uDACM,eAAiB,CACtB,AACD,+BACE,eAAgB,AAChB,UAAY,CACb,AACD,6BACE,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,gBAAiB,AACjB,6BAA8B,AAC9B,+BAAkC,AAClC,gBAAiB,AACjB,iBAAkB,AAClB,yBAA0B,AAC1B,aAAe,CAChB,AACD,mCACI,gBAAiB,AACjB,UAAe,CAClB","file":"searchContainer.vue","sourcesContent":["\n.search-container[data-v-1b0aece8] {\n  color: #ffffff;\n  width: 90vw;\n  font-family: \"MontSerrat-Regular\";\n  font-size: 12px;\n}\n@media screen and (min-width: 769px) {\n.search-container[data-v-1b0aece8] {\n      width: 100%;\n      font-size: 16px;\n}\n}\n.search-container .search-overview[data-v-1b0aece8] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.search-container .search-overview .what-with-a-view[data-v-1b0aece8] {\n      font-weight: bold;\n      text-transform: capitalize;\n}\n.search-container .search-overview .view-type-list[data-v-1b0aece8] {\n      padding-left: 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      overflow: scroll;\n      -ms-overflow-style: none;\n      /* IE and Edge */\n      scrollbar-width: none;\n      /* Firefox */\n}\n.search-container .search-overview .view-type-list .view-type-list-item[data-v-1b0aece8] {\n        padding-left: 10px;\n        padding-right: 10px;\n        cursor: pointer;\n        font-weight: 100;\n        white-space: nowrap;\n}\n.search-container .search-overview .view-type-list .all[data-v-1b0aece8] {\n        border-right: 0.5px solid rgba(255, 255, 255, 0.5);\n}\n.search-container .search-overview .view-type-list .active[data-v-1b0aece8] {\n        font-family: \"MontSerrat\";\n        border-bottom: 0.5px solid #f5a623;\n        font-weight: 900;\n}\n.search-container .search-overview .view-type-list[data-v-1b0aece8]::-webkit-scrollbar {\n      display: none;\n}\n.search-container .search-overview .logo[data-v-1b0aece8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: baseline;\n          -ms-flex-align: baseline;\n              align-items: baseline;\n      color: #bd10e0;\n      font-weight: bold;\n}\n.search-container .search-details[data-v-1b0aece8] {\n    padding-top: 5px;\n    cursor: pointer;\n    position: relative;\n}\n.search-container .search-details .filter-container[data-v-1b0aece8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      min-height: 36px;\n      padding: 10px 0px;\n      border-radius: 23px;\n      background-color: #1f1f1f;\n}\n.search-container .search-details .filter-container .filter-location[data-v-1b0aece8] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-flex: 1;\n            -ms-flex-positive: 1;\n                flex-grow: 1;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        text-transform: capitalize;\n}\n.search-container .search-details .filter-container .filter-location .location-name[data-v-1b0aece8] {\n          text-align: start;\n          color: #b9b9b9;\n          width: 50%;\n}\n.search-container .search-details .filter-container .filter-icon-select-dates[data-v-1b0aece8] {\n        -ms-flex-negative: 0;\n            flex-shrink: 0;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        color: #b9b9b9;\n        white-space: nowrap;\n}\n.search-container .search-details .filter-container .filter-icon-select-dates .separator[data-v-1b0aece8] {\n          border-left: 0.5px solid #b9b9b9;\n}\n.search-container .search-details .filter-container .filter-icon-select-dates .filter-icon[data-v-1b0aece8] {\n          color: #b9b9b9;\n}\n.btn-style[data-v-1b0aece8] {\n  padding: 6px 12px;\n  border-radius: 6px;\n}\n.cancel-btn[data-v-1b0aece8] {\n  background-color: #000000;\n  color: #ffffff;\n  width: 38%;\n}\n.update-btn[data-v-1b0aece8] {\n  width: 70%;\n  background-color: #f5a623;\n  color: #000000;\n}\n.location-dropdown[data-v-1b0aece8] {\n  background-color: #000000;\n  color: #ffffff;\n  border-radius: 20px;\n  position: absolute;\n  font-family: \"MontSerrat-Regular\";\n  padding: 6px;\n  width: 100%;\n  top: 36px;\n  left: 0px;\n  text-align: left;\n  height: 200px;\n}\n.location-dropdown .location-list[data-v-1b0aece8] {\n    padding: 4px 35px;\n}\n@media only screen and (min-width: 768px) {\n.location-dropdown[data-v-1b0aece8] {\n      padding: 5px;\n}\n.location-dropdown .location-list[data-v-1b0aece8] {\n        padding: 5px 40px;\n}\n}\n.location-dropdown li[data-v-1b0aece8] {\n    margin: 6px 0;\n    font-weight: 700;\n}\n.location-dropdown .location-name[data-v-1b0aece8] {\n    text-transform: capitalize;\n    font-family: \"MontSerrat\";\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.location-dropdown ul[data-v-1b0aece8] {\n    height: 100%;\n}\n.dates-dropdown[data-v-1b0aece8] {\n  color: #ffffff;\n  margin: 5px 0px;\n  border-top: 0.5px solid #b9b9b9;\n  border-bottom: 0.5px solid #b9b9b9;\n  padding: 0px 12px;\n  border-radius: 6px;\n  max-height: 376px;\n  overflow: auto;\n  width: 100%;\n  text-align: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.dates-dropdown .check-in-date[data-v-1b0aece8] {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    padding: 6px 0px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    color: #b9b9b9;\n    border-right: 1px solid #b9b9b9;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.dates-dropdown .check-in-date label[data-v-1b0aece8] {\n      margin-left: 5px;\n}\n.dates-dropdown .check-out-date[data-v-1b0aece8] {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    padding: 6px 0px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    color: #b9b9b9;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-left: 10px;\n}\n.dates-dropdown .check-out-date label[data-v-1b0aece8] {\n      margin-left: 5px;\n}\n.no-of-guests[data-v-1b0aece8] {\n  margin-top: 2px;\n  width: 100%;\n}\n.set-button[data-v-1b0aece8] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-top: 10px;\n  background-color: transparent;\n  font-family: \"MontSerrat-Regular\";\n  font-weight: 100;\n  padding: 5px 10px;\n  border: 1px solid #b9b9b9;\n  color: #b9b9b9;\n}\n.set-button[data-v-1b0aece8]:hover {\n    font-weight: 800;\n    color: #ffffff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(579);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("07a36066", content, true, {});

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA0MjYuNjk4IDQyNi42OTgiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgNDI2LjY5OCA0MjYuNjk4IiB3aWR0aD0iNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnPjxwYXRoIGQ9Im0zNDYuNjIzIDE0Mi42MTRjMCA3MS45NzItNzcuNTgyIDEzMC4yOS0xNzMuMzE0IDEzMC4yOS0yNS45ODcuMTE1LTUxLjc4OC00LjM4My03Ni4yMDMtMTMuMjg1LTU0LjUwOSAzOS41NDgtOTMuMTkzIDI1LjAzLTkzLjE5MyAyNS4wMyAxOS4xNTktMTMuMjE5IDMzLjcxMi0zMi4wODkgNDEuNjMtNTMuOTc4LTI4LjI5My0yMy4xNzgtNDUuNTQzLTU0LjA4My00NS41NDMtODguMDU3IDAtNzIuMDI1IDc3LjU4Mi0xMzAuMzQzIDE3My4zMTQtMTMwLjM0M3MxNzMuMzA5IDU4LjMxOCAxNzMuMzA5IDEzMC4zNDN6IiBmaWxsPSIjZWVlZmVlIi8+PGcgZmlsbD0iIzU3NWI2ZCI+PHBhdGggZD0ibTEwNi4xOTIgMTQyLjU3N2MwIDEwLjkyMS04Ljg1MyAxOS43NzQtMTkuNzc0IDE5Ljc3NHMtMTkuNzc0LTguODUzLTE5Ljc3NC0xOS43NzQgOC44NTMtMTkuNzc0IDE5Ljc3NC0xOS43NzRjMTAuOTEyLjAyIDE5Ljc1NCA4Ljg2MiAxOS43NzQgMTkuNzc0eiIvPjxwYXRoIGQ9Im0xOTMuMTA0IDE0Mi41NzdjMCAxMC45MjEtOC44NTMgMTkuNzc0LTE5Ljc3NCAxOS43NzRzLTE5Ljc3NC04Ljg1My0xOS43NzQtMTkuNzc0IDguODUzLTE5Ljc3NCAxOS43NzQtMTkuNzc0YzEwLjkxMi4wMiAxOS43NTQgOC44NjIgMTkuNzc0IDE5Ljc3NHoiLz48cGF0aCBkPSJtMjgwLjAxNiAxNDIuNTc3YzAgMTAuOTIxLTguODUzIDE5Ljc3NC0xOS43NzQgMTkuNzc0cy0xOS43NzQtOC44NTMtMTkuNzc0LTE5Ljc3NCA4Ljg1My0xOS43NzQgMTkuNzc0LTE5Ljc3NGMxMC45MTMuMDIgMTkuNzU0IDguODYyIDE5Ljc3NCAxOS43NzR6Ii8+PC9nPjxwYXRoIGQ9Im0xNDAuMTMgMjk0Ljg0OGMwIDU5LjUwNCA2NC4xNDEgMTA3LjcxNiAxNDMuMjg0IDEwNy43MTYgMjEuNDg1LjA5NyA0Mi44MTYtMy42MjEgNjMuMDAxLTEwLjk4IDQ1LjA2NCAzMi42ODQgNzcuMDQ2IDIwLjY5NSA3Ny4wNDYgMjAuNjk1LTE1Ljg0NS0xMC45MjYtMjcuODgzLTI2LjUyOC0zNC40MzMtNDQuNjI3IDIzLjQxNy0xOS4xNjUgMzcuNjctNDQuNzE1IDM3LjY3LTcyLjggMC01OS41NDYtNjQuMTQxLTEwNy43NTgtMTQzLjI4NC0xMDcuNzU4cy0xNDMuMjg0IDQ4LjIwOC0xNDMuMjg0IDEwNy43NTR6IiBmaWxsPSIjZjZjODYzIi8+PGNpcmNsZSBjeD0iMzU1LjU3OSIgY3k9IjI5NC44MjciIGZpbGw9IiM1NzViNmQiIHI9IjE2LjQzMyIvPjxjaXJjbGUgY3g9IjI4My40MTkiIGN5PSIyOTQuODI3IiBmaWxsPSIjNTc1YjZkIiByPSIxNi40MzMiLz48Y2lyY2xlIGN4PSIyMTEuMjU0IiBjeT0iMjk0LjgyNyIgZmlsbD0iIzU3NWI2ZCIgcj0iMTYuNDMzIi8+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjI2IiBoZWlnaHQ9IjEyOCIgdmVyc2lvbj0iMS4xIiBzdHlsZT0iIj48cmVjdCBpZD0iYmFja2dyb3VuZHJlY3QiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHg9IjAiIHk9IjAiIGZpbGw9Im5vbmUiIHN0cm9rZT0ibm9uZSIvPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMSI+CiAgPHBhdGggZD0iTSA3NSAwIEwgMTU3IDEyOCBMIDE3NiAxMjggTCAxMzUgNjQgTCAxNTcgMzAgTCAyMjYgMTI4IEwgMCAxMjggWiBNIDc1IDAgIiBpZD0ic3ZnXzEiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgoKPGcgY2xhc3M9ImN1cnJlbnRMYXllciIgc3R5bGU9IiI+PHRpdGxlPkxheWVyIDE8L3RpdGxlPjxnIGlkPSJzdXJmYWNlMSIgY2xhc3M9InNlbGVjdGVkIiBmaWxsPSIjMDAwMDAwIiBmaWxsLW9wYWNpdHk9IjEiPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDEpIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGlkPSJzdmdfMiIgZmlsbD0iIzAwMDAwMCIgZmlsbC1vcGFjaXR5PSIxIj4KPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjIyNiIgaGVpZ2h0PSIxMjgiIHN0eWxlPSJzdHJva2U6IG5vbmU7IiBpZD0ic3ZnXzMiIGZpbGw9IiMwMDAwMDAiIGZpbGwtb3BhY2l0eT0iMSIvPgo8L2c+CjwvZz48L2c+PC9zdmc+"

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(581)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(598),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b0aece8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 598:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search-container"
  }, [_c('div', {
    staticClass: "search-overview"
  }, [_c('ul', {
    staticClass: "view-type-list"
  }, [_c('li', {
    staticClass: "view-type-list-item pl-0 all",
    attrs: {
      "id": "all"
    },
    on: {
      "click": function($event) {
        return _vm.changespotType('all', ['all'], null)
      }
    }
  }, [_c('span', {
    class: _vm.tab === 'all' ? 'active' : ''
  }, [_vm._v("All")])]), _vm._v(" "), _vm._l((_vm.selectorSpotTypes), function(optionItem, index) {
    return _c('li', {
      key: index,
      staticClass: "view-type-list-item",
      attrs: {
        "id": optionItem.id
      },
      on: {
        "click": function($event) {
          return _vm.changespotType(optionItem.id, optionItem.search, index)
        }
      }
    }, [_c('span', {
      class: _vm.tab === ("" + (optionItem.id)) ? 'active' : ''
    }, [_vm._v(_vm._s(optionItem.label) + "\n            "), (_vm.tab === ("" + (optionItem.id))) ? _c('span', {
      staticClass: "hidden-sm-and-down"
    }, [_vm._v("with A view")]) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "search-details"
  }, [_c('div', {
    staticClass: "filter-container mt-1"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "position": "relative",
      "padding": "0px 20px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "filter-location"
  }, [_c('i', {
    staticClass: "material-icons cursor",
    staticStyle: {
      "color": "#ffffff",
      "font-size": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("arrow_back_ios")]), _vm._v(" "), _c('span', {
    staticClass: "location-name",
    on: {
      "click": _vm.toggleLocations
    }
  }, [_vm._v(_vm._s(_vm.filterLocation))])])]), _vm._v(" "), (_vm.openLocations) ? _c('div', {
    staticClass: "location-dropdown",
    on: {
      "mouseleave": _vm.toggleLocations
    }
  }, [_c('vue-scroll', [_c('ul', {
    staticClass: "location-list"
  }, [_c('li', {
    staticClass: "location-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.filterLocation))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "20px",
      "padding": "5px 5px 5px 15px"
    },
    on: {
      "click": _vm.toggleLocations
    }
  }, [_vm._v("close")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#979797",
      "width": "100%",
      "height": "1px"
    }
  }), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('worldwide')
      }
    }
  }, [_vm._v("Worldwide")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('barcelona')
      }
    }
  }, [_vm._v("Barcelona")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('berlin')
      }
    }
  }, [_vm._v("Berlin")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('copenhagen')
      }
    }
  }, [_vm._v("Copenhagen")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('florence')
      }
    }
  }, [_vm._v("Florence")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('lisbon')
      }
    }
  }, [_vm._v("Lisbon")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('london')
      }
    }
  }, [_vm._v("London")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('los angeles')
      }
    }
  }, [_vm._v("Los Angeles")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('madrid')
      }
    }
  }, [_vm._v("Madrid")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('milan')
      }
    }
  }, [_vm._v("Milan")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('new york')
      }
    }
  }, [_vm._v("New York")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('paris')
      }
    }
  }, [_vm._v("Paris")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('porto')
      }
    }
  }, [_vm._v("Porto")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('rome')
      }
    }
  }, [_vm._v("Rome")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('san francisco')
      }
    }
  }, [_vm._v("San Francisco")])])])], 1) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

exports.FeedbackFish={mounted:function(){var e=this;this.$nextTick(function(){var t=document.createElement("script");t.setAttribute("src","https://feedback.fish/ff.js?pid="+e.$props.projectId),t.defer=!0,document.head.appendChild(t)})},props:{projectId:String},render:function(){return null}};
//# sourceMappingURL=feedback-fish.js.map


/***/ }),

/***/ 635:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_imageLinks__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_share__ = __webpack_require__(213);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "slideShow",
  props: {
    toggleSlideShow: Function,
    imageArray: Array,
    like: Function
  },
  data: function data() {
    return {
      items: null,
      screenW: 0,
      currentIndex: 0
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_imageLinks__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixin_share__["a" /* default */]],
  computed: {
    getImageDescription: function getImageDescription() {
      var currentImageDetails = this.$props.imageArray[this.currentIndex];
      return currentImageDetails;
    }
  },
  methods: {
    getBackgroundImage: function getBackgroundImage(image) {
      return "background-image: url(" + image + ")";
    },
    addLike: function addLike() {
      this.$emit("like", this.getImageDescription, false);
    }
  },
  mounted: function mounted() {
    this.items = this.$props.imageArray;
    window.addEventListener("keydown", function (event) {
      switch (event.key) {
        case "ArrowLeft":
          document.getElementsByClassName("v-carousel__prev")[0].firstChild.click();
          break;
        case "ArrowRight":
          document.getElementsByClassName("v-carousel__next")[0].firstChild.click();
          break;
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.addEventListener("keydown", function (event) {
      switch (event.key) {
        case "ArrowLeft":
          this.keyboardLeftClick;
          break;
        case "ArrowRight":
          this.keyboardRightClick;
          break;
      }
    });
  },
  created: function created() {
    this.screenW = screen.width;
  }
});

/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_platform__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixin_imageLinks__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixin_cropUsername__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_identifySafariMobile__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_bottomMenu_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_bottomMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_common_bottomMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helper_gen__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_geo_hash__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_geo_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_geo_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_haversine__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_haversine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_haversine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_searchContainer_vue__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_searchContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__common_searchContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_loader_vue__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_loader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_loader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixin_share__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helper_valUrl__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__configurations__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__configurations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__configurations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__feedback_fish_vue__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__feedback_fish_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__feedback_fish_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_slideshow_vue__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_slideshow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__common_slideshow_vue__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var vm = void 0;











//


//

//

//


var cloudinarySettings = __WEBPACK_IMPORTED_MODULE_19__configurations___default.a.cloudinary_settings;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "viewzzz-image-details",
  metaInfo: function metaInfo() {
    return {
      title: this.getPageTitle(),
      titleTemplate: null,
      meta: [{ charset: "utf-8" }, {
        name: "description",
        content: this.getPageDescription()
      }, {
        property: "og:title",
        content: this.getOgTitle()
      }, {
        property: "og:description",
        content: "Everything's better with A view. Discover the most beautiful Hotels, Restaurants & Bars with A view."
      }, { property: "og:url", content: window.location.href, vmid: "og:url" }, // here it is just ngrok for my test
      {
        property: "og:site_name",
        content: "with A view"
      }, {
        property: "og:image",
        content: this.getOgImage()
      }, {
        property: "og:image:url",
        content: this.getOgImage()
      }, { property: "og:image:secure_url", content: this.getOgImage() }, {
        property: "og:image:type",
        content: "image/jpeg"
      }, {
        property: "og:type",
        content: "website"
      }, {
        name: "twitter:site",
        content: "@withaview_co"
      }, {
        name: "twitter:creator",
        content: "@withaview_co"
      }, {
        name: "twitter:url",
        content: "" + window.location.href
      }, {
        name: "twitter:title",
        content: "" + this.getOgTitle()
      }, {
        name: "twitter:description",
        content: "Everything's better with A view. Discover the most beautiful Hotels, Restaurants & Bars with A view."
      }, {
        name: "twitter:image",
        content: "" + this.getOgImage()
      }, {
        property: "fb:app_id",
        content: "172987823496136"
      }]
    };
  },

  // mixins
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixin_imageLinks__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__mixin_share__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixin_cropUsername__["a" /* default */]],
  data: function data() {
    return {
      pageLoader: true,
      platform: __WEBPACK_IMPORTED_MODULE_6_platform___default.a.name,
      loaderVal: 0,
      top_index: 0,
      imgLoader: true,
      top_sectionArr: [],
      currentImageData: null,
      changeFromSelect: false,
      fullScreen: false,
      current_top_index: 0,
      top_section: {},
      animPlay: true,
      limit: 10,
      screenH: 0,
      screenW: 0,
      locDetails: {},
      wishlistStatus: "add to my wishlist", // default value
      checkInStatus: "check-in", // default value
      imageInfo: {},
      addedToWishlist: false,
      checkedin: false,
      showFooter: true,
      monSelectOpts: false,
      durSelectOpts: false,
      muted: true,
      playVideo: false,
      playVideoWindow: true,
      youtubeVideoParameter: {
        autoplay: 1,
        controls: 1,
        loop: 1,
        playsinline: 1,
        modestbranding: 1
      },
      showSlideShow: false,
      lastScrollPosition: 0,
      showNavbar: true,
      filterViewType: "Everything is better ",
      showHomeIcon: true
    };
  },

  watch: {
    selected_mon: {
      handler: function handler() {
        this.top_sectionArr_compute();
      }
    },
    selected_dur: {
      handler: function handler() {
        this.top_sectionArr_compute();
      }
    },
    // changes when ask-to-add-to-wishlist is clicked
    "$store.state.common.toggleForAddToWishlist": {
      handler: function handler() {
        localStorage.removeItem("openDirections");
        if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.imageInfo).length !== 0) {
          if (this.imageInfo.isLiked === false) {
            this.changeCnt(this.imageInfo, false);
          }
          this.$modal.hide("ask-to-add-to-wishlist");
        }
      }
    },

    // when location of user is fetched
    "$store.state.gen.finalUserLocation": function $storeStateGenFinalUserLocation() {
      vm.getLocationImage();
    },

    // changes when clicked on 'nearby viewzzz'
    "$route.params.id": function $routeParamsId() {
      vm.getDet(vm.$route.params.id);
      vm.goBackToTop();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapGetters */])(["fetchingNearby", "isbottomMenuOpen", //
  "user", "finalUserLocation", "isLoggedIn", "fetchLocLoader", "nearBy", "user"]), {

    // check if device is mobile - safari
    checkIfMobileSafari: function checkIfMobileSafari() {
      var deviceIsSafriMobile = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_identifySafariMobile__["a" /* isMobileSafari */])();
      return deviceIsSafriMobile;
    }
  }),
  components: {
    bottomMenu: __WEBPACK_IMPORTED_MODULE_11__components_common_bottomMenu_vue___default.a,
    FeedbackFish: __WEBPACK_IMPORTED_MODULE_20__feedback_fish_vue__["FeedbackFish"],
    loader: __WEBPACK_IMPORTED_MODULE_16__components_loader_vue___default.a,
    slideShow: __WEBPACK_IMPORTED_MODULE_21__common_slideshow_vue___default.a,
    searchContainer: __WEBPACK_IMPORTED_MODULE_15__common_searchContainer_vue___default.a
  },

  // *********************** route navigation **********************
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.showFooter === false && localStorage.getItem("path") === null) {
      localStorage.removeItem("path");
      localStorage.removeItem("openDirections");
      vm.backToDetails();
      next(false);
    } else {
      localStorage.removeItem("path");
      localStorage.removeItem("openDirections");
      var localStorageElem = JSON.parse(localStorage.getItem("homePageImages"));
      if (localStorageElem != null) {
        var _obj = localStorageElem.filteredImagesArr[localStorageElem.swipeIndex];

        _obj.isLiked = vm.imageInfo.isLiked;
        _obj.isCheckedin = vm.imageInfo.isCheckedin;
        _obj.likes = vm.imageInfo.likes;
        _obj.checkins = vm.imageInfo.checkins;
        localStorageElem.filteredImagesArr[localStorageElem.swipeIndex] = _obj;
        localStorage.setItem("homePageImages", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(localStorageElem));
      }
      next();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.showFooter === false && localStorage.getItem("path") === null) {
      localStorage.removeItem("path");
      localStorage.removeItem("openDirections");
      vm.backToDetails();
      next(false);
    } else {
      var localStorageElem = JSON.parse(localStorage.getItem("homePageImages"));
      if (localStorageElem != null) {
        var _obj2 = localStorageElem.filteredImagesArr[localStorageElem.swipeIndex];
        if (_obj2 !== undefined) {
          _obj2.isLiked = vm.imageInfo.isLiked;
          _obj2.isCheckedin = vm.imageInfo.isCheckedin;
          _obj2.likes = vm.imageInfo.likes;
          _obj2.checkins = vm.imageInfo.checkins;
          localStorageElem.filteredImagesArr[localStorageElem.swipeIndex] = _obj2;

          localStorage.setItem("homePageImages", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(localStorageElem));
        }
      }
      localStorage.removeItem("openDirections");
      localStorage.removeItem("path");
      next();
    }
  },

  // *********************** /route navigation **********************
  mounted: function mounted() {
    var _this = this;

    vm = this;
    // if (this.platform.toLowerCase() === "safari") {
    //   setInterval(() => {
    //     if (this.animPlay) {
    //       if (this.loaderVal == 100) {
    //         this.reccursiveAnimationCall();
    //         this.loaderVal = 0;
    //       } else {
    //         this.loaderVal += 10;
    //       }
    //     }
    //   }, 3000);
    // }
    setTimeout(function () {
      _this.getDet(_this.$route.params.id);
    }, 1000);
    this.$store.commit("getLocationFinal");

    this.screenW = screen.width;
    this.screenH = screen.height;
    var obj = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(vm.$route.query));
    if (!!obj.inapp) {
      this.showHomeIcon = false;
    } else {
      this.showHomeIcon = true;
    }
  },
  created: function created() {
    var _this2 = this;

    window.addEventListener("blur", function () {
      _this2.videoPlayPauseWindow();
    });
    window.addEventListener("focus", function () {
      _this2.videoPlayPauseWindow();
    });
    var obj = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.$route.query));
    this.filterViewType = obj.viewType ? obj.viewType : "Everything is better";
  },
  beforeDestroy: function beforeDestroy() {
    var _this3 = this;

    window.removeEventListener("blur", function () {
      _this3.videoPlayPauseWindow();
    });
    window.removeEventListener("focus", function () {
      _this3.videoPlayPauseWindow();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapMutations */])(["operationOnPhoto", "getLocation", "snackbar_alert"]), {
    getPageTitle: function getPageTitle() {
      if (this.currentImageData) {
        var caption = this.currentImageData.caption.length > 40 ? this.currentImageData.caption.substring(0, 40) + ".." : this.currentImageData.caption;
        var spot = this.getSpotType(this.currentImageData);
        if (caption.length > 1 && spot !== "Spot") {
          return caption + " | " + spot;
        } else if (caption.length > 1 && spot === "Spot") {
          return caption + " | " + spot;
        } else if (caption.length <= 1 && spot !== "Spot") {
          return "" + spot;
        } else {
          return "Spot with A view";
        }
      } else {
        return "with a view";
      }
    },
    getPageDescription: function getPageDescription() {
      if (this.currentImageData) {
        var spot = this.getSpotType(this.currentImageData);
        var city = this.getCity(this.currentImageData);
        var country = this.currentImageData.aboutLoc.country ? this.currentImageData.aboutLoc.country : "";
        return "Discover this beautiful " + spot + " with a view in " + city + (city === country ? "" : ", " + country) + " , exact location, travel tip and nearby spots";
      }
    },
    getOgTitle: function getOgTitle() {
      var imgTitle = "";
      if (this.currentImageData) {
        if (this.currentImageData.caption.length > 1) {
          if (this.currentImageData.spotType.length !== 1) {
            var st = this.getSpotType(this.currentImageData);
            imgTitle = "Check out this beautiful " + st + " with A view!";
          } else {
            imgTitle = "Check out this beautiful spot with A view";
          }
        } else {
          if (this.currentImageData.spotType.length !== 1) {
            var _st = this.getSpotType(this.currentImageData);
            imgTitle = _st + " with a view";
          } else {
            imgTitle = "Spot with A view";
          }
        }
      } else {
        imgTitle = "Spot with A view";
      }
      return imgTitle;
    },
    getOgDescription: function getOgDescription() {
      if (this.currentImageData) {
        return this.currentImageData.pic_desc;
      } else {
        return "";
      }
    },
    getOgImage: function getOgImage() {
      var imageData = this.currentImageData;
      if (imageData) {
        if (imageData.resourceType === "image") {
          if (imageData.photoId.match("^fse")) {
            var link = this.top_sectionArr[0].photoSourceLink;
            var photoLink = link.replace("original", "width1200");
            return photoLink;
          } else if (!!imageData.propertyLink) {
            if (imageData.photoSourceLink.includes("w=")) {
              var _photoLink = new URL(imageData.photoSourceLink);
              var baseURL = _photoLink.origin;
              var path = _photoLink.pathname;
              _photoLink.searchParams.set("w", 1200);
              var search = _photoLink.search;
              return baseURL + path + search;
            } else {
              return imageData.photoSourceLink;
            }
          } else {
            return "https://res.cloudinary.com/" + __WEBPACK_IMPORTED_MODULE_19__configurations___default.a.cloudinary_cloudName + "/image/upload/w_1200," + cloudinarySettings + ",dpr_auto/" + __WEBPACK_IMPORTED_MODULE_19__configurations___default.a.cloudinary_preset + "/" + imageData.photoId;
          }
        } else {
          return "https://res.cloudinary.com/" + __WEBPACK_IMPORTED_MODULE_19__configurations___default.a.cloudinary_cloudName + "/image/upload/w_1200," + cloudinarySettings + "/" + __WEBPACK_IMPORTED_MODULE_19__configurations___default.a.cloudinary_preset + "/IMG_9689_fkookv_aywwr4";
        }
      } else {
        return "";
      }
    },
    closeSlideShow: function closeSlideShow() {
      this.showSlideShow = false;
    },
    pause: function pause() {
      if (this.player) {
        this.player.pauseVideo();
      }
    },
    playing: function playing() {
      if (this.player) {
        this.player.playVideo();
      }
    },
    videoPlayPause: function videoPlayPause() {
      this.playVideo = !this.playVideo;
      if (this.playVideo) {
        this.playing();
      } else {
        this.pause();
      }
    },
    videoPlayPauseWindow: function videoPlayPauseWindow() {
      this.playVideoWindow = !this.playVideoWindow;
      if (this.playVideoWindow) {
        this.playing();
      } else {
        this.pause();
      }
    },
    ready: function ready(event) {
      this.player = event.target;
    },
    audioClasses: function audioClasses() {
      if (this.muted) {
        return "audio-button-sound-off";
      } else {
        return "audio-button-sound-on";
      }
    },
    getVideoLink: function getVideoLink(videoId, videoLink) {
      var timestamp = "";
      if (videoLink.indexOf("#") !== -1) {
        timestamp = "#" + videoLink.split("#")[1];
      }
      var id = videoId.substring(videoId.indexOf("_") + 1);
      return "https://player.vimeo.com/video/" + id + "?loop=1" + timestamp + "&title=0&byline=0&portrait=0";
    },
    getVideoId: function getVideoId(videoId, videoLink) {
      var id = videoId.substring(videoId.indexOf("_") + 1);
      var parameters = new URL(videoLink).searchParams;
      if (parameters.get("t") !== null || parameters.get("start") !== null) {
        if (parameters.get("t")) {
          this.youtubeVideoParameter["start"] = parameters.get("t");
        } else {
          this.youtubeVideoParameter["start"] = parameters.get("start");
        }
      }
      console.log("Link", id);
      return id;
    },
    getScrollPos: function getScrollPos() {
      var elem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helper_gen__["a" /* ele */])("image-details-container");
      var containerScrollPos = elem.scrollTop;
      if (containerScrollPos > 500) {
        if (containerScrollPos - this.lastScrollPosition < 0) {
          document.getElementById("sticky-search-bar").style.top = "0px";
        } else {
          document.getElementById("sticky-search-bar").style.top = "-100%";
        }
        this.lastScrollPosition = containerScrollPos;
      } else {
        document.getElementById("sticky-search-bar").style.top = "0px";
      }
    },
    newBrowserTab: function newBrowserTab() {
      if (this.screenW > 768) {
        return "_blank";
      } else {
        return "";
      }
    },
    getImageBackground: function getImageBackground(id, screenHeight, screenWidth, photoDetails, hasExtabs) {
      if (id.match("^fse")) {
        var link = photoDetails.photoSourceLink;
        var photoLink = link.replace("original", "height" + (screenHeight * 0.85).toFixed(0));
        return photoLink;
      } else if (!!photoDetails.propertyLink) {
        if (photoDetails.photoSourceLink.includes("h=")) {
          var _photoLink2 = new URL(photoDetails.photoSourceLink);
          var baseURL = _photoLink2.origin;
          var path = _photoLink2.pathname;
          _photoLink2.searchParams.set("h", this.screenH * 0.60);
          var search = _photoLink2.search;
          return baseURL + path + search;
        }
        return photoDetails.photoSourceLink;
      } else {
        if (!!photoDetails.flickrImageLink) {
          if (screenWidth > 1200 && screenWidth < 1600) {
            return photoDetails.flickrImageLink.replace("_o.", "_h.");
          } else if (screenWidth > 1600) {
            return photoDetails.flickrImageLink.replace("_o.", "_k.");
          } else if (screenWidth < 1200 && screenWidth > 800) {
            return photoDetails.flickrImageLink.replace("_o.", "_b.");
          } else if (screenWidth <= 800) {
            return photoDetails.flickrImageLink.replace("_o.", "_c.");
          }
        } else {
          return "https://res.cloudinary.com/" + __WEBPACK_IMPORTED_MODULE_19__configurations___default.a.cloudinary_cloudName + "/image/upload/h_" + (screenHeight * 0.85).toFixed(0) + "," + cloudinarySettings + ",dpr_auto/" + __WEBPACK_IMPORTED_MODULE_19__configurations___default.a.cloudinary_preset + "/" + id;
        }
      }
    },
    top_sectionArr_compute: function top_sectionArr_compute() {
      var arr = [];
      if (this.top_section.pics !== undefined) {
        for (var i in this.top_section.pics) {
          if (i === this.selected_mon) {
            for (var j in this.top_section.pics[i]) {
              if (j === this.selected_dur) {
                for (var k in this.top_section.pics[i][j]) {
                  var _obj3 = this.top_section.pics[i][j][k];
                  _obj3.mon = i;
                  _obj3.dur = j;
                  arr.unshift(_obj3);
                }
              } else {
                for (var _k in this.top_section.pics[i][j]) {
                  var _obj4 = this.top_section.pics[i][j][_k];
                  _obj4.mon = i;
                  _obj4.dur = j;
                  arr.push(_obj4);
                }
              }
            }
          } else {
            for (var _j in this.top_section.pics[i]) {
              for (var _k2 in this.top_section.pics[i][_j]) {
                var _obj5 = this.top_section.pics[i][_j][_k2];
                _obj5.mon = i;
                _obj5.dur = _j;
                arr.push(_obj5);
              }
            }
          }
        }
        // arr = this.top_section.pics[this.selected_mon][this.selected_dur]
      }
      this.current_top_index = 0;
      this.top_sectionArr = arr;
      this.currentImageData = arr[0];
    },
    goToHome: function goToHome() {
      var lsElem = JSON.parse(localStorage.getItem("homePageImages"));
      if (lsElem !== null) {
        if (screen.width < 768) {
          lsElem.isModeSwipe = true;
        } else {
          lsElem.isModeSwipe = false;
        }
        lsElem.swipeIndex = 0;
        localStorage.setItem("homePageImages", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(lsElem));
      }
      if (JSON.parse(localStorage.getItem("fromPath")) !== null) {
        if (JSON.parse(localStorage.getItem("fromPath")).loc !== undefined) {
          this.$router.push("/?loc=" + JSON.parse(localStorage.getItem("fromPath")).loc);
        } else {
          this.$router.push("/?loc=Worldwide");
        }
      } else {
        this.$router.push("/?loc=Worldwide");
      }
    },
    animation: function animation(status) {
      var fl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helper_gen__["a" /* ele */])("f-l");
      var fr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helper_gen__["a" /* ele */])("f-r");
      if (fl != null && fr != null && __WEBPACK_IMPORTED_MODULE_6_platform___default.a !== "safari") {
        fl.style.webkitAnimationPlayState = status;
        fl.style.animationPlayState = status;
        fr.style.webkitAnimationPlayState = status;
        fr.style.animationPlayState = status;
        if (status === "paused") {
          this.animPlay = false;
        } else {
          this.animPlay = true;
        }
      } else {
        if (status === "paused") {
          this.animPlay = false;
        } else {
          this.animPlay = true;
        }
      }
    },
    restartAnim: function restartAnim(action) {
      this.loaderVal = 0;
      if (action === "inc") {
        if (this.current_top_index < this.top_sectionArr.length) {
          if (this.current_top_index < this.top_sectionArr.length - 1) {
            this.current_top_index += 1;
            this.top_index += 1;
          } else {
            this.current_top_index = 0;
            this.top_index = 0;
          }
        }

        var elem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helper_gen__["a" /* ele */])("loader");

        if (elem !== null) {
          elem.style.display = "none";
          setTimeout(function () {
            elem.style.display = "flex";
          }, 1);
        }
      } else {
        if (this.current_top_index >= 0) {
          if (this.current_top_index > 0) {
            this.current_top_index -= 1;
            this.top_index -= 1;
          } else {
            this.current_top_index = this.top_sectionArr.length - 1;
            this.top_index = this.top_sectionArr.length - 1;
          }

          var _elem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helper_gen__["a" /* ele */])("loader");
          if (_elem !== null) {
            _elem.style.display = "none";
            setTimeout(function () {
              _elem.style.display = "flex";
            }, 1);
          }
        }
      }
      // this.selected_mon = this.top_sectionArr[this.current_top_index].mon;
      // this.selected_dur = this.top_sectionArr[this.current_top_index].dur;
    },
    reccursiveAnimationCall: function reccursiveAnimationCall() {
      if (this.top_index < this.top_sectionArr.length - 1) {
        this.top_index++;
      } else {
        this.top_index = 0;
      }
      var elem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helper_gen__["a" /* ele */])("loader");
      if (this.animPlay) {
        if (elem !== null) {
          elem.style.display = "none";
          setTimeout(function () {
            elem.style.display = "flex";
          }, 1);
        }

        var arr = this.top_sectionArr;
        if (this.current_top_index >= arr.length - 1) {
          this.current_top_index = 0;
        } else {
          this.current_top_index += 1;
        }
      }
    },
    getScroll: function getScroll() {
      console.log(this.imageInfo);
      var elem = document.getElementById("nearby");
      if (elem.scrollLeft > elem.scrollWidth - 700 && !this.fetchingNearby) {
        console.log("this.imageInfo", this.imageInfo);
        this.$store.commit("getNearbyPhotos", {
          geohash: this.imageInfo.shareSpotLocation.geohash,
          startAt: this.nearBy.length,
          limit: this.limit,
          photoId: this.imageInfo.photoId,
          isProperty: this.imageInfo.isProperty,
          masterPropertyId: this.imageInfo.masterPropertyId
        });
      }
    },


    // called when distance is available and clicked on the distance
    dummyFunc: function dummyFunc() {
      this.$store.state.common.imageDetParticular = this.imageInfo;
      this.$store.state.common.imageDetParticular.id = this.$route.params.id;
      this.$modal.show("ask-to-add-to-wishlist");
    },


    //
    goToUpload: function goToUpload() {
      //alert(this.$store.state.auth.isLoggedIn)
      if (this.$store.state.auth.isLoggedIn) {
        //alert(`0`)
        this.$router.push("/upload-0");
      } else {
        //alert(`1`)
        this.$router.push("/login");
        this.$store.commit("snackbar_alert", {
          msg: "Please sign in to complete your desired action."
        });
      }
    },


    // set scrollTop position to 0
    goBackToTop: function goBackToTop() {
      var e1 = document.getElementById("back-key");
      e1.scrollIntoView();
    },

    //
    validateUrl: function validateUrl(url) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helper_valUrl__["a" /* isUrl */])(url);
    },

    //
    //
    getDet: function getDet(paramId) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var topImageSection, particularPhotoDetails, vm, res, imageData, ischeckedIn, d1Lon, d1, d2Lon, d2, distance;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //
                topImageSection = null;
                particularPhotoDetails = null;
                vm = _this4;
                res = void 0;

                vm.pageLoader = true;
                if (localStorage.getItem("imgDet_status") !== "comingFromApp") {
                  topImageSection = _this4.$store.dispatch("_top_image_section", {
                    photoId: paramId,
                    uid: vm.user.uid,
                    isLoggedIn: vm.$store.state.auth.isLoggedIn
                  });
                  particularPhotoDetails = _this4.$store.dispatch("getImageDetails", {
                    pid: paramId,
                    uid: vm.user.uid,
                    radius: 10,
                    isLoggedIn: vm.$store.state.auth.isLoggedIn
                  });
                } else {
                  particularPhotoDetails = _this4.$store.dispatch("getImageDetails", {
                    pid: paramId,
                    uid: vm.user.uid,
                    radius: 10,
                    isLoggedIn: vm.$store.state.auth.isLoggedIn
                  });
                  // this.imageInfo = {};
                  // this.imageInfo = res;
                  topImageSection = _this4.$store.dispatch("_top_image_section", {
                    photoId: paramId,
                    uid: vm.user.uid,
                    isLoggedIn: vm.$store.state.auth.isLoggedIn
                  });
                  // this.top_sectionArr_compute();
                }
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([topImageSection, particularPhotoDetails]);

              case 8:
                imageData = _context.sent;

                _this4.top_section = imageData[0];
                _this4.top_sectionArr_compute();
                res = imageData[1];
                _this4.imageInfo = {};
                _this4.imageInfo = res;
                vm.pageLoader = false;

                ischeckedIn = res.isCheckedIn;

                delete _this4.imageInfo["isCheckedIn"];
                _this4.imageInfo.isCheckedin = ischeckedIn;

                // wishlist btn status
                // if (this.imageInfo.isLiked) {
                //   vm.wishlistStatus = `already on your wishlist`;
                // } else {
                //   vm.wishlistStatus = `add to my wishlist`;
                // }
                //
                if (localStorage.getItem("operationOnPhoto") != null) {
                  if (_this4.imageInfo.isLiked === false) {
                    _this4.changeCnt();
                  }
                }

                // checkin btn status
                // if (this.imageInfo.isCheckedin) {
                //   vm.checkInStatus = `you are already checked in here`;
                // } else {
                //   vm.checkInStatus = `check-in`;
                // }

                if (_this4.finalUserLocation !== "" && _this4.finalUserLocation !== undefined && res.hasGeohash !== false) {
                  d1Lon = __WEBPACK_IMPORTED_MODULE_13_geo_hash___default.a.decode(_this4.finalUserLocation);
                  d1 = { latitude: d1Lon.lat, longitude: d1Lon.lon };
                  d2Lon = __WEBPACK_IMPORTED_MODULE_13_geo_hash___default.a.decode(vm.imageInfo.shareSpotLocation.geohash);
                  d2 = { latitude: d2Lon.lat, longitude: d2Lon.lon };
                  distance = __WEBPACK_IMPORTED_MODULE_14_haversine___default()(d1, d2);

                  _this4.imageInfo.distance = distance.toFixed(0) + " km";
                  if (_this4.imageInfo.distance === undefined) {
                    _this4.imageInfo.distance = "NA";
                  }
                } else {
                  if (res.hasGeohash === false) {
                    _this4.imageInfo.distance = "NA";
                  } else {
                    _this4.imageInfo.distance = "-- km";
                  }
                }
                // setTimeout(() => {
                //   this.$store.commit("getMarkerOnCurrentLoc", {
                //     isLocAvailable: this.imageInfo.hasGeohash,
                //     geohash: this.imageInfo.shareSpotLocation.geohash
                //   });
                // }, 100);

                // setTimeout(() => {
                //   if (localStorage.getItem("openDirections") != null) {
                //     if (this.imageInfo.isLiked !== true) {
                //       this.changeCnt();
                //     }
                //   }
                // }, 500);
                _this4.$store.commit("getNearbyPhotos", {
                  geohash: res.shareSpotLocation.geohash,
                  startAt: 0,
                  limit: vm.limit,
                  photoId: res.photoId,
                  isProperty: res.isProperty,
                  masterPropertyId: res.masterPropertyId
                });
                vm.pageLoader = false;

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    getLocationImage: function getLocationImage() {
      if (this.finalUserLocation !== "" && this.finalUserLocation !== undefined && this.imageInfo.shareSpotLocation !== undefined) {
        var d1 = void 0,
            d2 = void 0;
        if (this.imageInfo.shareSpotLocation.geohash !== "") {
          var d = this.finalUserLocation;
          var d1Lon = __WEBPACK_IMPORTED_MODULE_13_geo_hash___default.a.decode(d);
          d1 = { latitude: d1Lon.lat, longitude: d1Lon.lon };
          var d2Lon = __WEBPACK_IMPORTED_MODULE_13_geo_hash___default.a.decode(vm.imageInfo.shareSpotLocation.geohash);
          d2 = { latitude: d2Lon.lat, longitude: d2Lon.lon };
        }

        var distance = __WEBPACK_IMPORTED_MODULE_14_haversine___default()(d1, d2);
        var isM = false;
        if (distance.toFixed(0) === "0") {
          isM = true;
          distance = __WEBPACK_IMPORTED_MODULE_14_haversine___default()(d1, d2, { unit: "meter" });
        }
        this.imageInfo.distance = distance.toFixed(0) + " " + (isM ? " m" : " km");
        this.$forceUpdate();
      } else {
        this.imageInfo.distance = "-- km";
        this.$forceUpdate();
      }
    },
    fadeOpen: function fadeOpen() {
      if (this.isbottomMenuOpen) {
        setTimeout(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helper_gen__["a" /* ele */])("bottom-menu").style.opacity = 1;
        }, 100);
      }
    },
    abc: function abc(anc) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("CALLED IT", anc);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    changeCnt: function changeCnt(obj, imageClick) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _vm, img, status;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("CAlled");

                if (_this6.$store.state.gen.isAPICalling) {
                  _context3.next = 21;
                  break;
                }

                _vm = _this6;

                console.log("comming in");

                if (!_this6.isLoggedIn) {
                  _context3.next = 19;
                  break;
                }

                console.log("coming in");
                img = obj; //this.imageInfo

                if (!(imageClick && img.isLiked === true)) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 17;
                break;

              case 10:
                if (img.isLiked === false) {
                  _vm.wishlistStatus = "added to my wishlist";
                  img.isLiked = true;
                  img.likes++;
                  a;
                } else {
                  _vm.wishlistStatus = "add to my wishlist";
                  img.isLiked = false;
                  img.likes--;
                }
                _this6.$store.commit("UPDATE_IS_API_CALLING", { val: true });
                _context3.next = 14;
                return _vm.$store.dispatch("operationOnPhoto", {
                  pid: obj.photoId === undefined ? obj.id : obj.photoId,
                  uid: _vm.user.uid,
                  operation: "like",
                  uploaderId: obj.mediaSourceInformation.photoGrapherId,
                  action: img.isLiked ? "add" : "remove"
                });

              case 14:
                status = _context3.sent;

                _this6.$store.commit("UPDATE_IS_API_CALLING", { val: false });
                _this6.updateLS(img);

              case 17:
                _context3.next = 21;
                break;

              case 19:
                _this6.$store.commit("snackbar_alert", {
                  msg: " Please sign in to complete your desired action."
                });
                _this6.$router.push("/login");

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    updateLS: function updateLS(img) {
      var localStorageElem = JSON.parse(localStorage.getItem("homePageImages"));
      if (localStorageElem != null) {
        for (var i in localStorageElem.filteredImagesArr) {
          if (localStorageElem.filteredImagesArr[i].id = vm.$route.params.id) {
            // let obj = localStorageElem.filteredImagesArr[i]
            localStorageElem.filteredImagesArr[i].likes = img.likes;
            localStorageElem.filteredImagesArr[i].isLiked = img.isLiked;
            localStorageElem.filteredImagesArr[i].checkins = img.checkins;
            localStorageElem.filteredImagesArr[i].isCheckedin = img.isCheckedin;
            localStorage.setItem("homePageImages", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(localStorageElem));
            break;
          }
        }
      }
    },
    changeCntCheckin: function changeCntCheckin(obj) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _vm2, img, status;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this7.$store.state.gen.isAPICalling) {
                  _context4.next = 15;
                  break;
                }

                _vm2 = _this7;

                if (!_this7.isLoggedIn) {
                  _context4.next = 13;
                  break;
                }

                img = obj; // this.imageInfo

                if (img.isCheckedin === false) {
                  _vm2.checkInStatus = "you are checked in";
                  img.isCheckedin = true;
                  img.checkins++;
                } else {
                  _vm2.checkInStatus = "check-in";
                  img.isCheckedin = false;
                  img.checkins--;
                }
                _this7.$store.commit("UPDATE_IS_API_CALLING", { val: true });
                _context4.next = 8;
                return _vm2.$store.dispatch("operationOnPhoto", {
                  pid: obj.photoId,
                  uid: _vm2.user.uid,
                  operation: "checkin",
                  uploaderId: img.mediaSourceInformation.photoGrapherId,
                  action: img.isCheckedin ? "add" : "remove"
                });

              case 8:
                status = _context4.sent;

                _this7.$store.commit("UPDATE_IS_API_CALLING", { val: false });

                _this7.updateLS(img);
                _context4.next = 15;
                break;

              case 13:
                _this7.$store.commit("snackbar_alert", {
                  msg: "Please sign in to complete your desired action."
                });
                _this7.$router.push("/login");

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    easeOut: function easeOut(time) {
      setTimeout(function () {
        var currentScrollPosition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helper_gen__["a" /* ele */])("image-container").scrollLeft;
        var upperLimit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helper_gen__["a" /* ele */])("image-main").clientWidth - vm.screenW;
        var lowerLimit = 0;
        var scrollWidth = upperLimit / 2;
        if (currentScrollPosition >= upperLimit - 10 || currentScrollPosition <= lowerLimit + 10) {
          TweenMax.to("#image-container", 1, {
            scrollLeft: scrollWidth,
            ease: Bounce.easeOut
          });
        }
      }, time);
    },
    getDirectionLink: function getDirectionLink() {
      var coord = __WEBPACK_IMPORTED_MODULE_13_geo_hash___default.a.decode(vm.imageInfo.shareSpotLocation.geohash);
      return "https://www.google.com/maps/dir//" + coord.lat + "," + coord.lon + "/";
    },
    getGoogleEarthLink: function getGoogleEarthLink() {
      var coord = __WEBPACK_IMPORTED_MODULE_13_geo_hash___default.a.decode(vm.imageInfo.shareSpotLocation.geohash);
      return "https://earth.google.com/web/search/" + coord.lat + "," + coord.lon + "/";
    },
    backToDetails: function backToDetails() {
      var pathFromLS = localStorage.getItem("path");
      if (pathFromLS === null) {} else {
        this.$router.push(pathFromLS);
      }
    },
    getSpotType: function getSpotType(filterArr) {
      var defaultSpotType = "Spot";
      if (filterArr != undefined) {
        if (filterArr.spotType.length == 0) {
          return defaultSpotType;
        } else {
          if (filterArr.spotType.length == 1 && filterArr.spotType[0] == "all") {
            return defaultSpotType;
          } else {
            var priorityList = ["rooftop bar", "bar", "airbnb", "apartment", "hotel room", "room", "hotel", "infinity pool", "pool", "restaurant", "cafe"];
            var spotType = defaultSpotType;
            var i = void 0;
            for (i = 0; i < priorityList.length; i++) {
              if (filterArr.spotType.includes(priorityList[i])) {
                spotType = priorityList[i];
                break;
              }
            }
            return this.getCapitalizedString(spotType);
          }
        }
      } else {
        return defaultSpotType;
      }
    },
    getCapitalizedString: function getCapitalizedString(str) {
      var capitalizedString = str.charAt(0).toUpperCase() + str.slice(1);
      return capitalizedString;
    },
    getCity: function getCity(filterArr) {
      if (filterArr != undefined) {
        var city_or_country = "Spot";
        if (filterArr.aboutLoc != undefined) {
          if (filterArr.aboutLoc.city != undefined) {
            city_or_country = filterArr.aboutLoc.city + ", " + filterArr.aboutLoc.country;
          } else if (filterArr.aboutLoc.state != undefined) {
            city_or_country = filterArr.aboutLoc.state + ", " + filterArr.aboutLoc.country;
          } else if (filterArr.aboutLoc.subLocality != undefined) {
            city_or_country = filterArr.aboutLoc.subLocality + ", " + filterArr.aboutLoc.country;
          } else if (filterArr.aboutLoc.region != undefined) {
            city_or_country = filterArr.aboutLoc.region + ", " + filterArr.aboutLoc.country;
          } else {
            city_or_country = filterArr.aboutLoc.country;
          }
        }
        return this.getCapitalizedString(city_or_country);
      } else {
        return "";
      }
      return obj;
    }
  })
});

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      quotes: [{
        author: "Lao Tzu",
        text: "A good traveler has no fixed plans, and is not intent on arriving."
      }, {
        author: "Michael Bassey Johnson",
        text: "A good traveler is one who knows how to travel with the mind."
      }, {
        author: "Tim Cahill",
        text: "A journey is best measured in friends rather than miles."
      }, {
        author: "John Steinbeck",
        text: "A journey is like marriage. The certain way to be wrong is to think you control it."
      }, {
        author: "Lao Tzu",
        text: "A journey of a thousand miles begins with a single step."
      }, {
        author: "John A. Shedd",
        text: "A ship in a harbor is safe, but it not what ships are built for."
      }, {
        author: "Aesop",
        text: "Adventure is worthwhile."
      }, {
        author: "Unknown",
        text: "Adventure may hurt you but monotony will kill you."
      }, {
        author: "Martin Buber",
        text: "All journeys have secret destinations of which the traveler is unaware."
      }, {
        author: "JRR Tolkien",
        text: "All that is gold does not glitter; just as not all those who wander are lost."
      }, {
        author: "Wolf, an Appalachian Trail Hiker",
        text: "All you need to know is that it’s possible."
      }, {
        author: "Unknown",
        text: "Better to see something once than hear about it a thousand times."
      }, {
        author: "Lovelle Drachman",
        text: "Blessed are the curious for they shall have adventures."
      }, {
        author: "Unknown",
        text: "Collect Moment, Not Things."
      }, {
        author: "Unknown",
        text: "Dare to live the life you’ve always wanted."
      }, {
        author: "Ralph Waldo Emerson",
        text: "Do not follow where the path may lead. Go instead where there is no path and leave a trail."
      }, {
        author: "Shane L. Koyczan",
        text: "Don’t let your luggage define your travels, each life unravels differently."
      }, {
        author: "Unknown",
        text: "Don’t listen to what they say. Go see."
      }, {
        author: "Mohammed",
        text: "Don’t tell me how educated you are, tell me how much you have traveled."
      }, {
        author: "Ma Jian",
        text: "Everything I was I carry with me, everything I will be lies waiting on the road ahead."
      }, {
        author: "Unknown",
        text: "Go, fly, roam, travel, voyage, explore, journey, discover, adventure."
      }, {
        author: "William Blake",
        text: "Great things are done when men and mountains meet."
      }, {
        author: "Mary Anne Radmacher",
        text: "I am not the same having seen the moon shine on the other side of the world."
      }, {
        author: "Paulo Coelho",
        text: "I can speak to my soul only when the two of us are off exploring deserts or cities or mountains or roads."
      }, {
        author: "Mark Twain",
        text: "I have found out that there ain’t no surer way to find out whether you like people or hate them than to travel with them."
      }, {
        author: "Susan Sontag",
        text: "I haven’t been everywhere, but it’s on my list."
      }, {
        author: "Derek Walcott",
        text: "I read; I travel; I become."
      }, {
        author: "Thomas Jefferson",
        text: "I think one travels more usefully when they travel alone because they reflect more."
      }, {
        author: "Caskie Stinnett",
        text: "I travel a lot; I hate having my life disrupted by routine."
      }, {
        author: "Carew Papritz",
        text: "I travel because it makes me realize how much I haven’t seen, how much I’m not going to see, and how much I still need to see."
      }, {
        author: "Roman Payne",
        text: "I wandered everywhere, through cities and countries wide. And everywhere I went, the world was on my side."
      }, {
        author: "A. Redmerski",
        text: "I wonder if the ocean smells different on the other side of the world."
      }, {
        author: "John Green",
        text: "I’m in love with cities I’ve never been to and people I’ve never met."
      }, {
        author: "Santosh Kalwar",
        text: "If life is a journey then let my soul travel and share your pain."
      }, {
        author: "James Michener",
        text: "If you reject the food, ignore the customs, fear the religion and avoid the people, you might better stay at home."
      }, {
        author: "Paul Coelho",
        text: "If you think adventures are dangerous, try routine: It’s Lethal."
      }, {
        author: "Unknown",
        text: "In the end, we only regret the chances we didn’t take."
      }, {
        author: "Unknown",
        text: "It feels good to be lost in the right direction."
      }, {
        author: "Ursula K. Le Guin",
        text: "It is good to have an end to journey toward, but it is the journey that matters in the end."
      }, {
        author: "Henry David Thoreau",
        text: "It’s not what you look at that matters. It’s what you see."
      }, {
        author: "Helen Keller",
        text: "Life is either a daring adventure or nothing at all."
      }, {
        author: "Unknown",
        text: "Life is short and the world is wide."
      }, {
        author: "Benjamin Disraeli",
        text: "Like all great travelers, I have seen more than I remember, and remember more than I have seen."
      }, {
        author: "Oscar Wilde",
        text: "Live life with no excuses, travel with no regret."
      }, {
        author: "Stephen Covey",
        text: "Live your life by a compass not a clock."
      }, {
        author: "Tennessee Williams",
        text: "Make voyages. Attempt them. There’s nothing else."
      }, {
        author: "Andre Gide",
        text: "Man cannot discover new oceans unless he has the courage to lose sight of the shore."
      }, {
        author: "Jodi Picoult",
        text: "Maybe you had to leave in order to miss a place; maybe you had to travel to figure out how beloved your starting point was."
      }, {
        author: "Roman Payne",
        text: "Never did the world make a queen of a girl who hides in houses and dreams without traveling."
      }, {
        author: "Amin Maalouf",
        text: "Never hesitate to go far away, beyond all seas, all frontiers, all countries, all beliefs."
      }, {
        author: "Banana Yoshimoto",
        text: "No matter where you are, you’re always a bit on your own, always an outsider."
      }, {
        author: "Lin Yutang",
        text: "No one realizes how beautiful it is to travel until he comes home and rests his head on his old, familiar pillow."
      }, {
        author: "J.R.R. Tolkien",
        text: "Not all those who wander are lost."
      }, {
        author: "Unknown",
        text: "Oh Darling, Let’s Be Adventurers."
      }, {
        author: "Dr. Seuss",
        text: "Oh the places you’ll go."
      }, {
        author: "Dalai Lama",
        text: "Once a year, go someplace you’ve never been before."
      }, {
        author: "Michael Palin",
        text: "Once the travel bug bites there is no known antidote, and I know that I shall be happily infected until the end of my life."
      }, {
        author: "Henry Miller",
        text: "One’s destination is never a place, but a new way of seeing things."
      }, {
        author: "John Steinbeck",
        text: "People don’t take trips, trips take people."
      }, {
        author: "Unknown",
        text: "Quit your job, buy a ticket, get a tan, fall in love, never return."
      }, {
        author: "Roy M. Goodman",
        text: "Remember that happiness is a way of travel – not a destination."
      }, {
        author: "Jack Kerouac",
        text: "So shut up, live, travel, adventure, bless and don’t be sorry."
      }, {
        author: "Erol Ozan",
        text: "Some beautiful paths can’t be discovered without getting lost."
      }, {
        author: "Chief Seattle",
        text: "Take only memories, leave only footprints."
      }, {
        author: "Agnes Repplier",
        text: "The impulse to travel is one of the hopeful symptoms of life."
      }, {
        author: "Dan Eldon",
        text: "The journey is the destination."
      }, {
        author: "T.S. Eliot",
        text: "The journey not the arrival matters."
      }, {
        author: "Anna Quindlen",
        text: "The life you have led doesn’t need to be the only life you have."
      }, {
        author: "Henry David Thoreau",
        text: "The man who goes alone can start today, but he who travels with another must wait till that other is ready."
      }, {
        author: "Wallace Stevens",
        text: "The most beautiful in the world is, of course, the world itself."
      }, {
        author: "G.K. Chesterton",
        text: "The traveler sees what he sees. The tourist sees what he has come to see."
      }, {
        author: "Augustine of Hippo",
        text: "The world is a book and those who do not travel read only one page."
      }, {
        author: "Ralph Waldo Emerson",
        text: "The world makes way for the man who knows where he is going."
      }, {
        author: "Robert Louis Stevenson",
        text: "There are no foreign lands. It is the traveler only who is foreign."
      }, {
        author: "Paulo Coelho",
        text: "This wasn’t a strange place; it was a new one."
      }, {
        author: "Ralph Waldo Emerson",
        text: "Though we travel the world over to find the beautiful, we must carry it with us, or we find it not."
      }, {
        author: "Freya Stark",
        text: "To awaken quite alone in a strange town is one of the pleasantest sensations in the world."
      }, {
        author: "Aldous Huxley",
        text: "To travel is to discover that everyone is wrong about other countries."
      }, {
        author: "Hans Christian Andersen",
        text: "To travel is to live."
      }, {
        author: "Elizabeth Gilbert",
        text: "To travel is worth any cost or sacrifice."
      }, {
        author: "Alex Garland",
        text: "Tourists went on holidays while travelers did something else. They traveled."
      }, {
        author: "Jalaluddin Rumi",
        text: "Travel brings power and love back into your life."
      }, {
        author: "Joe Abercrombie",
        text: "Travel brings wisdom only to the wise. It renders the ignorant more ignorant than ever."
      }, {
        author: "Marty Rubin",
        text: "Travel doesn’t become adventure until you leave yourself behind."
      }, {
        author: "Claire Fontaine",
        text: "Travel empties out everything you’ve into the box called your life, all the things you accumulate to tell you who you are."
      }, {
        author: "David Mitchell",
        text: "Travel far enough, you meet yourself."
      }, {
        author: "Mark Twain",
        text: "Travel is fatal to prejudice, bigotry, and narrow-mindedness."
      }, {
        author: "Miriam Beard",
        text: "Travel is more than the seeing of sights; it is a change that goes on, deep and permanent, in the ideas of living."
      }, {
        author: "Unknown",
        text: "Travel is the only thing you buy that makes you richer."
      }, {
        author: "Thomas Fuller",
        text: "Travel makes a wise man better, and a fool worse."
      }, {
        author: "Gustave Flaubert",
        text: "Travel makes one modest. You see what a tiny place you occupy in the world"
      }, {
        author: "Ibn Battuta",
        text: "Traveling – it leaves you speechless, then turns you into a storyteller."
      }, {
        author: "Gayle Foreman",
        text: "Traveling’s not something you’re good at. It’s something you do. Like Breathing."
      }, {
        author: "Robert Frost",
        text: "Two roads diverged in a wood and I – I took the one less traveled by, and that has made all the difference."
      }, {
        author: "Ray Bradbury",
        text: "We travel for romance, we travel for architecture, and we travel to be lost."
      }, {
        author: "Anonymous",
        text: "We travel not to escape life, but for life not to escape us."
      }, {
        author: "Anais Nin",
        text: "We travel, some of us forever, to seek other states, other lives, other souls."
      }, {
        author: "Hilaire Belloc",
        text: "We wander for distraction but we travel for fulfillment."
      }, {
        author: "Jack Kerouac",
        text: "We wandered in a frenzy and a dream."
      }, {
        author: "Clifton Fadiman",
        text: "When you travel, remember that a foreign country is not designed to make you comfortable. It is designed to make its own people comfortable."
      }, {
        author: "Vera Nazarian",
        text: "Whenever you go on a trip to visit foreign lands or distant places, remember that they are all someone’s home and backyard."
      }, {
        author: "Anita Desai",
        text: "Wherever you go becomes a part of you somehow."
      }, {
        author: "Neil Gaiman",
        text: "Wherever you go, you take yourself with you."
      }, {
        author: "Frank Herbert",
        text: "Without new experiences, something inside of us sleeps. The sleeper must awaken."
      }, {
        author: "Unknown",
        text: "Work, Travel, Save, Repeat."
      }, {
        author: "Kirsten Hubbard",
        text: "You can’t control the past, but you can control where you go next."
      }, {
        author: "George Bernard Shaw",
        text: "I dislike feeling at home when I am abroad."
      }, {
        author: "Henry David Thoreau",
        text: "Not until we are lost do we begin to understand ourselves."
      }, {
        author: "Mohamed",
        text: "Don’t tell me how educated you are, tell me how much you travelled."
      }, {
        author: "Kurt Vonnegut",
        text: "Bizarre travel plans are dancing lessons from God."
      }, {
        author: "Martin Buber",
        text: "All journeys have secret destinations of which the traveller is unaware."
      }, {
        author: "Paul Theroux",
        text: "Tourists don’t know where they’ve been, travellers don’t know where they’re going."
      }, {
        author: "Robert Louis Stevenson",
        text: "There are no foreign lands. It is the traveller only who is foreign."
      }, {
        author: "Albert Einstein",
        text: "I love to travel, but hate to arrive."
      }, {
        author: "Hilaire Belloc",
        text: "We wander for distraction, but we travel for fulfillment."
      }, {
        author: "Benjamin Disraeli",
        text: "Travel teaches toleration."
      }, {
        author: "Ray Bradbury",
        text: "Half of the fun of travel is the aesthetic of lostness."
      }, {
        author: "Ben Francia",
        text: "Great things never came from comfort zones."
      }, {
        author: "Maya Angelou",
        text: "If you are always trying to be normal, you will never know how amazing you can be."
      }, {
        author: "Unknown",
        text: "Fear is only temporary. Regrets last forever."
      }, {
        author: "Neale Donald Walsch",
        text: "Life begins at the end of your comfort zone."
      }, {
        author: "David McCullough Jr.",
        text: "Climb the mountain so you can see the world, not so the world can see you."
      }, {
        author: "Alexander Sattler",
        text: "I would rather own a little and see the world than own the world and see a little of it."
      }, {
        author: "William Langewiesche",
        text: "So much of who we are is where we have been."
      }, {
        author: "Paulo Coelho",
        text: "Travel is never a matter of money but of courage."
      }, {
        author: "Shakespeare",
        text: "The earth has music for those who listen."
      }, {
        author: "Unknown",
        text: "Do more things that make you forget to check your phone."
      }, {
        author: "Carew Papritz",
        text: "I travel because I become uncomfortable being too comfortable."
      }, {
        author: "Peter McWilliams",
        text: "Nothing adventured, nothing attained."
      }, {
        author: "Seth Godin",
        text: "If it scares you, it might be a good thing to try."
      }, {
        author: "Franklin D. Roosevelt",
        text: "Above all, try something."
      }, {
        author: "Unknown",
        text: "Good things come to those who book flights."
      }, {
        author: "Edith Wharton",
        text: "One of the great things about travel is that you find out how many good, kind people there are."
      }, {
        author: "Unknown",
        text: "If you look like your passport photo, you probably need the trip."
      }, {
        author: "Rachel Wolchin",
        text: "If we were meant to stay in one place, we’d have roots instead of feet."
      }, {
        author: "Unknown",
        text: "My favourite thing is to go where I’ve never been."
      }, {
        author: "Unknown",
        text: "It’s bad manners to keep an adventure waiting."
      }, {
        author: "Ray Bradbury",
        text: "We travel for romance, we travel for architecture, we travel to be lost."
      }, {
        author: "Ernest Hemingway",
        text: "Never go on trips with anyone you do not love."
      }, {
        author: "Unknown",
        text: "Some things weren’t meant to be tamed. For example, YOU."
      }, {
        author: "Ben Franklin",
        text: "Either write something worth reading or do something worth writing."
      }, {
        author: "John Steinbeck",
        text: "I wonder how many people I’ve looked at all my life and never seen."
      }, {
        author: "Unknown",
        text: "May you never be too busy to stop and breathe under a palm tree."
      }, {
        author: "Unknown",
        text: "Don’t quit your daydream."
      }, {
        author: "Ernest Hemingway",
        text: "The best way to find out if you can trust somebody is to trust them."
      }, {
        author: "Winston Churchill",
        text: "I like things to happen. And if they don’t happen, I like to make them happen."
      }, {
        author: "Unknown",
        text: "Surround yourself with people who get it."
      }, {
        author: "Terry Pratchett",
        text: "Coming back to where you started is not the same as not leaving."
      }, {
        author: "Paul Theroux",
        text: "Travel is glamorous only in retrospect."
      }, {
        author: "Aerin Lauder",
        text: "To understand what’s going on in the world, you have to see the world."
      }, {
        author: "Ugo Eze",
        text: "Be careful who you make memories with. Those things can last a lifetime."
      }, {
        author: "Walt Whitman",
        text: "Not I, not anyone else, can travel that road for you. You must travel it for yourself."
      }, {
        author: "Shanti",
        text: "At the end of the day, your feet should be dirty, your hair should be messy and your eyes sparkling."
      }, {
        author: "Your Passport",
        text: "You’ll never know until you go."
      }, {
        author: "Unknown",
        text: "Travelling is about finding those things that you never knew you were looking for."
      }]
    };
  },

  methods: {
    getQuotes: function getQuotes() {
      var x = Math.floor(Math.random() * this.quotes.length);
      this.currentQuote = this.quotes[x];
    }
  }
});

/***/ }),

/***/ 653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isMobileSafari; });
var isMobileSafari = function identifySafariMobile() {
  var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if (isSafari && iOS) {
    //alert(true)
    return true;
  } else {
    // alert(false)
    return false;
  }
};

/***/ }),

/***/ 654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isUrl; });
var isUrl = function isUrl(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?' + // port
  '(\\/[-a-z\\d%@_.~+&:]*)*' + // path
  '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' + // query string
  '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return pattern.test(str);
};

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".close-btn[data-v-045f387e]{width:33.33%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.slideShowContainer[data-v-045f387e]{background:#000;position:fixed;height:100vh;width:100vw;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;z-index:1800}.header[data-v-045f387e]{color:#fff;padding:10px 30px;margin-bottom:30px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.header[data-v-045f387e],.slider-item-container[data-v-045f387e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.slider-item-container[data-v-045f387e]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.slider-item[data-v-045f387e]{overflow:hidden}.v-responsive__content[data-v-045f387e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.slide-image[data-v-045f387e]{max-width:1280px;max-height:600px}@media screen and (max-width:1280px){.slide-image[data-v-045f387e]{max-width:100%;max-height:600px}}@media screen and (min-width:1720px){.slide-image[data-v-045f387e]{max-width:1600px;max-height:700px}}@media screen and (max-width:768px){.slide-image[data-v-045f387e]{max-width:100%;max-height:400px}}.carousel-container[data-v-045f387e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.photo-description[data-v-045f387e]{font-family:Montserrat;font-size:24px;font-weight:600;line-height:1.2;color:#b9b9b9;margin-bottom:40px}.photo-description .photo-caption[data-v-045f387e]{display:block}@media screen and (max-width:768px){.photo-description .photo-caption[data-v-045f387e]{display:none}}.photographer-profile-det-container[data-v-045f387e]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:12px;-ms-flex-wrap:nowrap;flex-wrap:nowrap;font-size:14px}@media only screen and (max-width:768px){.photographer-profile-det-container[data-v-045f387e]{height:auto;-ms-flex-wrap:wrap;flex-wrap:wrap}}.photographer-profile-det-container img[data-v-045f387e]{height:1.5em;width:1.5em;-o-object-fit:cover;object-fit:cover;border-radius:100%}.photographer-profile-det-container .no-profile-image[data-v-045f387e]{width:1.5em;height:1.5em;border-radius:100%;background:#fff;font-size:20px;color:#000;text-align:center;line-height:1.5em;font-weight:700}.photographer-profile-det-container .name-container[data-v-045f387e]{margin:auto .8em auto 0;font-size:.9em;text-transform:capitalize;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-weight:500}@media only screen and (max-width:768px){.photographer-profile-det-container .name-container[data-v-045f387e]{font-size:.6875em}}.photographer-profile-det-container .photographer-profile-user[data-v-045f387e]{width:33.33333vw;color:#fff}.photographer-profile-det-container .photographer-profile-user img[data-v-045f387e]{margin-right:.8em}@media only screen and (max-width:768px){.photographer-profile-det-container .photographer-profile-user[data-v-045f387e]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}.photographer-profile-det-container .photographer-profile[data-v-045f387e]{color:#9b9b9b}@media only screen and (max-width:768px){.photographer-profile-det-container .photographer-profile[data-v-045f387e]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}.like-share-container[data-v-045f387e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;width:33.33%}.like-share-container .icon-container[data-v-045f387e]{color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.like-share-container .icon-container i[data-v-045f387e]{font-size:30px}.like-share-container .icon-container .share-icon[data-v-045f387e]{height:30px;width:30px}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/common/slideshow.vue"],"names":[],"mappings":"AACA,4BACE,aAAc,AACd,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,qCACE,gBAAkB,AAClB,eAAgB,AAChB,aAAc,AACd,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,YAAc,CACf,AACD,yBACE,WAAa,AACb,kBAA6B,AAO7B,mBAAoB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CACxC,AACD,iEAXE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAgB7B,AAVD,wCAIE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAIjC,AACD,8BACE,eAAiB,CAClB,AACD,wCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,8BACE,iBAAkB,AAClB,gBAAkB,CACnB,AACD,qCACA,8BACI,eAAgB,AAChB,gBAAkB,CACrB,CACA,AACD,qCACA,8BACI,iBAAkB,AAClB,gBAAkB,CACrB,CACA,AACD,oCACA,8BACI,eAAgB,AAChB,gBAAkB,CACrB,CACA,AACD,qCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CACtB,AACD,oCACE,uBAAwB,AACxB,eAAgB,AAChB,gBAAiB,AACjB,gBAAiB,AACjB,cAAe,AACf,kBAAoB,CACrB,AACD,mDACI,aAAe,CAClB,AACD,oCACA,mDACM,YAAc,CACnB,CACA,AACD,qDACE,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,mBAAoB,AACpB,qBAAsB,AAClB,iBAAkB,AACtB,cAAgB,CACjB,AACD,yCACA,qDACM,YAAa,AACb,mBAAoB,AAChB,cAAgB,CACzB,CACA,AACD,yDACI,aAAc,AACd,YAAa,AACb,oBAAqB,AAClB,iBAAkB,AACrB,kBAAoB,CACvB,AACD,uEACI,YAAa,AACb,aAAc,AACd,mBAAoB,AACpB,gBAAoB,AACpB,eAAgB,AAChB,WAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,eAAkB,CACrB,AACD,qEACI,wBAA4B,AAC5B,eAAiB,AACjB,0BAA2B,AAC3B,4IAA+J,AAC/J,eAAiB,CACpB,AACD,yCACA,qEACQ,iBAAoB,CAC3B,CACA,AACD,gFACI,iBAAuB,AACvB,UAAe,CAClB,AACD,oFACM,iBAAoB,CACzB,AACD,yCACA,gFACQ,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAC5B,CACA,AACD,2EACI,aAAe,CAClB,AACD,yCACA,2EACQ,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACvC,CACA,AACD,uCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,YAAc,CACf,AACD,uDACI,WAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,yDACM,cAAgB,CACrB,AACD,mEACM,YAAa,AACb,UAAY,CACjB","file":"slideshow.vue","sourcesContent":["\n.close-btn[data-v-045f387e] {\n  width: 33.33%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.slideShowContainer[data-v-045f387e] {\n  background: black;\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  z-index: 1800;\n}\n.header[data-v-045f387e] {\n  color: white;\n  padding: 10px 30px 10px 30px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 30px;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.slider-item-container[data-v-045f387e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.slider-item[data-v-045f387e] {\n  overflow: hidden;\n}\n.v-responsive__content[data-v-045f387e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.slide-image[data-v-045f387e] {\n  max-width: 1280px;\n  max-height: 600px;\n}\n@media screen and (max-width: 1280px) {\n.slide-image[data-v-045f387e] {\n    max-width: 100%;\n    max-height: 600px;\n}\n}\n@media screen and (min-width: 1720px) {\n.slide-image[data-v-045f387e] {\n    max-width: 1600px;\n    max-height: 700px;\n}\n}\n@media screen and (max-width: 768px) {\n.slide-image[data-v-045f387e] {\n    max-width: 100%;\n    max-height: 400px;\n}\n}\n.carousel-container[data-v-045f387e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n.photo-description[data-v-045f387e] {\n  font-family: Montserrat;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 1.2;\n  color: #b9b9b9;\n  margin-bottom: 40px;\n}\n.photo-description .photo-caption[data-v-045f387e] {\n    display: block;\n}\n@media screen and (max-width: 768px) {\n.photo-description .photo-caption[data-v-045f387e] {\n      display: none;\n}\n}\n.photographer-profile-det-container[data-v-045f387e] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-bottom: 12px;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  font-size: 14px;\n}\n@media only screen and (max-width: 768px) {\n.photographer-profile-det-container[data-v-045f387e] {\n      height: auto;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n}\n}\n.photographer-profile-det-container img[data-v-045f387e] {\n    height: 1.5em;\n    width: 1.5em;\n    -o-object-fit: cover;\n       object-fit: cover;\n    border-radius: 100%;\n}\n.photographer-profile-det-container .no-profile-image[data-v-045f387e] {\n    width: 1.5em;\n    height: 1.5em;\n    border-radius: 100%;\n    background: #ffffff;\n    font-size: 20px;\n    color: black;\n    text-align: center;\n    line-height: 1.5em;\n    font-weight: bold;\n}\n.photographer-profile-det-container .name-container[data-v-045f387e] {\n    margin: auto 0.8em auto 0px;\n    font-size: 0.9em;\n    text-transform: capitalize;\n    font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n    font-weight: 500;\n}\n@media only screen and (max-width: 768px) {\n.photographer-profile-det-container .name-container[data-v-045f387e] {\n        font-size: 0.6875em;\n}\n}\n.photographer-profile-det-container .photographer-profile-user[data-v-045f387e] {\n    width: calc(100vw / 3);\n    color: #ffffff;\n}\n.photographer-profile-det-container .photographer-profile-user img[data-v-045f387e] {\n      margin-right: 0.8em;\n}\n@media only screen and (max-width: 768px) {\n.photographer-profile-det-container .photographer-profile-user[data-v-045f387e] {\n        -webkit-box-flex: 1;\n            -ms-flex-positive: 1;\n                flex-grow: 1;\n}\n}\n.photographer-profile-det-container .photographer-profile[data-v-045f387e] {\n    color: #9b9b9b;\n}\n@media only screen and (max-width: 768px) {\n.photographer-profile-det-container .photographer-profile[data-v-045f387e] {\n        -webkit-box-flex: 1;\n            -ms-flex-positive: 1;\n                flex-grow: 1;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n}\n}\n.like-share-container[data-v-045f387e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: 33.33%;\n}\n.like-share-container .icon-container[data-v-045f387e] {\n    color: white;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.like-share-container .icon-container i[data-v-045f387e] {\n      font-size: 30px;\n}\n.like-share-container .icon-container .share-icon[data-v-045f387e] {\n      height: 30px;\n      width: 30px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".padding-right[data-v-33f88de8]{padding-right:10px}.fullscreen[data-v-33f88de8]{overflow-x:scroll;overflow-y:hidden}.no-padding[data-v-33f88de8]{padding:0}.logo-loader[data-v-33f88de8]{position:absolute;top:50%;left:48%}.video-container[data-v-33f88de8]{height:100%;width:auto}.feedback-speech-bubble[data-v-33f88de8]{margin-left:10px}.v-lazy-image[data-v-33f88de8]{-webkit-filter:blur(5px);filter:blur(5px);-webkit-transition:-webkit-filter .7s;transition:-webkit-filter .7s;transition:filter .7s;transition:filter .7s,-webkit-filter .7s}.v-lazy-image-loaded[data-v-33f88de8]{-webkit-filter:blur(0);filter:blur(0)}pre[data-v-33f88de8]{font-family:MontSerrat-Regular!important}.video-player-youtube[data-v-33f88de8]{position:relative;height:100%;width:100%;pointer-events:none!important}.logo-color[data-v-33f88de8]{color:#bd10e0;font-weight:bolder}.image-details-container[data-v-33f88de8]{position:fixed;left:0;right:0;z-index:100;height:100vh;background-color:transparent;overflow-y:scroll;-webkit-overflow-scrolling:touch}.image-details-container .top-section[data-v-33f88de8]{padding:0}.image-details-container .top-section .profile-detail .uploader-profile[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:.929em;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.image-details-container .top-section .profile-detail .uploader-profile .name[data-v-33f88de8]{margin-left:1em;margin-right:6px}.image-details-container .top-section .profile-detail .uploader-profile .pic[data-v-33f88de8]{height:1.714em;width:1.714em;-o-object-fit:cover;object-fit:cover;border-radius:100%;margin-bottom:2px}.image-details-container .nearby-images[data-v-33f88de8]{position:relative;padding-left:20px;padding-bottom:5em;margin-top:1.2em!important;color:hsla(0,0%,100%,.8)}@media screen and (min-width:1920px){.image-details-container .nearby-images[data-v-33f88de8]{font-size:1.6em!important}}@media screen and (max-width:1920px) and (min-width:1536px){.image-details-container .nearby-images[data-v-33f88de8]{font-size:calc(1.6em - 15%)!important}}@media screen and (max-width:1536px) and (min-width:1440px){.image-details-container .nearby-images[data-v-33f88de8]{font-size:calc(1.6em - 20%)!important}}@media screen and (max-width:1440px) and (min-width:768px){.image-details-container .nearby-images[data-v-33f88de8]{font-size:calc(1.6em - 25%)!important}}@media screen and (max-width:1440px){.image-details-container .nearby-images[data-v-33f88de8]{font-size:calc(1.6em - 25%)!important}}.image-details-container .nearby-images .scrollmenu[data-v-33f88de8]{width:100%;white-space:nowrap;overflow-x:scroll;overflow-y:hidden;-webkit-transform:translateZ(0)}.image-details-container .nearby-images .a-tag[data-v-33f88de8]{padding:14px 0;display:inline-block}.image-details-container .nearby-images .a-tag img[data-v-33f88de8]{-o-object-fit:cover;object-fit:cover;border-radius:15px;height:392px;width:259px}.footer[data-v-33f88de8]{background:-webkit-gradient(linear,left top,left bottom,from(transparent),color-stop(62%,rgba(0,0,0,.61)));background:linear-gradient(-180deg,transparent,rgba(0,0,0,.61) 62%);height:18.740629685157423vh;z-index:200;width:100%;position:fixed;bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-bottom:3.7481259370314843vh}.footer i[data-v-33f88de8]{font-size:30px}.google-maps-open[data-v-33f88de8]{background-color:#50e3c2;color:#fff;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;z-index:900000000;width:250px;height:43px;position:absolute;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;bottom:55px;border-radius:100px}.google-maps-open .text[data-v-33f88de8]{letter-spacing:1px;font-size:14px;font-weight:700}.filter-black[data-v-33f88de8]{position:fixed;z-index:2;height:85vh;width:100vw;background:-webkit-gradient(linear,left top,left bottom,from(#eee),to(#d8d8d8));background:linear-gradient(180deg,#eee,#d8d8d8)}.header-det[data-v-33f88de8]{top:0;padding-top:.5em;left:0;height:7.429em;background:-webkit-gradient(linear,left bottom,left top,from(transparent),to(rgba(0,0,0,.61)));background:linear-gradient(0deg,transparent,rgba(0,0,0,.61));position:fixed;width:100vw;display:-webkit-box;display:-ms-flexbox;display:flex;z-index:101;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.header-det .more-vert[data-v-33f88de8]{display:none;margin-right:.7em;font-size:1.5em;text-align:right;color:#9b9b9b}hr[data-v-33f88de8]{border:.5px solid #4a4a4a}.audio-button-sound-off[data-v-33f88de8]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;margin-top:10px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:.5px solid hsla(0,0%,73%,.5);background-color:#000;border-radius:6px;cursor:pointer;color:#fff;padding:6px;height:30px}.audio-button-sound-off i[data-v-33f88de8]{margin-left:2px}.audio-button-sound-off label[data-v-33f88de8]{cursor:pointer}.audio-button-sound-on[data-v-33f88de8]{margin-top:10px}.audio-button-sound-on[data-v-33f88de8],.video-button[data-v-33f88de8]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;height:30px;width:30px;padding-right:2px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:.5px solid hsla(0,0%,73%,.5);background-color:#000;border-radius:50%;cursor:pointer}.video-button[data-v-33f88de8]{margin-top:10px;margin:10px}.video-player-buttons[data-v-33f88de8]{margin-left:20px;top:0;left:0;position:absolute;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}@media (max-width:1024px){.video-player-buttons[data-v-33f88de8]{display:none}}.video-player-buttons-small-screen[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;display:none}@media (max-width:1024px){.video-player-buttons-small-screen[data-v-33f88de8]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}}.details-container[data-v-33f88de8]{position:relative}.details-container .top-section-container[data-v-33f88de8]{position:fixed;top:0;left:0;height:100vh;width:100vw;z-index:1500;overflow:hidden;width:100%;background-color:#000;background-size:auto 85vh;background-position:50%}@media (max-width:768px){.details-container .top-section-container[data-v-33f88de8]{height:37.857em}}.details-container .top-section-container .view-image[data-v-33f88de8]{height:100%}.details-container .top-section-container .view-image-full[data-v-33f88de8]{width:100%;margin-top:-10%}@media only screen and (max-width:768px){.details-container .top-section-container .view-image-full[data-v-33f88de8]{margin-top:50px}}.details-container .top-section-container .top-header-container[data-v-33f88de8]{position:absolute;width:100%;height:7.429em;background-image:-webkit-gradient(linear,left bottom,left top,from(transparent),color-stop(13%,rgba(0,0,0,.06)),color-stop(25%,rgba(0,0,0,.11)),color-stop(36%,rgba(0,0,0,.18)),color-stop(45%,rgba(0,0,0,.26)),color-stop(53%,rgba(0,0,0,.33)),color-stop(60%,rgba(0,0,0,.41)),color-stop(66%,rgba(0,0,0,.48)),color-stop(72%,rgba(0,0,0,.56)),color-stop(77%,rgba(0,0,0,.62)),color-stop(81%,rgba(0,0,0,.68)),color-stop(86%,rgba(0,0,0,.73)),color-stop(90%,rgba(0,0,0,.77)),color-stop(95%,rgba(0,0,0,.79)),to(rgba(0,0,0,.8)));background-image:linear-gradient(0deg,transparent,rgba(0,0,0,.06) 13%,rgba(0,0,0,.11) 25%,rgba(0,0,0,.18) 36%,rgba(0,0,0,.26) 45%,rgba(0,0,0,.33) 53%,rgba(0,0,0,.41) 60%,rgba(0,0,0,.48) 66%,rgba(0,0,0,.56) 72%,rgba(0,0,0,.62) 77%,rgba(0,0,0,.68) 81%,rgba(0,0,0,.73) 86%,rgba(0,0,0,.77) 90%,rgba(0,0,0,.79) 95%,rgba(0,0,0,.8));top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:10px}.details-container .top-section-container .top-header-container .header-content[data-v-33f88de8]{width:100vw;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;position:relative}.details-container .top-section-container .top-header-container .header-content .month-duration[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;font-family:MontSerrat;font-size:.6875em;text-align:right;color:#fff;margin-bottom:.625em}.details-container .top-section-container .top-header-container .header-content .month-duration .month-name[data-v-33f88de8]{margin-right:.3125em}.details-container .top-section-container .top-header-container .header-content .month-duration .dur-time[data-v-33f88de8]{margin-left:.3125em}.details-container .top-section-container .top-header-container .header-content .top-menu-icons[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media only screen and (min-width:768px){.details-container .top-section-container .top-header-container .header-content .top-menu-icons[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}.details-container .top-section-container .top-header-container .header-content .image-time-place-details[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype[data-v-33f88de8]{padding:.3125em .9375em;background-color:rgba(0,0,0,.8);color:#fff;border-radius:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;cursor:pointer;font-size:.75em;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif!important}@media only screen and (min-width:768px) and (min-width:1920px){.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype[data-v-33f88de8]{font-size:1em!important}}@media only screen and (min-width:768px) and (max-width:1920px) and (min-width:1536px){.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype[data-v-33f88de8]{font-size:calc(1em - 15%)!important}}@media only screen and (min-width:768px) and (max-width:1536px) and (min-width:1440px){.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype[data-v-33f88de8]{font-size:calc(1em - 20%)!important}}@media only screen and (min-width:768px) and (max-width:1440px) and (min-width:768px){.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype[data-v-33f88de8]{font-size:calc(1em - 25%)!important}}@media only screen and (min-width:768px) and (max-width:1440px){.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype[data-v-33f88de8]{font-size:calc(1em - 25%)!important}}.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype .spotTypeOthers[data-v-33f88de8]{font-weight:700}.details-container .top-section-container .top-header-container .header-content .white-line[data-v-33f88de8]{height:1px;border-radius:2px;width:60%;background-color:#fff;margin-bottom:5px}@media only screen and (max-width:768px){.details-container .top-section-container .top-header-container .header-content .white-line[data-v-33f88de8]{width:100%}}.details-container .top-section-container .top-header-container .header-content .image-carousal[data-v-33f88de8]{position:relative;margin-bottom:.625em;width:50%;display:-webkit-box;display:-ms-flexbox;display:flex}.details-container .top-section-container .top-header-container .header-content .image-carousal .img-progress-bar[data-v-33f88de8]{margin-left:1px;margin-right:1px;height:2px;border-radius:3px;background-color:#fff;-webkit-animation:fill-length-data-v-33f88de8 3s linear;animation:fill-length-data-v-33f88de8 3s linear}.details-container .top-section-container .top-header-container .header-content .image-carousal .img-progress-bar .passed[data-v-33f88de8]{width:100%;background-color:#fff}.details-container .top-section-container .top-header-container .header-content .image-carousal .img-progress-bar .active[data-v-33f88de8]{-webkit-animation:fill-length-data-v-33f88de8 3s linear;animation:fill-length-data-v-33f88de8 3s linear}.details-container .top-section-container .top-header-container .header-content .image-carousal .img-progress-bar-container[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin-left:1px;margin-right:1px;height:2px;border-radius:3px;background-color:rgba(0,0,0,.8)}@-webkit-keyframes fill-length{0%{width:0}to{width:100%}}@keyframes fill-length-data-v-33f88de8{0%{width:0}to{width:100%}}@media only screen and (min-width:768px){.details-container .top-section-container .top-header-container .header-content .go-back-container[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}.details-container .top-section-container .top-header-container .header-content .go-back-container .go-back-icon[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:100px;padding:.5em;z-index:10000000;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;cursor:pointer}@media only screen and (max-width:768px){.details-container .top-section-container .top-header-container .header-content .go-back-container .go-back-icon[data-v-33f88de8]{display:block}}.details-container .top-section-container .top-header-container .header-content .go-back-container .go-back-icon i[data-v-33f88de8]{-webkit-transform:translate(21%);transform:translate(21%);font-size:1em}.details-container .top-section-container .fullscreen-footer[data-v-33f88de8]{position:absolute;width:100%;height:4.714em;background-image:-webkit-gradient(linear,left top,left bottom,from(transparent),color-stop(7%,rgba(0,0,0,.01)),color-stop(13%,rgba(0,0,0,.03)),color-stop(18%,rgba(0,0,0,.07)),color-stop(24%,rgba(0,0,0,.11)),color-stop(29%,rgba(0,0,0,.17)),color-stop(34%,rgba(0,0,0,.23)),color-stop(39%,rgba(0,0,0,.3)),color-stop(45%,rgba(0,0,0,.38)),color-stop(51%,rgba(0,0,0,.45)),color-stop(59%,rgba(0,0,0,.53)),color-stop(67%,rgba(0,0,0,.6)),color-stop(76%,rgba(0,0,0,.68)),color-stop(87%,rgba(0,0,0,.74)),to(rgba(0,0,0,.8)));background-image:linear-gradient(180deg,transparent,rgba(0,0,0,.01) 7%,rgba(0,0,0,.03) 13%,rgba(0,0,0,.07) 18%,rgba(0,0,0,.11) 24%,rgba(0,0,0,.17) 29%,rgba(0,0,0,.23) 34%,rgba(0,0,0,.3) 39%,rgba(0,0,0,.38) 45%,rgba(0,0,0,.45) 51%,rgba(0,0,0,.53) 59%,rgba(0,0,0,.6) 67%,rgba(0,0,0,.68) 76%,rgba(0,0,0,.74) 87%,rgba(0,0,0,.8));bottom:0;left:0;padding:.5em 1em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.details-container .top-section-container .fullscreen-footer .footer-content[data-v-33f88de8]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.details-container .top-section-container .fullscreen-footer .footer-content .like-share-fullscreen-container[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;width:33.33333vw;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#fff}.details-container .top-section-container .fullscreen-footer .footer-content .like-share-fullscreen-container i[data-v-33f88de8]{color:#fff}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link[data-v-33f88de8]{width:33.33333vw;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media only screen and (max-width:768px){.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link[data-v-33f88de8]{display:none}}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link a[data-v-33f88de8]:first-child{border-top-left-radius:6px;border-bottom-left-radius:6px}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link a[data-v-33f88de8]:last-child{border-top-right-radius:6px;border-bottom-right-radius:6px}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .street-view-link-button[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-align:center;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:12px;font-weight:700;color:#fff;border:.5px solid #b9b9b9;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background-color:#000;padding:.625em .9375em;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;width:-webkit-max-content;width:-moz-max-content;width:max-content}@media only screen and (max-width:768px){.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .street-view-link-button[data-v-33f88de8]{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:auto;margin-right:auto;width:100%;margin-top:10px}}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .street-view-link-button .virtual-doll[data-v-33f88de8]{width:17px;height:20px}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .street-view-link-button i[data-v-33f88de8],.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .street-view-link-button img[data-v-33f88de8]{margin-right:7px}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-link-button[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:12px;font-weight:700;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;color:#fff;border:.5px solid #b9b9b9;background-color:#000;padding:.625em .9375em;text-decoration:none;width:-webkit-max-content;width:-moz-max-content;width:max-content;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media only screen and (max-width:768px){.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-link-button[data-v-33f88de8]{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:auto;margin-right:auto;width:100%;margin-top:10px}}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-link-button .heli-view-image[data-v-33f88de8]{width:33px;height:17px}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-link-button img[data-v-33f88de8]{height:17px}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-botton-flex[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:12px;font-weight:700;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;border:.5px solid #b9b9b9;background-color:#000;padding:.625em .9375em;text-decoration:none;width:-webkit-max-content;width:-moz-max-content;width:max-content;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media only screen and (max-width:768px){.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-botton-flex[data-v-33f88de8]{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:auto;margin-right:auto;width:100%;margin-top:10px}}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-botton-flex .heli-view-image[data-v-33f88de8]{width:33px;height:17px;margin-right:12px}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-botton-flex img[data-v-33f88de8]{height:17px}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-botton-flex i[data-v-33f88de8]{margin-right:12px}.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link i[data-v-33f88de8]{font-size:18px}.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-like[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;color:#fff}.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-like i[data-v-33f88de8]{color:#fff;font-size:1.7em}@media only screen and (max-width:768px){.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-like i[data-v-33f88de8]{font-size:1.3em}}.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-like .likes-container[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-right:.6em}.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-like .likes-count[data-v-33f88de8]{margin-right:.6em}.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll[data-v-33f88de8]{position:relative;z-index:8;border-radius:.375em;padding:.3em .9375em;outline:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:.6875em;font-weight:700}@media screen and (min-width:1920px){.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll[data-v-33f88de8]{font-size:1em!important}}@media screen and (max-width:1920px) and (min-width:1536px){.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll[data-v-33f88de8]{font-size:calc(1em - 15%)!important}}@media screen and (max-width:1536px) and (min-width:1440px){.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll[data-v-33f88de8]{font-size:calc(1em - 20%)!important}}@media screen and (max-width:1440px) and (min-width:768px){.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll[data-v-33f88de8]{font-size:calc(1em - 25%)!important}}@media screen and (max-width:1440px){.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll[data-v-33f88de8]{font-size:calc(1em - 25%)!important}}.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll i[data-v-33f88de8]{z-index:10!important;color:#f5a623;padding-left:.7em;font-size:1.3em}.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go[data-v-33f88de8]{background-color:#bd10e0;color:#fff}.details-container .top-section-container .fullscreen-footer .footer-content .on-travel-list[data-v-33f88de8]{background-color:#000;color:#f5a623;border:.5px solid hsla(0,0%,73%,.5)}.details-container .top-section-container .fullscreen-footer .footer-content .share-like[data-v-33f88de8]{position:relative;width:33.33333vw}@media only screen and (max-width:768px){.details-container .top-section-container .fullscreen-footer .footer-content .share-like[data-v-33f88de8]{width:auto}}.details-container .top-section-container .fullscreen-footer .footer-content .share-btn[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:.9375em;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;color:#fff}.details-container .top-section-container .fullscreen-footer .footer-content .share-btn i[data-v-33f88de8]{font-size:1.7em;color:#fff;-webkit-transform:scaleX(-1);transform:scaleX(-1)}@media only screen and (max-width:768px){.details-container .top-section-container .fullscreen-footer .footer-content .share-btn i[data-v-33f88de8]{font-size:1.3em}}.inner[data-v-33f88de8]{overflow-x:hidden;padding:.5em 1em;position:absolute;top:42%;width:100%;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:space-between}@media (max-width:1024px){.inner[data-v-33f88de8]{top:45%}}.inner .arrow-container[data-v-33f88de8]{height:50px;width:50px;border-radius:50%;background-color:rgba(0,0,0,.3);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}@media (max-width:1024px){.inner .arrow-container[data-v-33f88de8]{height:auto;width:auto}}.inner .arrow-buttons[data-v-33f88de8]{cursor:pointer;color:#fff;-webkit-transform:scale(1.7);transform:scale(1.7)}@media (max-width:1024px){.inner .arrow-buttons[data-v-33f88de8]{-webkit-transform:scale(1.3);transform:scale(1.3)}}.inner .loading-container[data-v-33f88de8]{margin-right:-22px;height:100px;width:100px}@media (max-width:1024px){.inner .loading-container[data-v-33f88de8]{margin-right:-40px}}.inner .loading-container .loading[data-v-33f88de8]{transform:scale(.3);width:100px;height:100px;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-transform:scale(.3);-webkit-width:100px;-webkit-height:100px;-webkit-position:relative;-webkit-display:flex;-webkit-align-items:center;-webkit-justify-content:center}.inner .loading-container .loading .text[data-v-33f88de8]{position:absolute;z-index:20;font-size:2.5em;color:#999;font-weight:600}.inner .loading-container .outer-shadow[data-v-33f88de8]{z-index:2;background:transparent;-webkit-z-index:2;-webkit-background:transparent}.inner .loading-container .inner-shadow[data-v-33f88de8],.inner .loading-container .outer-shadow[data-v-33f88de8]{position:absolute;width:100%;height:100%;border-radius:100%;-webkit-position:absolute;-webkit-width:100%;-webkit-height:100%;-webkit-border-radius:100%}.inner .loading-container .inner-shadow[data-v-33f88de8]{z-index:6;transform:scale(1.1);top:50%;left:50%;width:80px;height:80px;margin-left:-40px;margin-top:-40px;border-radius:100%;background-color:#000;-webkit-z-index:6;-webkit-transform:scale(1.1);-webkit-top:50%;-webkit-left:50%;-webkit-width:80px;-webkit-height:80px;-webkit-margin-left:-40px;-webkit-margin-top:-40px;-webkit-border-radius:100%;-webkit-background-color:#000}.inner .loading-container .hold[data-v-33f88de8]{z-index:0!important;position:absolute;width:100%;height:100%;clip:rect(0,100px,100px,50px);border-radius:100%;background-color:transparent;-webkit-z-index:0!important;-webkit-position:absolute;-webkit-width:100%;-webkit-height:100%;-webkit-clip:rect(0,100px,100px,50px);-webkit-border-radius:100%;-webkit-background-color:transparent}.inner .loading-container .dot span[data-v-33f88de8],.inner .loading-container .fill[data-v-33f88de8]{background-color:#9b9b9b;-webkit-background-color:#9b9b9b}.inner .loading-container .fill[data-v-33f88de8]{position:absolute;width:100%;height:100%;border-radius:100%;clip:rect(0,50px,100px,0);-webkit-position:absolute;-webkit-width:100%;-webkit-height:100%;-webkit-border-radius:100%;-webkit-clip:rect(0,50px,100px,0)}@keyframes left-data-v-33f88de8{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(180deg)}}@-webkit-keyframes left{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(180deg)}}.inner .loading-container .left .fill[data-v-33f88de8]{-webkit-animation-play-state:running;-webkit-animation:left-data-v-33f88de8 3s linear;animation:left-data-v-33f88de8 3s linear both}.inner .loading-container .right[data-v-33f88de8]{-webkit-transform:rotate(180deg);transform:rotate(180deg)}@keyframes right-data-v-33f88de8{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(180deg)}}@-webkit-keyframes right{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(180deg)}}.inner .loading-container .right .fill[data-v-33f88de8]{-webkit-animation-play-state:running;-webkit-animation:left-data-v-33f88de8 3s linear;animation:left-data-v-33f88de8 3s linear both;-webkit-animation-delay:3s;animation-delay:3s}.bottom-container[data-v-33f88de8]{top:85vh;position:relative}@media (max-width:768px){.bottom-container[data-v-33f88de8]{top:37.857em}}.bottom-container .photographer-profile-det[data-v-33f88de8]{padding-bottom:8em;position:absolute;top:0;width:100%}.bottom-container .photographer-profile-det .mobile-street-links-nearby[data-v-33f88de8]{display:none}@media only screen and (max-width:768px){.bottom-container .photographer-profile-det .mobile-street-links-nearby[data-v-33f88de8]{display:block}}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link[data-v-33f88de8]{margin-bottom:10px;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link a[data-v-33f88de8]:first-child{border-top-left-radius:6px;border-bottom-left-radius:6px}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link a[data-v-33f88de8]:last-child{border-top-right-radius:6px;border-bottom-right-radius:6px}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .street-view-link-button[data-v-33f88de8]{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-align:center;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:12px;font-weight:700;color:#fff;border:.5px solid #b9b9b9;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background-color:#000;padding:.625em .9375em;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;width:-webkit-max-content;width:-moz-max-content;width:max-content}@media only screen and (max-width:768px){.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .street-view-link-button[data-v-33f88de8]{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:auto;margin-right:auto;width:100%;margin-top:10px}}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .street-view-link-button .virtual-doll[data-v-33f88de8]{width:17px;height:20px}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .street-view-link-button i[data-v-33f88de8],.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .street-view-link-button img[data-v-33f88de8]{margin-right:7px}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-link-button[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:12px;font-weight:700;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;color:#fff;border:.5px solid #b9b9b9;background-color:#000;padding:.625em .9375em;text-decoration:none;width:-webkit-max-content;width:-moz-max-content;width:max-content;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media only screen and (max-width:768px){.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-link-button[data-v-33f88de8]{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:auto;margin-right:auto;width:100%;margin-top:10px}}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-link-button .heli-view-image[data-v-33f88de8]{width:33px;height:17px}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-link-button img[data-v-33f88de8]{height:17px}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-botton-flex[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:12px;font-weight:700;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;border:.5px solid #b9b9b9;background-color:#000;padding:.625em .9375em;text-decoration:none;width:-webkit-max-content;width:-moz-max-content;width:max-content;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media only screen and (max-width:768px){.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-botton-flex[data-v-33f88de8]{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:auto;margin-right:auto;width:100%;margin-top:10px}}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-botton-flex .heli-view-image[data-v-33f88de8]{width:33px;height:17px;margin-right:12px}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-botton-flex img[data-v-33f88de8]{height:17px}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-botton-flex i[data-v-33f88de8]{margin-right:12px}.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link i[data-v-33f88de8]{font-size:18px}.bottom-container .photographer-profile-det .mobile-street-links-nearby .nearby-and-maps-links[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex}.bottom-container .photographer-profile-det .mobile-street-links-nearby .nearby-and-maps-links .nearby-button[data-v-33f88de8]{width:100%;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:12px;font-weight:800;border:.5px solid #b9b9b9;background-image:-webkit-gradient(linear,left top,right top,color-stop(75%,#000),color-stop(25%,#bd10e0));color:#b9b9b9;text-decoration:none;padding:8px;border-radius:6px}.bottom-container .photographer-profile-det .photographer-profile-det-container[data-v-33f88de8]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:2.5em;margin-bottom:.6875em;-ms-flex-wrap:nowrap;flex-wrap:nowrap}@media only screen and (max-width:768px){.bottom-container .photographer-profile-det .photographer-profile-det-container[data-v-33f88de8]{height:auto;-ms-flex-wrap:wrap;flex-wrap:wrap}}.bottom-container .photographer-profile-det .photographer-profile-det-container img[data-v-33f88de8]{height:1.5em;width:1.5em;-o-object-fit:cover;object-fit:cover;border-radius:100%}.bottom-container .photographer-profile-det .photographer-profile-det-container .no-profile-image[data-v-33f88de8]{width:1.5em;height:1.5em;border-radius:100%;background:#fff;font-size:20px;color:#000;text-align:center;line-height:1.5em;font-weight:700}.bottom-container .photographer-profile-det .photographer-profile-det-container .nearby-and-maps-links[data-v-33f88de8]{width:33.33333vw;display:-webkit-box;display:-ms-flexbox;display:flex}@media only screen and (max-width:768px){.bottom-container .photographer-profile-det .photographer-profile-det-container .nearby-and-maps-links[data-v-33f88de8]{display:none}}.bottom-container .photographer-profile-det .photographer-profile-det-container .nearby-and-maps-links .nearby-button[data-v-33f88de8]{width:100%;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:12px;font-weight:800;border:.5px solid #b9b9b9;background-image:-webkit-gradient(linear,left top,right top,color-stop(75%,#000),color-stop(25%,#bd10e0));color:#b9b9b9;text-decoration:none;padding:8px;border-radius:6px}.bottom-container .photographer-profile-det .photographer-profile-det-container .name-container[data-v-33f88de8]{margin:auto .8em auto 0;font-size:.9em;text-transform:capitalize;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-weight:500}@media only screen and (max-width:768px){.bottom-container .photographer-profile-det .photographer-profile-det-container .name-container[data-v-33f88de8]{font-size:.6875em}}.bottom-container .photographer-profile-det .photographer-profile-det-container .distance[data-v-33f88de8]{color:#fff;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;width:33.33333vw;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:.8125em}.bottom-container .photographer-profile-det .photographer-profile-det-container .distance .loc-detail[data-v-33f88de8],.bottom-container .photographer-profile-det .photographer-profile-det-container .distance[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.bottom-container .photographer-profile-det .photographer-profile-det-container .distance .loc-detail pre b[data-v-33f88de8]{font-weight:700}@media only screen and (max-width:768px){.bottom-container .photographer-profile-det .photographer-profile-det-container .distance[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}.bottom-container .photographer-profile-det .photographer-profile-det-container .distance i[data-v-33f88de8]{font-size:1em;margin-right:5px}.bottom-container .photographer-profile-det .photographer-profile-det-container .photographer-profile-user[data-v-33f88de8]{width:33.33333vw;color:#fff}.bottom-container .photographer-profile-det .photographer-profile-det-container .photographer-profile-user img[data-v-33f88de8]{margin-right:.8em}@media only screen and (max-width:768px){.bottom-container .photographer-profile-det .photographer-profile-det-container .photographer-profile-user[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}.bottom-container .photographer-profile-det .photographer-profile-det-container .photographer-profile[data-v-33f88de8]{color:#9b9b9b;width:33.33333vw}@media only screen and (max-width:768px){.bottom-container .photographer-profile-det .photographer-profile-det-container .photographer-profile[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}.bottom-container .photographer-profile-det .caption[data-v-33f88de8]{text-align:left;margin-top:1.25em;margin-bottom:1.25em;font-size:1.1875em!important;font-weight:700;color:#fff;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif}.bottom-container .photographer-profile-det .enable-loc[data-v-33f88de8]{margin:1.2em 0 0;padding-left:.5em;text-align:left;font-size:1em;color:#fff;font-family:MontSerrat-Regular}.bottom-container .photographer-profile-det .enable-loc i[data-v-33f88de8]{font-size:1em}.bottom-container .photographer-profile-det hr[data-v-33f88de8]{margin-top:1.2em}.user-footer-bottom[data-v-33f88de8]{position:fixed;bottom:0;bottom:-50px;width:100vw;z-index:200;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;color:#fff;background-color:#151515;opacity:.8;height:50px;padding:5px}@media only screen and (min-width:768px){.user-footer-bottom[data-v-33f88de8]{background-color:transparent;bottom:-50px}}.user-footer-bottom .wav-icon-footer[data-v-33f88de8]{height:14px}@media only screen and (min-width:768px){.user-footer-bottom .wav-icon-footer[data-v-33f88de8]{height:10px}}.user-footer-bottom .user_account[data-v-33f88de8]{width:1.75em}.user-footer-bottom i[data-v-33f88de8]{font-size:18px}.user-footer-bottom button[data-v-33f88de8]{outline:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.user-footer-bottom .footer-icons[data-v-33f88de8]{cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif}.user-footer-bottom .footer-icons span[data-v-33f88de8]{font-size:10px;cursor:pointer}.user-footer-bottom .option-container[data-v-33f88de8]{cursor:pointer;width:56px;display:-webkit-box;display:-ms-flexbox;display:flex}.user-footer-bottom .search-icon-text[data-v-33f88de8]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.near-height[data-v-33f88de8]{margin-bottom:2em;padding-top:1.0625em;font-size:.875em;background-color:#151515;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif}.disable-select[data-v-33f88de8]{scroll-behavior:smooth;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.custom-select[data-v-33f88de8]{position:relative;outline:none;margin-right:1em}.custom-select__label[data-v-33f88de8]{outline:none;font-size:.919em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}@media screen and (max-width:600px){.custom-select__label[data-v-33f88de8]{color:#9b9b9b}}@media screen and (min-width:601px){.custom-select__label[data-v-33f88de8]{color:#fff;font-weight:700}}.custom-select__label-down-arrow[data-v-33f88de8]{padding-left:.313em}@media screen and (max-width:600px){.custom-select__label-down-arrow[data-v-33f88de8]{height:1.5em}}@media screen and (min-width:601px){.custom-select__label-down-arrow[data-v-33f88de8]{height:1.1em}}@media screen and (min-width:601px){.custom-select__label-down-arrow_mobile[data-v-33f88de8]{display:none}}@media screen and (max-width:600px){.custom-select__label-down-arrow_desktop[data-v-33f88de8]{display:none}}.custom-select__options[data-v-33f88de8]{position:absolute;top:1.5em;right:0;background:#fff;-webkit-box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);padding:.7em 1em;border-radius:8px}.custom-select__option[data-v-33f88de8]{cursor:pointer;font-size:.818em;padding-top:.05em;padding-bottom:.05em}.custom-select__option_selected[data-v-33f88de8]{font-weight:500;color:#333}.custom-select__option_disabled[data-v-33f88de8]{color:#999}.media-top-section[data-v-33f88de8]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-top:90px;padding-bottom:90px;background-color:#151515}@media screen and (max-width:768px){.media-top-section[data-v-33f88de8]{padding-top:60px}}.media-top-section .top-section[data-v-33f88de8]{position:relative;overflow:hidden;padding:10px}.media-top-section .top-section .photo-details[data-v-33f88de8]{display:none}@media screen and (max-width:768px){.media-top-section .top-section .photo-details[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;color:#fff;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-align:left;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-bottom:20px}.media-top-section .top-section .photo-details .caption[data-v-33f88de8]{font-size:14px!important;font-weight:600;margin-bottom:10px;line-height:1.2;text-align:center}.media-top-section .top-section .photo-details .location[data-v-33f88de8]{font-size:11px!important;line-height:1.03;display:-webkit-box;display:-ms-flexbox;display:flex}.media-top-section .top-section .photo-details .nearby-button-mobile[data-v-33f88de8]{width:100%;font-family:MontSerrat;font-weight:700;padding:8px;background-color:#5b5b5b;border-radius:6px;text-align:center;color:#fff;text-decoration:none;margin-top:10px}.media-top-section .top-section .photo-details .photographer-details[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%;font-size:10px!important;padding:16px}}.media-top-section .top-section .photo-details-description[data-v-33f88de8]{background-color:#000;border-radius:10px;padding-top:10px;padding-bottom:20px;margin-bottom:-10px}.media-top-section .top-section .video-card[data-v-33f88de8]{width:100vw;height:65vh}.media-top-section .top-section .image-card[data-v-33f88de8]{border-radius:12px;position:relative;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:1130px;height:65vh}.media-top-section .top-section .image-card .image-card-image[data-v-33f88de8]{width:100%;height:auto}@media screen and (max-width:768px){.media-top-section .top-section .image-card .image-card-image[data-v-33f88de8]{width:auto;height:100%}}@media screen and (max-width:1130px){.media-top-section .top-section .image-card[data-v-33f88de8]{width:100%;height:47vh}}.media-top-section .like-share-container[data-v-33f88de8]{position:absolute;top:0;right:0;padding:20px 10px;display:-webkit-box;display:-ms-flexbox;display:flex}.media-top-section .like-share-container .icon-container[data-v-33f88de8]{height:45px;width:45px;background-color:rgba(0,0,0,.5);border-radius:50%;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.media-top-section .like-share-container .icon-container i[data-v-33f88de8]{font-size:30px}.media-top-section .like-share-container .icon-container .share-icon[data-v-33f88de8]{height:30px;width:30px}@media screen and (max-width:768px){.media-top-section .like-share-container .icon-container[data-v-33f88de8]{height:30px;width:30px}.media-top-section .like-share-container .icon-container i[data-v-33f88de8]{font-size:18px}.media-top-section .like-share-container .icon-container .share-icon[data-v-33f88de8]{height:18px;width:18px}}.media-top-section .control-section[data-v-33f88de8]{width:100%;background-color:transparent;padding:22px 0;display:-webkit-box;display:-ms-flexbox;display:flex;max-width:1130px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}@media screen and (max-width:768px){.media-top-section .control-section[data-v-33f88de8]{margin-top:-10px;padding:20px 0 10px;background-color:#000;border-radius:0 0 10px 10px;margin-bottom:5px}}.media-top-section .control-section .location-details[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}@media screen and (max-width:768px){.media-top-section .control-section .location-details[data-v-33f88de8]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}.media-top-section .control-section .control-item[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-right:20px;color:#fff}@media screen and (max-width:768px){.media-top-section .control-section .control-item[data-v-33f88de8]{font-size:11px}}.media-top-section .control-section .control-item label[data-v-33f88de8]{cursor:pointer}.media-top-section .control-section .control-item img[data-v-33f88de8]{height:36px;width:auto}@media screen and (max-width:768px){.media-top-section .control-section .control-item img[data-v-33f88de8]{height:20px}}.media-top-section .control-section .control-item i[data-v-33f88de8]{font-size:36px}@media screen and (max-width:768px){.media-top-section .control-section .control-item i[data-v-33f88de8]{font-size:20px}}.media-top-section .control-section a[data-v-33f88de8]{text-decoration:none;color:#fff}.media-top-section .control-section .nearby-places[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex}@media screen and (max-width:768px){.media-top-section .control-section .nearby-places[data-v-33f88de8]{display:none}}.media-top-section .control-section .nearby-places .nearby-button[data-v-33f88de8]{font-family:MontSerrat;font-weight:700;padding:1.25rem 4.5rem;background-color:#5b5b5b;border-radius:6px}.media-top-section .control-section .nearby-places .feedback[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-right:20px;color:#fff}.media-top-section .control-section .nearby-places .feedback img[data-v-33f88de8]{height:25px;width:auto}.media-top-section .control-section .nearby-places .feedback i[data-v-33f88de8]{font-size:36px}.search-top-city-container[data-v-33f88de8]{z-index:999;top:0;width:100%;position:fixed;color:#fff;background-color:#2c2c2c;-webkit-transition:top 1s;transition:top 1s}.search-top-city-container .toolbar-content-container[data-v-33f88de8]{position:relative;width:100%;padding:.625rem;background-color:#000;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.search-top-city-container .toolbar-content-container .cursor[data-v-33f88de8]{cursor:pointer}.search-top-city-container .toolbar-content-container .fullscreen-mode-text[data-v-33f88de8]{font-size:11px;display:none;cursor:pointer}@media only screen and (max-width:768px){.search-top-city-container .toolbar-content-container .fullscreen-mode-text[data-v-33f88de8]{font-size:11px;display:block}}.search-top-city-container .toolbar-content-container .list-view-text[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font-size:16px;font-weight:700;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-family:MontSerrat;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.search-top-city-container .toolbar-content-container .list-view-text .search-component[data-v-33f88de8]{display:block}@media screen and (max-width:1024px){.search-top-city-container .toolbar-content-container .list-view-text .search-component[data-v-33f88de8]{display:none}}.search-top-city-container .toolbar-content-container .list-view-text .logo-color[data-v-33f88de8]{font-family:MontSerrat;color:#bd10e0}.search-top-city-container .toolbar-content-container .heading-text[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}@media only screen and (min-width:1024px){.search-top-city-container .toolbar-content-container .heading-text[data-v-33f88de8]{display:none}}.search-top-city-container .header-section-3[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.search-top-city-container .header-section-3 .pill-container[data-v-33f88de8]{display:none;border-radius:2rem;border:.5px solid #b9b9b9}@media only screen and (min-width:768px){.search-top-city-container .header-section-3 .pill-container[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex}}.search-top-city-container .header-section-3 .pill[data-v-33f88de8]{padding:1rem 2rem .4rem}.search-top-city-container .header-section-3 .pill [data-v-33f88de8]{cursor:pointer;padding:0;margin:0}.search-top-city-container .pills-description[data-v-33f88de8]{margin-top:5px;display:none}@media only screen and (min-width:768px){.search-top-city-container .pills-description[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex}}.search-top-city-container .pills-description .description-item[data-v-33f88de8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-size:12px}.search-top-city-container .search-city-relative[data-v-33f88de8]{position:relative;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.search-top-city-container .search-city-relative i[data-v-33f88de8]{opacity:.6;color:#fff;font-size:1.286em}.search-top-city-container .search-city-relative .i-1[data-v-33f88de8]{left:20px}.search-top-city-container .search-city-relative .i-2[data-v-33f88de8]{left:65px}.search-top-city-container .search-city-relative .i-3[data-v-33f88de8]{right:3em}.search-top-city-container .search-city-relative .i-4[data-v-33f88de8]{right:22px}.search-top-city-container-hide[data-v-33f88de8]{display:none;-webkit-transition:top 2s ease 0s;transition:top 2s ease 0s}.go-back-icon-and-fullscreen-mobile[data-v-33f88de8]{display:none;font-family:Montserrat;padding:3px;text-decoration:none;color:#fff}.go-back-icon-and-fullscreen-mobile i[data-v-33f88de8]{font-size:12px;margin-right:5px}@media only screen and (min-width:768px){.go-back-icon-and-fullscreen-mobile[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-weight:700;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.go-back-icon-and-fullscreen-mobile .logo[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;color:#bd10e0}}.sticky-footer[data-v-33f88de8]{position:fixed;bottom:0;padding:15px 0;background-color:#d9d9d9;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-family:MontSerrat-Regular;z-index:999;width:100%}@media screen and (max-width:786px){.sticky-footer[data-v-33f88de8]{padding:10px 0}}.sticky-footer .logo[data-v-33f88de8]{text-decoration:none;color:#000;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0 10px 0 0}.sticky-footer .logo img[data-v-33f88de8]{height:18px}@media screen and (max-width:786px){.sticky-footer .logo[data-v-33f88de8]{font-size:11px}.sticky-footer .logo img[data-v-33f88de8]{height:14px}}.sticky-footer .list-view-btn[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#000}@media screen and (max-width:768px){.sticky-footer .list-view-btn[data-v-33f88de8]{font-size:11px}.sticky-footer .list-view-btn i[data-v-33f88de8]{font-size:18px}}.sticky-footer .navigations[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0 20px;border-right:1px solid #979797;margin-right:10px}.sticky-footer .photo-description[data-v-33f88de8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;padding:0 20px;color:#000;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-align:left;-ms-flex-pack:distribute;justify-content:space-around}.sticky-footer .photo-description .caption[data-v-33f88de8]{font-size:24px!important;font-weight:600;line-height:1.2;max-width:600px}.sticky-footer .photo-description .location[data-v-33f88de8]{font-size:18px!important;font-weight:600;line-height:1.03;display:-webkit-box;display:-ms-flexbox;display:flex}@media screen and (max-width:786px){.sticky-footer .photo-description[data-v-33f88de8]{display:none}}.sticky-footer .check-price-btn[data-v-33f88de8]{padding:12px 30px;border-radius:4px;background-color:#655fff;font-family:Montserrat;font-size:14px;font-weight:700;font-stretch:normal;font-style:normal;line-height:2;letter-spacing:normal;text-align:center;color:#fff;text-decoration:none;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}@media screen and (max-width:768px){.sticky-footer .check-price-btn[data-v-33f88de8]{font-size:12px;padding:4px 16px;margin-left:auto}}@media screen and (max-width:360px){.sticky-footer .check-price-btn[data-v-33f88de8]{font-size:10px;margin-left:auto}}.sticky-footer .read-review-btn[data-v-33f88de8]{padding:12px 30px;border-radius:4px;background-color:#000;font-family:Montserrat;font-size:14px;font-weight:700;font-stretch:normal;font-style:normal;line-height:2;letter-spacing:normal;text-align:center;color:#fff;text-decoration:none;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}@media screen and (max-width:768px){.sticky-footer .read-review-btn[data-v-33f88de8]{font-size:12px;padding:4px 16px}}@media screen and (max-width:360px){.sticky-footer .read-review-btn[data-v-33f88de8]{font-size:10px;margin-left:auto}}.sticky-footer .travel-list-btn[data-v-33f88de8]{font-family:Montserrat;font-size:14px;font-weight:700;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:14px 30px;border-radius:4px;margin-left:10px;margin-right:20px;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}@media screen and (max-width:768px){.sticky-footer .travel-list-btn[data-v-33f88de8]{font-size:12px;line-height:2;padding:4px 16px;margin-right:15px}.sticky-footer .travel-list-btn i[data-v-33f88de8]{display:none}}@media screen and (max-width:360px){.sticky-footer .travel-list-btn[data-v-33f88de8]{font-size:10px;margin-left:auto}}.sticky-footer .checked[data-v-33f88de8]{background-color:#000;border:1px solid #f5a623;color:#f5a623}.sticky-footer .checked i[data-v-33f88de8]{color:#f5a623;font-size:12px}.sticky-footer .add[data-v-33f88de8]{background-color:#bd10e0;color:#fff}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/imageDetails/imageDetails.vue"],"names":[],"mappings":"AACA,gCACE,kBAAoB,CACrB,AACD,6BACE,kBAAmB,AACnB,iBAAmB,CACpB,AACD,6BACE,SAAW,CACZ,AACD,8BACE,kBAAmB,AACnB,QAAS,AACT,QAAU,CACX,AACD,kCACE,YAAa,AACb,UAAY,CACb,AACD,yCACE,gBAAkB,CACnB,AACD,+BACE,yBAA0B,AAClB,iBAAkB,AAC1B,sCAAwC,AACxC,8BAAgC,AAChC,sBAAwB,AACxB,wCAA6C,CAC9C,AACD,sCACE,uBAAwB,AAChB,cAAgB,CACzB,AACD,qBACE,wCAA2C,CAC5C,AACD,uCACE,kBAAmB,AACnB,YAAa,AACb,WAAY,AACZ,6BAAgC,CACjC,AACD,6BACE,cAAe,AACf,kBAAoB,CACrB,AACD,0CACE,eAAgB,AAChB,OAAQ,AACR,QAAS,AACT,YAAa,AACb,aAAc,AACd,6BAA8B,AAC9B,kBAAmB,AACnB,gCAAkC,CACnC,AACD,uDACI,SAAW,CACd,AACD,yFACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,iBAAmB,AACnB,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACjC,AACD,+FACQ,gBAAiB,AACjB,gBAAkB,CACzB,AACD,8FACQ,eAAgB,AAChB,cAAe,AACf,oBAAqB,AAClB,iBAAkB,AACrB,mBAAoB,AACpB,iBAAmB,CAC1B,AACD,yDACI,kBAAmB,AACnB,kBAAmB,AACnB,mBAAoB,AACpB,2BAA6B,AAC7B,wBAAgC,CACnC,AACD,qCACA,yDACQ,yBAA4B,CACnC,CACA,AACD,4DACA,yDACQ,qCAAwC,CAC/C,CACA,AACD,4DACA,yDACQ,qCAAwC,CAC/C,CACA,AACD,2DACA,yDACQ,qCAAwC,CAC/C,CACA,AACD,qCACA,yDACQ,qCAAwC,CAC/C,CACA,AACD,qEACM,WAAY,AACZ,mBAAoB,AACpB,kBAAmB,AACnB,kBAAmB,AACnB,+BAAiC,CACtC,AACD,gEACM,eAAuB,AACvB,oBAAsB,CAC3B,AACD,oEACQ,oBAAqB,AAClB,iBAAkB,AACrB,mBAAoB,AACpB,aAAc,AACd,WAAa,CACpB,AACD,yBACE,2GAA0H,AAC1H,oEAAmF,AACnF,4BAA6B,AAC7B,YAAa,AACb,WAAY,AACZ,eAAgB,AAChB,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,mCAAqC,CACtC,AACD,2BACI,cAAgB,CACnB,AACD,mCACE,yBAA0B,AAC1B,WAAe,AACf,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,kBAAmB,AACnB,YAAa,AACb,YAAa,AACb,kBAAmB,AACnB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAmB,AACnB,YAAa,AACb,mBAAqB,CACtB,AACD,yCACI,mBAAoB,AACpB,eAAgB,AAChB,eAAiB,CACpB,AACD,+BACE,eAAgB,AAChB,UAAW,AACX,YAAa,AACb,YAAa,AACb,gFAAwF,AACxF,+CAAyD,CAC1D,AACD,6BACE,MAAO,AACP,iBAAmB,AACnB,OAAQ,AACR,eAAgB,AAChB,+FAA6G,AAC7G,6DAA2E,AAC3E,eAAgB,AAChB,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACnC,AACD,wCACI,aAAc,AACd,kBAAoB,AACpB,gBAAiB,AACjB,iBAAkB,AAClB,aAAe,CAClB,AACD,oBACE,yBAA4B,CAC7B,AACD,yCACE,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oCAA6C,AAC7C,sBAA0B,AAC1B,kBAAmB,AACnB,eAAgB,AAChB,WAAa,AACb,YAAa,AACb,WAAa,CACd,AACD,2CACI,eAAiB,CACpB,AACD,+CACI,cAAgB,CACnB,AACD,wCAIE,eAAiB,CAiBlB,AACD,uEArBE,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAE9B,YAAa,AACb,WAAY,AACZ,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oCAA6C,AAC7C,sBAA0B,AAC1B,kBAAmB,AACnB,cAAgB,CAwBjB,AAtBD,+BAIE,gBAAiB,AAiBjB,WAAa,CACd,AACD,uCACE,iBAAkB,AAClB,MAAO,AACP,OAAQ,AACR,kBAAmB,AACnB,2BAA4B,AAC5B,2BAA4B,AAC5B,mBAAqB,CACtB,AACD,0BACA,uCACM,YAAc,CACnB,CACA,AACD,oDACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAc,CACf,AACD,0BACA,oDACM,2BAA4B,AAC5B,2BAA4B,AAC5B,mBAAqB,CAC1B,CACA,AACD,oCACE,iBAAmB,CACpB,AACD,2DACI,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,aAAc,AACd,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,WAAY,AACZ,sBAA0B,AAC1B,0BAA2B,AAC3B,uBAA4B,CAC/B,AACD,yBACA,2DACQ,eAAiB,CACxB,CACA,AACD,uEACM,WAAa,CAClB,AACD,4EACM,WAAY,AACZ,eAAiB,CACtB,AACD,yCACA,4EACU,eAAiB,CAC1B,CACA,AACD,iFACM,kBAAmB,AACnB,WAAY,AACZ,eAAgB,AAChB,ogBAAgmB,AAChmB,sUAAqZ,AACrZ,MAAO,AACP,OAAQ,AACR,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,YAAc,CACnB,AACD,iGACQ,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,iBAAmB,CAC1B,AACD,iHACU,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACxB,kBAAoB,AACpB,iBAAkB,AAClB,WAAe,AACf,oBAAuB,CAChC,AACD,6HACY,oBAAuB,CAClC,AACD,2HACY,mBAAsB,CACjC,AACD,iHACU,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACzC,AACD,yCACA,iHACc,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAClC,CACA,AACD,2HACU,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CACxC,AACD,0IACY,wBAA2B,AAC3B,gCAAqC,AACrC,WAAe,AACf,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,2BAA4B,AACxB,wBAAyB,AACrB,qBAAsB,AAC9B,eAAgB,AAChB,gBAAkB,AAClB,qJAA0K,CACrL,AACD,gEACA,0IACI,uBAA0B,CAC7B,CACA,AACD,uFACA,0IACI,mCAAsC,CACzC,CACA,AACD,uFACA,0IACI,mCAAsC,CACzC,CACA,AACD,sFACA,0IACI,mCAAsC,CACzC,CACA,AACD,gEACA,0IACI,mCAAsC,CACzC,CACA,AACD,0JACc,eAAkB,CAC/B,AACD,6GACU,WAAY,AACZ,kBAAmB,AACnB,UAAW,AACX,sBAA0B,AAC1B,iBAAmB,CAC5B,AACD,yCACA,6GACc,UAAY,CACzB,CACA,AACD,iHACU,kBAAmB,AACnB,qBAAuB,AACvB,UAAW,AACX,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACvB,AACD,mIACY,gBAAiB,AACjB,iBAAkB,AAClB,WAAY,AACZ,kBAAmB,AACnB,sBAA0B,AAC1B,wDAAyD,AACjD,+CAAiD,CACpE,AACD,2IACY,WAAY,AACZ,qBAA0B,CACrC,AACD,2IACY,wDAAyD,AACjD,+CAAiD,CACpE,AACD,6IACY,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,gBAAiB,AACjB,iBAAkB,AAClB,WAAY,AACZ,kBAAmB,AACnB,+BAAqC,CAChD,AACD,+BACA,GACI,OAAU,CACb,AACD,GACI,UAAY,CACf,CACA,AACD,uCACA,GACI,OAAU,CACb,AACD,GACI,UAAY,CACf,CACA,AACD,yCACA,oHACY,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAChC,CACA,AACD,kIACU,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,oBAAqB,AACrB,aAAe,AACf,iBAAkB,AAClB,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,0BAA2B,AAC3B,uBAAwB,AACxB,kBAAmB,AACnB,cAAgB,CACzB,AACD,yCACA,kIACc,aAAe,CAC5B,CACA,AACD,oIACY,iCAAqC,AAC7B,yBAA6B,AACrC,aAAe,CAC1B,AACD,8EACM,kBAAmB,AACnB,WAAY,AACZ,eAAgB,AAChB,igBAA6lB,AAC7lB,qUAAqZ,AACrZ,SAAU,AACV,OAAQ,AACR,iBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACvC,AACD,8FACQ,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC9C,AACD,+HACU,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,iBAAuB,AACvB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,UAAe,CACxB,AACD,iIACY,UAAe,CAC1B,AACD,gHACU,iBAAuB,AACvB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACzC,AACD,yCACA,gHACc,YAAc,CAC3B,CACA,AACD,8HACY,2BAA4B,AAC5B,6BAA+B,CAC1C,AACD,6HACY,4BAA6B,AAC7B,8BAAgC,CAC3C,AACD,yIACY,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,kBAAmB,AACnB,4IAA+J,AAC/J,eAAgB,AAChB,gBAAkB,AAClB,WAAe,AACf,0BAA4B,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,sBAAwB,AACxB,uBAA0B,AAC1B,qBAAsB,AACtB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CAC9B,AACD,yCACA,yIACgB,qCAAuC,AACvC,qCAAuC,AACvC,8BAAgC,AAChC,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAkB,AAClB,kBAAmB,AACnB,WAAY,AACZ,eAAiB,CAChC,CACA,AACD,uJACc,WAAY,AACZ,WAAa,CAC1B,AACD,wRAEc,gBAAkB,CAC/B,AACD,4IACY,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,4IAA+J,AAC/J,eAAgB,AAChB,gBAAkB,AAClB,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,WAAe,AAEf,0BAA4B,AAC5B,sBAAwB,AACxB,uBAA0B,AAC1B,qBAAsB,AACtB,0BAA2B,AAC3B,uBAAwB,AACxB,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACvC,AACD,yCACA,4IACgB,qCAAuC,AACvC,qCAAuC,AACvC,8BAAgC,AAChC,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAkB,AAClB,kBAAmB,AACnB,WAAY,AACZ,eAAiB,CAChC,CACA,AACD,6JACc,WAAY,AACZ,WAAa,CAC1B,AACD,gJACc,WAAa,CAC1B,AACD,4IACY,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,4IAA+J,AAC/J,eAAgB,AAChB,gBAAkB,AAClB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,WAAe,AAEf,0BAA4B,AAC5B,sBAAwB,AACxB,uBAA0B,AAC1B,qBAAsB,AACtB,0BAA2B,AAC3B,uBAAwB,AACxB,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACvC,AACD,yCACA,4IACgB,qCAAuC,AACvC,qCAAuC,AACvC,8BAAgC,AAChC,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAkB,AAClB,kBAAmB,AACnB,WAAY,AACZ,eAAiB,CAChC,CACA,AACD,6JACc,WAAY,AACZ,YAAa,AACb,iBAAmB,CAChC,AACD,gJACc,WAAa,CAC1B,AACD,8IACc,iBAAmB,CAChC,AACD,kHACY,cAAgB,CAC3B,AACD,+GACU,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,UAAe,CACxB,AACD,iHACY,WAAe,AACf,eAAiB,CAC5B,AACD,yCACA,iHACgB,eAAiB,CAChC,CACA,AACD,gIACY,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,iBAAoB,CAC/B,AACD,4HACY,iBAAoB,CAC/B,AACD,wHACU,kBAAmB,AACnB,UAAW,AACX,qBAAuB,AACvB,qBAAwB,AACxB,aAAc,AACd,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4IAA+J,AAC/J,kBAAoB,AACpB,eAAkB,CAC3B,AACD,qCACA,wHACc,uBAA0B,CACvC,CACA,AACD,4DACA,wHACc,mCAAsC,CACnD,CACA,AACD,4DACA,wHACc,mCAAsC,CACnD,CACA,AACD,2DACA,wHACc,mCAAsC,CACnD,CACA,AACD,qCACA,wHACc,mCAAsC,CACnD,CACA,AACD,0HACY,qBAAuB,AACvB,cAAe,AACf,kBAAoB,AACpB,eAAiB,CAC5B,AACD,0GACU,yBAA0B,AAC1B,UAAe,CACxB,AACD,8GACU,sBAA0B,AAC1B,cAAe,AACf,mCAA6C,CACtD,AACD,0GACU,kBAAmB,AACnB,gBAAuB,CAChC,AACD,yCACA,0GACc,UAAY,CACzB,CACA,AACD,yGACU,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAwB,AACxB,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,UAAe,CACxB,AACD,2GACY,gBAAiB,AACjB,WAAe,AACf,6BAA8B,AACtB,oBAAsB,CACzC,AACD,yCACA,2GACgB,eAAiB,CAChC,CACA,AACD,wBACE,kBAAmB,AACnB,iBAAmB,AACnB,kBAAmB,AACnB,QAAS,AACT,WAAY,AACZ,QAAW,AACX,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACvB,mBAAoB,AACpB,qBAAsB,AACtB,wBAAyB,AACzB,qBAAsB,AACtB,6BAA+B,CAChC,AACD,0BACA,wBACM,OAAS,CACd,CACA,AACD,yCACI,YAAa,AACb,WAAY,AACZ,kBAAmB,AACnB,gCAAqC,AACrC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,cAAgB,CACnB,AACD,0BACA,yCACQ,YAAa,AACb,UAAY,CACnB,CACA,AACD,uCACI,eAAgB,AAChB,WAAa,AACb,6BAA8B,AACtB,oBAAsB,CACjC,AACD,0BACA,uCACQ,6BAA8B,AACtB,oBAAsB,CACrC,CACA,AACD,2CACI,mBAAoB,AACpB,aAAc,AACd,WAAa,CAChB,AACD,0BACA,2CACQ,kBAAoB,CAC3B,CACA,AACD,oDACM,oBAAsB,AACtB,YAAa,AACb,aAAc,AACd,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,4BAA8B,AAM9B,oBAAqB,AACrB,qBAAsB,AACtB,0BAA2B,AAC3B,qBAAsB,AACtB,2BAA4B,AAC5B,8BAAgC,CACrC,AACD,0DACQ,kBAAmB,AACnB,WAAY,AACZ,gBAAiB,AACjB,WAAe,AACf,eAAiB,CACxB,AACD,yDACM,UAAW,AACX,uBAAwB,AACxB,kBAAmB,AACnB,8BAAgC,CACrC,AACD,kHAEM,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,0BAA2B,AAC3B,mBAAoB,AACpB,oBAAqB,AACrB,0BAA4B,CACjC,AACD,yDACM,UAAW,AACX,qBAAsB,AACtB,QAAS,AACT,SAAU,AACV,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,iBAAkB,AAClB,mBAAoB,AACpB,sBAAwB,AACxB,kBAAmB,AACnB,6BAA8B,AAC9B,gBAAiB,AACjB,iBAAkB,AAClB,mBAAoB,AACpB,oBAAqB,AACrB,0BAA2B,AAC3B,yBAA0B,AAC1B,2BAA4B,AAC5B,6BAAgC,CACrC,AACD,iDACM,oBAAsB,AACtB,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,8BAAoC,AACpC,mBAAoB,AACpB,6BAA8B,AAC9B,4BAA8B,AAC9B,0BAA2B,AAC3B,mBAAoB,AACpB,oBAAqB,AACrB,sCAA4C,AAC5C,2BAA4B,AAC5B,oCAAsC,CAC3C,AACD,sGAEM,yBAA0B,AAC1B,gCAAkC,CACvC,AACD,iDACM,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,0BAAkC,AAClC,0BAA2B,AAC3B,mBAAoB,AACpB,oBAAqB,AACrB,2BAA4B,AAC5B,iCAA0C,CAC/C,AACD,gCACA,GACI,8BAAgC,CACnC,AACD,GACI,gCAAkC,CACrC,CACA,AACD,wBACA,GACI,8BAAgC,CACnC,AACD,GACI,gCAAkC,CACrC,CACA,AACD,uDACM,qCAAsC,AACtC,iDAAkD,AAClD,6CAA+C,CACpD,AACD,kDACM,iCAAkC,AAClC,wBAA0B,CAC/B,AACD,iCACA,GACI,8BAAgC,CACnC,AACD,GACI,gCAAkC,CACrC,CACA,AACD,yBACA,GACI,8BAAgC,CACnC,AACD,GACI,gCAAkC,CACrC,CACA,AACD,wDACM,qCAAsC,AACtC,iDAAkD,AAClD,8CAA+C,AAC/C,2BAA4B,AAC5B,kBAAoB,CACzB,AACD,mCACE,SAAU,AACV,iBAAmB,CACpB,AACD,yBACA,mCACM,YAAc,CACnB,CACA,AACD,6DACI,mBAAoB,AACpB,kBAAmB,AACnB,MAAO,AACP,UAAY,CACf,AACD,yFACM,YAAc,CACnB,AACD,yCACA,yFACU,aAAe,CACxB,CACA,AACD,2GACQ,mBAAoB,AACpB,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACvC,AACD,yHACU,2BAA4B,AAC5B,6BAA+B,CACxC,AACD,wHACU,4BAA6B,AAC7B,8BAAgC,CACzC,AACD,oIACU,mBAAoB,AAChB,eAAgB,AACpB,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,kBAAmB,AACnB,4IAA+J,AAC/J,eAAgB,AAChB,gBAAkB,AAClB,WAAe,AACf,0BAA4B,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,sBAAwB,AACxB,uBAA0B,AAC1B,qBAAsB,AACtB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CAC5B,AACD,yCACA,oIACc,qCAAuC,AACvC,qCAAuC,AACvC,8BAAgC,AAChC,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAkB,AAClB,kBAAmB,AACnB,WAAY,AACZ,eAAiB,CAC9B,CACA,AACD,kJACY,WAAY,AACZ,WAAa,CACxB,AACD,8QAEY,gBAAkB,CAC7B,AACD,uIACU,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,4IAA+J,AAC/J,eAAgB,AAChB,gBAAkB,AAClB,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,WAAe,AAEf,0BAA4B,AAC5B,sBAAwB,AACxB,uBAA0B,AAC1B,qBAAsB,AACtB,0BAA2B,AAC3B,uBAAwB,AACxB,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACrC,AACD,yCACA,uIACc,qCAAuC,AACvC,qCAAuC,AACvC,8BAAgC,AAChC,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAkB,AAClB,kBAAmB,AACnB,WAAY,AACZ,eAAiB,CAC9B,CACA,AACD,wJACY,WAAY,AACZ,WAAa,CACxB,AACD,2IACY,WAAa,CACxB,AACD,uIACU,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,4IAA+J,AAC/J,eAAgB,AAChB,gBAAkB,AAClB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,WAAe,AAEf,0BAA4B,AAC5B,sBAAwB,AACxB,uBAA0B,AAC1B,qBAAsB,AACtB,0BAA2B,AAC3B,uBAAwB,AACxB,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACrC,AACD,yCACA,uIACc,qCAAuC,AACvC,qCAAuC,AACvC,8BAAgC,AAChC,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAkB,AAClB,kBAAmB,AACnB,WAAY,AACZ,eAAiB,CAC9B,CACA,AACD,wJACY,WAAY,AACZ,YAAa,AACb,iBAAmB,CAC9B,AACD,2IACY,WAAa,CACxB,AACD,yIACY,iBAAmB,CAC9B,AACD,6GACU,cAAgB,CACzB,AACD,gHACQ,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACrB,AACD,+HACU,WAAY,AACZ,4IAA+J,AAC/J,eAAgB,AAChB,gBAAiB,AACjB,0BAA4B,AAC5B,0GAAoH,AACpH,cAAe,AACf,qBAAsB,AACtB,YAAa,AACb,iBAAmB,CAC5B,AACD,iGACM,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,aAAc,AACd,sBAAwB,AACxB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,yCACA,iGACU,YAAa,AACb,mBAAoB,AAChB,cAAgB,CAC7B,CACA,AACD,qGACQ,aAAc,AACd,YAAa,AACb,oBAAqB,AAClB,iBAAkB,AACrB,kBAAoB,CAC3B,AACD,mHACQ,YAAa,AACb,aAAc,AACd,mBAAoB,AACpB,gBAAoB,AACpB,eAAgB,AAChB,WAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,eAAkB,CACzB,AACD,wHACQ,iBAAuB,AACvB,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACrB,AACD,yCACA,wHACY,YAAc,CACzB,CACA,AACD,uIACU,WAAY,AACZ,4IAA+J,AAC/J,eAAgB,AAChB,gBAAiB,AACjB,0BAA4B,AAC5B,0GAAoH,AACpH,cAAe,AACf,qBAAsB,AACtB,YAAa,AACb,iBAAmB,CAC5B,AACD,iHACQ,wBAA4B,AAC5B,eAAiB,AACjB,0BAA2B,AAC3B,4IAA+J,AAC/J,eAAiB,CACxB,AACD,yCACA,iHACY,iBAAoB,CAC/B,CACA,AACD,2GACQ,WAAe,AAOf,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,iBAAuB,AACvB,4IAA+J,AAC/J,iBAAoB,CAC3B,AACD,kOAbQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAenC,AACD,6HACY,eAAkB,CAC7B,AACD,yCACA,2GACY,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAChC,CACA,AACD,6GACU,cAAe,AACf,gBAAkB,CAC3B,AACD,4HACQ,iBAAuB,AACvB,UAAe,CACtB,AACD,gIACU,iBAAoB,CAC7B,AACD,yCACA,4HACY,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAChC,CACA,AACD,uHACQ,cAAe,AACf,gBAAuB,CAC9B,AACD,yCACA,uHACY,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAChC,CACA,AACD,sEACM,gBAAiB,AACjB,kBAAmB,AACnB,qBAAsB,AACtB,6BAA+B,AAC/B,gBAAkB,AAClB,WAAe,AACf,2IAA+J,CACpK,AACD,yEACM,iBAAoB,AACpB,kBAAoB,AACpB,gBAAiB,AACjB,cAAe,AACf,WAAe,AACf,8BAAgC,CACrC,AACD,2EACQ,aAAe,CACtB,AACD,gEACM,gBAAkB,CACvB,AACD,qCACE,eAAgB,AAChB,SAAU,AACV,aAAc,AACd,YAAa,AACb,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,WAAe,AACf,yBAA0B,AAC1B,WAAa,AACb,YAAa,AACb,WAAa,CACd,AACD,yCACA,qCACM,6BAA8B,AAC9B,YAAc,CACnB,CACA,AACD,sDACI,WAAa,CAChB,AACD,yCACA,sDACQ,WAAa,CACpB,CACA,AACD,mDACI,YAAc,CACjB,AACD,uCACI,cAAgB,CACnB,AACD,4CACI,aAAc,AACd,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,mDACI,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,2IAA+J,CAClK,AACD,wDACM,eAAgB,AAChB,cAAgB,CACrB,AACD,uDACI,eAAgB,AAChB,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,uDACI,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACrC,AACD,8BACE,kBAAmB,AACnB,qBAAsB,AACtB,iBAAmB,AACnB,yBAA0B,AAC1B,2IAA+J,CAChK,AACD,iCACE,uBAAwB,AACxB,2BAA4B,AAE5B,yBAA0B,AAG1B,sBAAuB,AAEvB,qBAAsB,AAEtB,gBAAkB,CAEnB,AACD,gCACE,kBAAmB,AACnB,aAAc,AACd,gBAAkB,CACnB,AACD,uCACE,aAAc,AACd,iBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,cAAgB,CACjB,AACD,oCACA,uCACM,aAAe,CACpB,CACA,AACD,oCACA,uCACM,WAAe,AACf,eAAkB,CACvB,CACA,AACD,kDACE,mBAAsB,CACvB,AACD,oCACA,kDACM,YAAc,CACnB,CACA,AACD,oCACA,kDACM,YAAc,CACnB,CACA,AACD,oCACA,yDACI,YAAc,CACjB,CACA,AACD,oCACA,0DACI,YAAc,CACjB,CACA,AACD,yCACE,kBAAmB,AACnB,UAAW,AACX,QAAS,AACT,gBAAoB,AACpB,uEAAiF,AACzE,+DAAyE,AACjF,iBAAmB,AACnB,iBAAmB,CACpB,AACD,wCACE,eAAgB,AAChB,iBAAmB,AACnB,kBAAoB,AACpB,oBAAuB,CACxB,AACD,iDACE,gBAAiB,AACjB,UAAe,CAChB,AACD,iDACE,UAAe,CAChB,AACD,oCACE,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,iBAAkB,AAClB,oBAAqB,AACrB,wBAA0B,CAC3B,AACD,oCACA,oCACM,gBAAkB,CACvB,CACA,AACD,iDACI,kBAAmB,AACnB,gBAAiB,AACjB,YAAc,CACjB,AACD,gEACM,YAAc,CACnB,AACD,oCACA,gEACU,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,WAAa,AACb,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,gBAAiB,AACjB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAqB,CAC9B,AACD,yEACY,yBAA2B,AAC3B,gBAAiB,AACjB,mBAAoB,AACpB,gBAAiB,AACjB,iBAAmB,CAC9B,AACD,0EACY,yBAA2B,AAC3B,iBAAkB,AAClB,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACzB,AACD,sFACY,WAAY,AACZ,uBAA0B,AAC1B,gBAAiB,AACjB,YAAa,AACb,yBAA0B,AAC1B,kBAAmB,AACnB,kBAAmB,AACnB,WAAa,AACb,qBAAsB,AACtB,eAAiB,CAC5B,AACD,sFACY,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,WAAY,AACZ,yBAA2B,AAC3B,YAAc,CACzB,CACA,AACD,4EACM,sBAAwB,AACxB,mBAAoB,AACpB,iBAAkB,AAClB,oBAAqB,AACrB,mBAAqB,CAC1B,AACD,6DACM,YAAa,AACb,WAAa,CAClB,AACD,6DACM,mBAAoB,AACpB,kBAAmB,AACnB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,aAAc,AACd,WAAa,CAClB,AACD,+EACQ,WAAY,AACZ,WAAa,CACpB,AACD,oCACA,+EACY,WAAY,AACZ,WAAa,CACxB,CACA,AACD,qCACA,6DACU,WAAY,AACZ,WAAa,CACtB,CACA,AACD,0DACI,kBAAmB,AACnB,MAAO,AACP,QAAS,AACT,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,0EACM,YAAa,AACb,WAAY,AACZ,gCAAqC,AACrC,kBAAmB,AACnB,WAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACrC,AACD,4EACQ,cAAgB,CACvB,AACD,sFACQ,YAAa,AACb,UAAY,CACnB,AACD,oCACA,0EACU,YAAa,AACb,UAAY,CACrB,AACD,4EACY,cAAgB,CAC3B,AACD,sFACY,YAAa,AACb,UAAY,CACvB,CACA,AACD,qDACI,WAAY,AACZ,6BAA8B,AAC9B,eAAkB,AAClB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,iBAAkB,AAClB,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,oCACA,qDACQ,iBAAkB,AAClB,oBAAuB,AACvB,sBAAwB,AACxB,4BAA6B,AAC7B,iBAAmB,CAC1B,CACA,AACD,uEACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAC1B,AACD,oCACA,uEACU,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACzC,CACA,AACD,mEACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAmB,AACnB,UAAa,CAClB,AACD,oCACA,mEACU,cAAgB,CACzB,CACA,AACD,yEACQ,cAAgB,CACvB,AACD,uEACQ,YAAa,AACb,UAAY,CACnB,AACD,oCACA,uEACY,WAAa,CACxB,CACA,AACD,qEACQ,cAAgB,CACvB,AACD,oCACA,qEACY,cAAgB,CAC3B,CACA,AACD,uDACM,qBAAsB,AACtB,UAAa,CAClB,AACD,oEACM,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACnB,AACD,oCACA,oEACU,YAAc,CACvB,CACA,AACD,mFACQ,uBAA0B,AAC1B,gBAAiB,AACjB,uBAAwB,AACxB,yBAA0B,AAC1B,iBAAmB,CAC1B,AACD,8EACQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAmB,AACnB,UAAa,CACpB,AACD,kFACU,YAAa,AACb,UAAY,CACrB,AACD,gFACU,cAAgB,CACzB,AACD,4CACE,YAAa,AACb,MAAO,AACP,WAAY,AACZ,eAAgB,AAChB,WAAa,AACb,yBAA0B,AAC1B,0BAA2B,AAC3B,iBAAmB,CACpB,AACD,uEACI,kBAAmB,AACnB,WAAY,AACZ,gBAAkB,AAClB,sBAA0B,AAC1B,WAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,+EACM,cAAgB,CACrB,AACD,6FACM,eAAgB,AAChB,aAAc,AACd,cAAgB,CACrB,AACD,yCACA,6FACU,eAAgB,AAChB,aAAe,CACxB,CACA,AACD,uFACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,eAAgB,AAChB,gBAAkB,AAClB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,uBAAwB,AACxB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAC1B,AACD,yGACQ,aAAe,CACtB,AACD,qCACA,yGACY,YAAc,CACzB,CACA,AACD,mGACQ,uBAAwB,AACxB,aAAe,CACtB,AACD,qFACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,2BAA4B,AACxB,wBAAyB,AACrB,oBAAsB,CACnC,AACD,0CACA,qFACU,YAAc,CACvB,CACA,AACD,8DACI,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,8EACM,aAAc,AACd,mBAAoB,AACpB,yBAA4B,CACjC,AACD,yCACA,8EACU,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACvB,CACA,AACD,oEACM,uBAA+B,CACpC,AACD,qEACQ,eAAgB,AAChB,UAAW,AACX,QAAU,CACjB,AACD,+DACI,eAAgB,AAChB,YAAc,CACjB,AACD,yCACA,+DACQ,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACrB,CACA,AACD,iFACM,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,cAAgB,CACrB,AACD,kEACI,kBAAmB,AACnB,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,oEACM,WAAa,AACb,WAAa,AACb,iBAAmB,CACxB,AACD,uEACM,SAAW,CAChB,AACD,uEACM,SAAW,CAChB,AACD,uEACM,SAAW,CAChB,AACD,uEACM,UAAY,CACjB,AACD,iDACE,aAAc,AACd,kCAAmC,AACnC,yBAA2B,CAC5B,AACD,qDACE,aAAc,AACd,uBAAwB,AACxB,YAAa,AACb,qBAAsB,AACtB,UAAa,CACd,AACD,uDACI,eAAgB,AAChB,gBAAkB,CACrB,AACD,yCACA,qDACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAkB,AAClB,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAC1B,AACD,2DACQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,2BAA4B,AACxB,wBAAyB,AACrB,qBAAsB,AAC9B,aAAe,CACtB,CACA,AACD,gCACE,eAAgB,AAChB,SAAU,AACV,eAAkB,AAClB,yBAA0B,AAC1B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,+BAAkC,AAClC,YAAa,AACb,UAAY,CACb,AACD,oCACA,gCACM,cAAkB,CACvB,CACA,AACD,sCACI,qBAAsB,AACtB,WAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,kBAAsB,CACzB,AACD,0CACM,WAAa,CAClB,AACD,oCACA,sCACQ,cAAgB,CACvB,AACD,0CACU,WAAa,CACtB,CACA,AACD,+CACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,UAAY,CACf,AACD,oCACA,+CACQ,cAAgB,CACvB,AACD,iDACU,cAAgB,CACzB,CACA,AACD,6CACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,eAAkB,AAClB,+BAAgC,AAChC,iBAAmB,CACtB,AACD,mDACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,WAAY,AACZ,eAAkB,AAClB,WAAa,AACb,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,gBAAiB,AACjB,yBAA0B,AACtB,4BAA8B,CACrC,AACD,4DACM,yBAA2B,AAC3B,gBAAiB,AACjB,gBAAiB,AACjB,eAAiB,CACtB,AACD,6DACM,yBAA2B,AAC3B,gBAAiB,AACjB,iBAAkB,AAClB,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACnB,AACD,oCACA,mDACQ,YAAc,CACrB,CACA,AACD,iDACI,kBAAmB,AACnB,kBAAmB,AACnB,yBAA0B,AAC1B,uBAA0B,AAC1B,eAAgB,AAChB,gBAAkB,AAClB,oBAAqB,AACrB,kBAAmB,AACnB,cAAe,AACf,sBAAuB,AACvB,kBAAmB,AACnB,WAAY,AACZ,qBAAsB,AACtB,2BAA4B,AAC5B,wBAAyB,AACzB,kBAAoB,CACvB,AACD,oCACA,iDACQ,eAAgB,AAChB,iBAAkB,AAClB,gBAAkB,CACzB,CACA,AACD,oCACA,iDACQ,eAAgB,AAChB,gBAAkB,CACzB,CACA,AACD,iDACI,kBAAmB,AACnB,kBAAmB,AACnB,sBAAwB,AACxB,uBAA0B,AAC1B,eAAgB,AAChB,gBAAkB,AAClB,oBAAqB,AACrB,kBAAmB,AACnB,cAAe,AACf,sBAAuB,AACvB,kBAAmB,AACnB,WAAY,AACZ,qBAAsB,AACtB,2BAA4B,AAC5B,wBAAyB,AACzB,kBAAoB,CACvB,AACD,oCACA,iDACQ,eAAgB,AAChB,gBAAkB,CACzB,CACA,AACD,oCACA,iDACQ,eAAgB,AAChB,gBAAkB,CACzB,CACA,AACD,iDACI,uBAA0B,AAC1B,eAAgB,AAChB,gBAAkB,AAClB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,kBAAmB,AACnB,kBAAmB,AACnB,iBAAkB,AAClB,kBAAmB,AACnB,2BAA4B,AAC5B,wBAAyB,AACzB,kBAAoB,CACvB,AACD,oCACA,iDACQ,eAAgB,AAChB,cAAe,AACf,iBAAkB,AAClB,iBAAmB,CAC1B,AACD,mDACU,YAAc,CACvB,CACA,AACD,oCACA,iDACQ,eAAgB,AAChB,gBAAkB,CACzB,CACA,AACD,yCACI,sBAAwB,AACxB,yBAA0B,AAC1B,aAAe,CAClB,AACD,2CACM,cAAe,AACf,cAAgB,CACrB,AACD,qCACI,yBAA0B,AAC1B,UAAa,CAChB","file":"imageDetails.vue","sourcesContent":["\n.padding-right[data-v-33f88de8] {\n  padding-right: 10px;\n}\n.fullscreen[data-v-33f88de8] {\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n.no-padding[data-v-33f88de8] {\n  padding: 0;\n}\n.logo-loader[data-v-33f88de8] {\n  position: absolute;\n  top: 50%;\n  left: 48%;\n}\n.video-container[data-v-33f88de8] {\n  height: 100%;\n  width: auto;\n}\n.feedback-speech-bubble[data-v-33f88de8] {\n  margin-left: 10px;\n}\n.v-lazy-image[data-v-33f88de8] {\n  -webkit-filter: blur(5px);\n          filter: blur(5px);\n  -webkit-transition: -webkit-filter 0.7s;\n  transition: -webkit-filter 0.7s;\n  transition: filter 0.7s;\n  transition: filter 0.7s, -webkit-filter 0.7s;\n}\n.v-lazy-image-loaded[data-v-33f88de8] {\n  -webkit-filter: blur(0);\n          filter: blur(0);\n}\npre[data-v-33f88de8] {\n  font-family: MontSerrat-Regular !important;\n}\n.video-player-youtube[data-v-33f88de8] {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  pointer-events: none !important;\n}\n.logo-color[data-v-33f88de8] {\n  color: #bd10e0;\n  font-weight: bolder;\n}\n.image-details-container[data-v-33f88de8] {\n  position: fixed;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  height: 100vh;\n  background-color: transparent;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n}\n.image-details-container .top-section[data-v-33f88de8] {\n    padding: 0;\n}\n.image-details-container .top-section .profile-detail .uploader-profile[data-v-33f88de8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      font-size: 0.929em;\n      -webkit-box-pack: end;\n          -ms-flex-pack: end;\n              justify-content: flex-end;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.image-details-container .top-section .profile-detail .uploader-profile .name[data-v-33f88de8] {\n        margin-left: 1em;\n        margin-right: 6px;\n}\n.image-details-container .top-section .profile-detail .uploader-profile .pic[data-v-33f88de8] {\n        height: 1.714em;\n        width: 1.714em;\n        -o-object-fit: cover;\n           object-fit: cover;\n        border-radius: 100%;\n        margin-bottom: 2px;\n}\n.image-details-container .nearby-images[data-v-33f88de8] {\n    position: relative;\n    padding-left: 20px;\n    padding-bottom: 5em;\n    margin-top: 1.2em !important;\n    color: rgba(255, 255, 255, 0.8);\n}\n@media screen and (min-width: 1920px) {\n.image-details-container .nearby-images[data-v-33f88de8] {\n        font-size: 1.6em !important;\n}\n}\n@media screen and (max-width: 1920px) and (min-width: 1536px) {\n.image-details-container .nearby-images[data-v-33f88de8] {\n        font-size: calc(1.6em - 15%) !important;\n}\n}\n@media screen and (max-width: 1536px) and (min-width: 1440px) {\n.image-details-container .nearby-images[data-v-33f88de8] {\n        font-size: calc(1.6em - 20%) !important;\n}\n}\n@media screen and (max-width: 1440px) and (min-width: 768px) {\n.image-details-container .nearby-images[data-v-33f88de8] {\n        font-size: calc(1.6em - 25%) !important;\n}\n}\n@media screen and (max-width: 1440px) {\n.image-details-container .nearby-images[data-v-33f88de8] {\n        font-size: calc(1.6em - 25%) !important;\n}\n}\n.image-details-container .nearby-images .scrollmenu[data-v-33f88de8] {\n      width: 100%;\n      white-space: nowrap;\n      overflow-x: scroll;\n      overflow-y: hidden;\n      -webkit-transform: translateZ(0);\n}\n.image-details-container .nearby-images .a-tag[data-v-33f88de8] {\n      padding: 14px 0 14px 0;\n      display: inline-block;\n}\n.image-details-container .nearby-images .a-tag img[data-v-33f88de8] {\n        -o-object-fit: cover;\n           object-fit: cover;\n        border-radius: 15px;\n        height: 392px;\n        width: 259px;\n}\n.footer[data-v-33f88de8] {\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), color-stop(62%, rgba(0, 0, 0, 0.61)));\n  background: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.61) 62%);\n  height: 18.740629685157423vh;\n  z-index: 200;\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding-bottom: 3.7481259370314843vh;\n}\n.footer i[data-v-33f88de8] {\n    font-size: 30px;\n}\n.google-maps-open[data-v-33f88de8] {\n  background-color: #50e3c2;\n  color: #ffffff;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  z-index: 900000000;\n  width: 250px;\n  height: 43px;\n  position: absolute;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  text-align: center;\n  bottom: 55px;\n  border-radius: 100px;\n}\n.google-maps-open .text[data-v-33f88de8] {\n    letter-spacing: 1px;\n    font-size: 14px;\n    font-weight: 700;\n}\n.filter-black[data-v-33f88de8] {\n  position: fixed;\n  z-index: 2;\n  height: 85vh;\n  width: 100vw;\n  background: -webkit-gradient(linear, left top, left bottom, from(#eeeeee), to(#d8d8d8));\n  background: linear-gradient(to bottom, #eeeeee, #d8d8d8);\n}\n.header-det[data-v-33f88de8] {\n  top: 0;\n  padding-top: 0.5em;\n  left: 0;\n  height: 7.429em;\n  background: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.61)));\n  background: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.61));\n  position: fixed;\n  width: 100vw;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  z-index: 101;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.header-det .more-vert[data-v-33f88de8] {\n    display: none;\n    margin-right: 0.7em;\n    font-size: 1.5em;\n    text-align: right;\n    color: #9b9b9b;\n}\nhr[data-v-33f88de8] {\n  border: solid 0.5px #4a4a4a;\n}\n.audio-button-sound-off[data-v-33f88de8] {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  margin-top: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border: 0.5px solid rgba(185, 185, 185, 0.5);\n  background-color: #000000;\n  border-radius: 6px;\n  cursor: pointer;\n  color: white;\n  padding: 6px;\n  height: 30px;\n}\n.audio-button-sound-off i[data-v-33f88de8] {\n    margin-left: 2px;\n}\n.audio-button-sound-off label[data-v-33f88de8] {\n    cursor: pointer;\n}\n.audio-button-sound-on[data-v-33f88de8] {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  margin-top: 10px;\n  height: 30px;\n  width: 30px;\n  padding-right: 2px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border: 0.5px solid rgba(185, 185, 185, 0.5);\n  background-color: #000000;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.video-button[data-v-33f88de8] {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  margin-top: 10px;\n  height: 30px;\n  width: 30px;\n  padding-right: 2px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border: 0.5px solid rgba(185, 185, 185, 0.5);\n  background-color: #000000;\n  border-radius: 50%;\n  cursor: pointer;\n  margin: 10px;\n}\n.video-player-buttons[data-v-33f88de8] {\n  margin-left: 20px;\n  top: 0;\n  left: 0;\n  position: absolute;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n@media (max-width: 1024px) {\n.video-player-buttons[data-v-33f88de8] {\n      display: none;\n}\n}\n.video-player-buttons-small-screen[data-v-33f88de8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  display: none;\n}\n@media (max-width: 1024px) {\n.video-player-buttons-small-screen[data-v-33f88de8] {\n      display: -webkit-inline-box;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n}\n}\n.details-container[data-v-33f88de8] {\n  position: relative;\n}\n.details-container .top-section-container[data-v-33f88de8] {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    width: 100vw;\n    z-index: 1500;\n    overflow: hidden;\n    width: 100%;\n    background-color: #000000;\n    background-size: auto 85vh;\n    background-position: center;\n}\n@media (max-width: 768px) {\n.details-container .top-section-container[data-v-33f88de8] {\n        height: 37.857em;\n}\n}\n.details-container .top-section-container .view-image[data-v-33f88de8] {\n      height: 100%;\n}\n.details-container .top-section-container .view-image-full[data-v-33f88de8] {\n      width: 100%;\n      margin-top: -10%;\n}\n@media only screen and (max-width: 768px) {\n.details-container .top-section-container .view-image-full[data-v-33f88de8] {\n          margin-top: 50px;\n}\n}\n.details-container .top-section-container .top-header-container[data-v-33f88de8] {\n      position: absolute;\n      width: 100%;\n      height: 7.429em;\n      background-image: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0)), color-stop(13%, rgba(0, 0, 0, 0.06)), color-stop(25%, rgba(0, 0, 0, 0.11)), color-stop(36%, rgba(0, 0, 0, 0.18)), color-stop(45%, rgba(0, 0, 0, 0.26)), color-stop(53%, rgba(0, 0, 0, 0.33)), color-stop(60%, rgba(0, 0, 0, 0.41)), color-stop(66%, rgba(0, 0, 0, 0.48)), color-stop(72%, rgba(0, 0, 0, 0.56)), color-stop(77%, rgba(0, 0, 0, 0.62)), color-stop(81%, rgba(0, 0, 0, 0.68)), color-stop(86%, rgba(0, 0, 0, 0.73)), color-stop(90%, rgba(0, 0, 0, 0.77)), color-stop(95%, rgba(0, 0, 0, 0.79)), to(rgba(0, 0, 0, 0.8)));\n      background-image: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.06) 13%, rgba(0, 0, 0, 0.11) 25%, rgba(0, 0, 0, 0.18) 36%, rgba(0, 0, 0, 0.26) 45%, rgba(0, 0, 0, 0.33) 53%, rgba(0, 0, 0, 0.41) 60%, rgba(0, 0, 0, 0.48) 66%, rgba(0, 0, 0, 0.56) 72%, rgba(0, 0, 0, 0.62) 77%, rgba(0, 0, 0, 0.68) 81%, rgba(0, 0, 0, 0.73) 86%, rgba(0, 0, 0, 0.77) 90%, rgba(0, 0, 0, 0.79) 95%, rgba(0, 0, 0, 0.8));\n      top: 0;\n      left: 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: start;\n          -ms-flex-align: start;\n              align-items: flex-start;\n      -webkit-box-pack: end;\n          -ms-flex-pack: end;\n              justify-content: flex-end;\n      padding: 10px;\n}\n.details-container .top-section-container .top-header-container .header-content[data-v-33f88de8] {\n        width: 100vw;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: end;\n            -ms-flex-pack: end;\n                justify-content: flex-end;\n        position: relative;\n}\n.details-container .top-section-container .top-header-container .header-content .month-duration[data-v-33f88de8] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          font-family: MontSerrat;\n          font-size: 0.6875em;\n          text-align: right;\n          color: #ffffff;\n          margin-bottom: 0.625em;\n}\n.details-container .top-section-container .top-header-container .header-content .month-duration .month-name[data-v-33f88de8] {\n            margin-right: 0.3125em;\n}\n.details-container .top-section-container .top-header-container .header-content .month-duration .dur-time[data-v-33f88de8] {\n            margin-left: 0.3125em;\n}\n.details-container .top-section-container .top-header-container .header-content .top-menu-icons[data-v-33f88de8] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n}\n@media only screen and (min-width: 768px) {\n.details-container .top-section-container .top-header-container .header-content .top-menu-icons[data-v-33f88de8] {\n              -webkit-box-flex: 1;\n                  -ms-flex-positive: 1;\n                      flex-grow: 1;\n}\n}\n.details-container .top-section-container .top-header-container .header-content .image-time-place-details[data-v-33f88de8] {\n          -webkit-box-flex: 1;\n              -ms-flex-positive: 1;\n                  flex-grow: 1;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n              -ms-flex-direction: column;\n                  flex-direction: column;\n}\n.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype[data-v-33f88de8] {\n            padding: 0.3125em 0.9375em;\n            background-color: rgba(0, 0, 0, 0.8);\n            color: #ffffff;\n            border-radius: 4px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: baseline;\n                -ms-flex-align: baseline;\n                    align-items: baseline;\n            cursor: pointer;\n            font-size: 0.75em;\n            font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif !important;\n}\n@media only screen and (min-width: 768px) and (min-width: 1920px) {\n.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype[data-v-33f88de8] {\n    font-size: 1em !important;\n}\n}\n@media only screen and (min-width: 768px) and (max-width: 1920px) and (min-width: 1536px) {\n.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype[data-v-33f88de8] {\n    font-size: calc(1em - 15%) !important;\n}\n}\n@media only screen and (min-width: 768px) and (max-width: 1536px) and (min-width: 1440px) {\n.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype[data-v-33f88de8] {\n    font-size: calc(1em - 20%) !important;\n}\n}\n@media only screen and (min-width: 768px) and (max-width: 1440px) and (min-width: 768px) {\n.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype[data-v-33f88de8] {\n    font-size: calc(1em - 25%) !important;\n}\n}\n@media only screen and (min-width: 768px) and (max-width: 1440px) {\n.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype[data-v-33f88de8] {\n    font-size: calc(1em - 25%) !important;\n}\n}\n.details-container .top-section-container .top-header-container .header-content .image-time-place-details .city-viewtype .spotTypeOthers[data-v-33f88de8] {\n              font-weight: bold;\n}\n.details-container .top-section-container .top-header-container .header-content .white-line[data-v-33f88de8] {\n          height: 1px;\n          border-radius: 2px;\n          width: 60%;\n          background-color: #ffffff;\n          margin-bottom: 5px;\n}\n@media only screen and (max-width: 768px) {\n.details-container .top-section-container .top-header-container .header-content .white-line[data-v-33f88de8] {\n              width: 100%;\n}\n}\n.details-container .top-section-container .top-header-container .header-content .image-carousal[data-v-33f88de8] {\n          position: relative;\n          margin-bottom: 0.625em;\n          width: 50%;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n.details-container .top-section-container .top-header-container .header-content .image-carousal .img-progress-bar[data-v-33f88de8] {\n            margin-left: 1px;\n            margin-right: 1px;\n            height: 2px;\n            border-radius: 3px;\n            background-color: #ffffff;\n            -webkit-animation: fill-length-data-v-33f88de8 3s linear;\n                    animation: fill-length-data-v-33f88de8 3s linear;\n}\n.details-container .top-section-container .top-header-container .header-content .image-carousal .img-progress-bar .passed[data-v-33f88de8] {\n            width: 100%;\n            background-color: #ffffff;\n}\n.details-container .top-section-container .top-header-container .header-content .image-carousal .img-progress-bar .active[data-v-33f88de8] {\n            -webkit-animation: fill-length-data-v-33f88de8 3s linear;\n                    animation: fill-length-data-v-33f88de8 3s linear;\n}\n.details-container .top-section-container .top-header-container .header-content .image-carousal .img-progress-bar-container[data-v-33f88de8] {\n            -webkit-box-flex: 1;\n                -ms-flex-positive: 1;\n                    flex-grow: 1;\n            margin-left: 1px;\n            margin-right: 1px;\n            height: 2px;\n            border-radius: 3px;\n            background-color: rgba(0, 0, 0, 0.8);\n}\n@-webkit-keyframes fill-length {\n0% {\n    width: 0%;\n}\n100% {\n    width: 100%;\n}\n}\n@keyframes fill-length-data-v-33f88de8 {\n0% {\n    width: 0%;\n}\n100% {\n    width: 100%;\n}\n}\n@media only screen and (min-width: 768px) {\n.details-container .top-section-container .top-header-container .header-content .go-back-container[data-v-33f88de8] {\n            -webkit-box-flex: 1;\n                -ms-flex-positive: 1;\n                    flex-grow: 1;\n}\n}\n.details-container .top-section-container .top-header-container .header-content .go-back-container .go-back-icon[data-v-33f88de8] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          border-radius: 100px;\n          padding: 0.5em;\n          z-index: 10000000;\n          -webkit-box-pack: start;\n              -ms-flex-pack: start;\n                  justify-content: flex-start;\n          width: -webkit-fit-content;\n          width: -moz-fit-content;\n          width: fit-content;\n          cursor: pointer;\n}\n@media only screen and (max-width: 768px) {\n.details-container .top-section-container .top-header-container .header-content .go-back-container .go-back-icon[data-v-33f88de8] {\n              display: block;\n}\n}\n.details-container .top-section-container .top-header-container .header-content .go-back-container .go-back-icon i[data-v-33f88de8] {\n            -webkit-transform: translate(21%, 0);\n                    transform: translate(21%, 0);\n            font-size: 1em;\n}\n.details-container .top-section-container .fullscreen-footer[data-v-33f88de8] {\n      position: absolute;\n      width: 100%;\n      height: 4.714em;\n      background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), color-stop(7%, rgba(0, 0, 0, 0.01)), color-stop(13%, rgba(0, 0, 0, 0.03)), color-stop(18%, rgba(0, 0, 0, 0.07)), color-stop(24%, rgba(0, 0, 0, 0.11)), color-stop(29%, rgba(0, 0, 0, 0.17)), color-stop(34%, rgba(0, 0, 0, 0.23)), color-stop(39%, rgba(0, 0, 0, 0.3)), color-stop(45%, rgba(0, 0, 0, 0.38)), color-stop(51%, rgba(0, 0, 0, 0.45)), color-stop(59%, rgba(0, 0, 0, 0.53)), color-stop(67%, rgba(0, 0, 0, 0.6)), color-stop(76%, rgba(0, 0, 0, 0.68)), color-stop(87%, rgba(0, 0, 0, 0.74)), to(rgba(0, 0, 0, 0.8)));\n      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.01) 7%, rgba(0, 0, 0, 0.03) 13%, rgba(0, 0, 0, 0.07) 18%, rgba(0, 0, 0, 0.11) 24%, rgba(0, 0, 0, 0.17) 29%, rgba(0, 0, 0, 0.23) 34%, rgba(0, 0, 0, 0.3) 39%, rgba(0, 0, 0, 0.38) 45%, rgba(0, 0, 0, 0.45) 51%, rgba(0, 0, 0, 0.53) 59%, rgba(0, 0, 0, 0.6) 67%, rgba(0, 0, 0, 0.68) 76%, rgba(0, 0, 0, 0.74) 87%, rgba(0, 0, 0, 0.8));\n      bottom: 0;\n      left: 0;\n      padding: 0.5em 1em;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      -webkit-box-pack: end;\n          -ms-flex-pack: end;\n              justify-content: flex-end;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content[data-v-33f88de8] {\n        width: 100%;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .like-share-fullscreen-container[data-v-33f88de8] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          width: calc(100vw / 3);\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          color: #ffffff;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .like-share-fullscreen-container i[data-v-33f88de8] {\n            color: #ffffff;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link[data-v-33f88de8] {\n          width: calc(100vw / 3);\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n}\n@media only screen and (max-width: 768px) {\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link[data-v-33f88de8] {\n              display: none;\n}\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link a[data-v-33f88de8]:first-child {\n            border-top-left-radius: 6px;\n            border-bottom-left-radius: 6px;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link a[data-v-33f88de8]:last-child {\n            border-top-right-radius: 6px;\n            border-bottom-right-radius: 6px;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .street-view-link-button[data-v-33f88de8] {\n            -webkit-box-flex: 1;\n                -ms-flex-positive: 1;\n                    flex-grow: 1;\n            text-align: center;\n            font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n            font-size: 12px;\n            font-weight: bold;\n            color: #ffffff;\n            border: solid 0.5px #b9b9b9;\n            -webkit-box-align: center;\n                -ms-flex-align: center;\n                    align-items: center;\n            -webkit-box-orient: vertical;\n            -webkit-box-direction: normal;\n                -ms-flex-direction: column;\n                    flex-direction: column;\n            background-color: black;\n            padding: 0.625em 0.9375em;\n            text-decoration: none;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            width: -webkit-max-content;\n            width: -moz-max-content;\n            width: max-content;\n}\n@media only screen and (max-width: 768px) {\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .street-view-link-button[data-v-33f88de8] {\n                display: -webkit-inline-box !important;\n                display: -ms-inline-flexbox !important;\n                display: inline-flex !important;\n                -webkit-box-pack: center;\n                    -ms-flex-pack: center;\n                        justify-content: center;\n                margin-left: auto;\n                margin-right: auto;\n                width: 100%;\n                margin-top: 10px;\n}\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .street-view-link-button .virtual-doll[data-v-33f88de8] {\n              width: 17px;\n              height: 20px;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .street-view-link-button img[data-v-33f88de8],\n            .details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .street-view-link-button i[data-v-33f88de8] {\n              margin-right: 7px;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-link-button[data-v-33f88de8] {\n            -webkit-box-flex: 1;\n                -ms-flex-positive: 1;\n                    flex-grow: 1;\n            font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n            font-size: 12px;\n            font-weight: bold;\n            -webkit-box-pack: end;\n                -ms-flex-pack: end;\n                    justify-content: flex-end;\n            color: #ffffff;\n            border: solid 0.5px #b9b9b9;\n            border: 0.5px solid #b9b9b9;\n            background-color: black;\n            padding: 0.625em 0.9375em;\n            text-decoration: none;\n            width: -webkit-max-content;\n            width: -moz-max-content;\n            width: max-content;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-orient: vertical;\n            -webkit-box-direction: normal;\n                -ms-flex-direction: column;\n                    flex-direction: column;\n            -webkit-box-align: center;\n                -ms-flex-align: center;\n                    align-items: center;\n}\n@media only screen and (max-width: 768px) {\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-link-button[data-v-33f88de8] {\n                display: -webkit-inline-box !important;\n                display: -ms-inline-flexbox !important;\n                display: inline-flex !important;\n                -webkit-box-pack: center;\n                    -ms-flex-pack: center;\n                        justify-content: center;\n                margin-left: auto;\n                margin-right: auto;\n                width: 100%;\n                margin-top: 10px;\n}\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-link-button .heli-view-image[data-v-33f88de8] {\n              width: 33px;\n              height: 17px;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-link-button img[data-v-33f88de8] {\n              height: 17px;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-botton-flex[data-v-33f88de8] {\n            -webkit-box-flex: 1;\n                -ms-flex-positive: 1;\n                    flex-grow: 1;\n            font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n            font-size: 12px;\n            font-weight: bold;\n            -webkit-box-pack: center;\n                -ms-flex-pack: center;\n                    justify-content: center;\n            color: #ffffff;\n            border: solid 0.5px #b9b9b9;\n            border: 0.5px solid #b9b9b9;\n            background-color: black;\n            padding: 0.625em 0.9375em;\n            text-decoration: none;\n            width: -webkit-max-content;\n            width: -moz-max-content;\n            width: max-content;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n                -ms-flex-align: center;\n                    align-items: center;\n}\n@media only screen and (max-width: 768px) {\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-botton-flex[data-v-33f88de8] {\n                display: -webkit-inline-box !important;\n                display: -ms-inline-flexbox !important;\n                display: inline-flex !important;\n                -webkit-box-pack: center;\n                    -ms-flex-pack: center;\n                        justify-content: center;\n                margin-left: auto;\n                margin-right: auto;\n                width: 100%;\n                margin-top: 10px;\n}\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-botton-flex .heli-view-image[data-v-33f88de8] {\n              width: 33px;\n              height: 17px;\n              margin-right: 12px;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-botton-flex img[data-v-33f88de8] {\n              height: 17px;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link .get-directions-botton-flex i[data-v-33f88de8] {\n              margin-right: 12px;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .street-view-link i[data-v-33f88de8] {\n            font-size: 18px;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-like[data-v-33f88de8] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: end;\n              -ms-flex-pack: end;\n                  justify-content: flex-end;\n          color: #ffffff;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-like i[data-v-33f88de8] {\n            color: #ffffff;\n            font-size: 1.7em;\n}\n@media only screen and (max-width: 768px) {\n.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-like i[data-v-33f88de8] {\n                font-size: 1.3em;\n}\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-like .likes-container[data-v-33f88de8] {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n                -ms-flex-align: center;\n                    align-items: center;\n            margin-right: 0.6em;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-like .likes-count[data-v-33f88de8] {\n            margin-right: 0.6em;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll[data-v-33f88de8] {\n          position: relative;\n          z-index: 8;\n          border-radius: 0.375em;\n          padding: 0.3em 0.9375em;\n          outline: none;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n          font-size: 0.6875em;\n          font-weight: bold;\n}\n@media screen and (min-width: 1920px) {\n.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll[data-v-33f88de8] {\n              font-size: 1em !important;\n}\n}\n@media screen and (max-width: 1920px) and (min-width: 1536px) {\n.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll[data-v-33f88de8] {\n              font-size: calc(1em - 15%) !important;\n}\n}\n@media screen and (max-width: 1536px) and (min-width: 1440px) {\n.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll[data-v-33f88de8] {\n              font-size: calc(1em - 20%) !important;\n}\n}\n@media screen and (max-width: 1440px) and (min-width: 768px) {\n.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll[data-v-33f88de8] {\n              font-size: calc(1em - 25%) !important;\n}\n}\n@media screen and (max-width: 1440px) {\n.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll[data-v-33f88de8] {\n              font-size: calc(1em - 25%) !important;\n}\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go-button-scroll i[data-v-33f88de8] {\n            z-index: 10 !important;\n            color: #f5a623;\n            padding-left: 0.7em;\n            font-size: 1.3em;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .want-to-go[data-v-33f88de8] {\n          background-color: #bd10e0;\n          color: #ffffff;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .on-travel-list[data-v-33f88de8] {\n          background-color: #000000;\n          color: #f5a623;\n          border: 0.5px solid rgba(185, 185, 185, 0.5);\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .share-like[data-v-33f88de8] {\n          position: relative;\n          width: calc(100vw / 3);\n}\n@media only screen and (max-width: 768px) {\n.details-container .top-section-container .fullscreen-footer .footer-content .share-like[data-v-33f88de8] {\n              width: auto;\n}\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .share-btn[data-v-33f88de8] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          margin-bottom: 0.9375em;\n          -webkit-box-pack: end;\n              -ms-flex-pack: end;\n                  justify-content: flex-end;\n          color: #ffffff;\n}\n.details-container .top-section-container .fullscreen-footer .footer-content .share-btn i[data-v-33f88de8] {\n            font-size: 1.7em;\n            color: #ffffff;\n            -webkit-transform: scaleX(-1);\n                    transform: scaleX(-1);\n}\n@media only screen and (max-width: 768px) {\n.details-container .top-section-container .fullscreen-footer .footer-content .share-btn i[data-v-33f88de8] {\n                font-size: 1.3em;\n}\n}\n.inner[data-v-33f88de8] {\n  overflow-x: hidden;\n  padding: 0.5em 1em;\n  position: absolute;\n  top: 42%;\n  width: 100%;\n  right: 0px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: space-between;\n}\n@media (max-width: 1024px) {\n.inner[data-v-33f88de8] {\n      top: 45%;\n}\n}\n.inner .arrow-container[data-v-33f88de8] {\n    height: 50px;\n    width: 50px;\n    border-radius: 50%;\n    background-color: rgba(0, 0, 0, 0.3);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    cursor: pointer;\n}\n@media (max-width: 1024px) {\n.inner .arrow-container[data-v-33f88de8] {\n        height: auto;\n        width: auto;\n}\n}\n.inner .arrow-buttons[data-v-33f88de8] {\n    cursor: pointer;\n    color: white;\n    -webkit-transform: scale(1.7);\n            transform: scale(1.7);\n}\n@media (max-width: 1024px) {\n.inner .arrow-buttons[data-v-33f88de8] {\n        -webkit-transform: scale(1.3);\n                transform: scale(1.3);\n}\n}\n.inner .loading-container[data-v-33f88de8] {\n    margin-right: -22px;\n    height: 100px;\n    width: 100px;\n}\n@media (max-width: 1024px) {\n.inner .loading-container[data-v-33f88de8] {\n        margin-right: -40px;\n}\n}\n.inner .loading-container .loading[data-v-33f88de8] {\n      transform: scale(0.3);\n      width: 100px;\n      height: 100px;\n      position: relative;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-transform: scale(0.3);\n      -webkit-width: 100px;\n      -webkit-height: 100px;\n      -webkit-position: relative;\n      -webkit-display: flex;\n      -webkit-align-items: center;\n      -webkit-width: 100px;\n      -webkit-height: 100px;\n      -webkit-position: relative;\n      -webkit-display: flex;\n      -webkit-align-items: center;\n      -webkit-justify-content: center;\n}\n.inner .loading-container .loading .text[data-v-33f88de8] {\n        position: absolute;\n        z-index: 20;\n        font-size: 2.5em;\n        color: #999999;\n        font-weight: 600;\n}\n.inner .loading-container .outer-shadow[data-v-33f88de8] {\n      z-index: 2;\n      background: transparent;\n      -webkit-z-index: 2;\n      -webkit-background: transparent;\n}\n.inner .loading-container .outer-shadow[data-v-33f88de8],\n    .inner .loading-container .inner-shadow[data-v-33f88de8] {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      border-radius: 100%;\n      -webkit-position: absolute;\n      -webkit-width: 100%;\n      -webkit-height: 100%;\n      -webkit-border-radius: 100%;\n}\n.inner .loading-container .inner-shadow[data-v-33f88de8] {\n      z-index: 6;\n      transform: scale(1.1);\n      top: 50%;\n      left: 50%;\n      width: 80px;\n      height: 80px;\n      margin-left: -40px;\n      margin-top: -40px;\n      border-radius: 100%;\n      background-color: black;\n      -webkit-z-index: 6;\n      -webkit-transform: scale(1.1);\n      -webkit-top: 50%;\n      -webkit-left: 50%;\n      -webkit-width: 80px;\n      -webkit-height: 80px;\n      -webkit-margin-left: -40px;\n      -webkit-margin-top: -40px;\n      -webkit-border-radius: 100%;\n      -webkit-background-color: black;\n}\n.inner .loading-container .hold[data-v-33f88de8] {\n      z-index: 0 !important;\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      clip: rect(0px, 100px, 100px, 50px);\n      border-radius: 100%;\n      background-color: transparent;\n      -webkit-z-index: 0 !important;\n      -webkit-position: absolute;\n      -webkit-width: 100%;\n      -webkit-height: 100%;\n      -webkit-clip: rect(0px, 100px, 100px, 50px);\n      -webkit-border-radius: 100%;\n      -webkit-background-color: transparent;\n}\n.inner .loading-container .fill[data-v-33f88de8],\n    .inner .loading-container .dot span[data-v-33f88de8] {\n      background-color: #9b9b9b;\n      -webkit-background-color: #9b9b9b;\n}\n.inner .loading-container .fill[data-v-33f88de8] {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      border-radius: 100%;\n      clip: rect(0px, 50px, 100px, 0px);\n      -webkit-position: absolute;\n      -webkit-width: 100%;\n      -webkit-height: 100%;\n      -webkit-border-radius: 100%;\n      -webkit-clip: rect(0px, 50px, 100px, 0px);\n}\n@keyframes left-data-v-33f88de8 {\n0% {\n    -webkit-transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(180deg);\n}\n}\n@-webkit-keyframes left {\n0% {\n    -webkit-transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(180deg);\n}\n}\n.inner .loading-container .left .fill[data-v-33f88de8] {\n      -webkit-animation-play-state: running;\n      -webkit-animation: left-data-v-33f88de8 3s linear;\n      animation: left-data-v-33f88de8 3s linear both;\n}\n.inner .loading-container .right[data-v-33f88de8] {\n      -webkit-transform: rotate(180deg);\n      transform: rotate(180deg);\n}\n@keyframes right-data-v-33f88de8 {\n0% {\n    -webkit-transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(180deg);\n}\n}\n@-webkit-keyframes right {\n0% {\n    -webkit-transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(180deg);\n}\n}\n.inner .loading-container .right .fill[data-v-33f88de8] {\n      -webkit-animation-play-state: running;\n      -webkit-animation: left-data-v-33f88de8 3s linear;\n      animation: left-data-v-33f88de8 3s linear both;\n      -webkit-animation-delay: 3s;\n      animation-delay: 3s;\n}\n.bottom-container[data-v-33f88de8] {\n  top: 85vh;\n  position: relative;\n}\n@media (max-width: 768px) {\n.bottom-container[data-v-33f88de8] {\n      top: 37.857em;\n}\n}\n.bottom-container .photographer-profile-det[data-v-33f88de8] {\n    padding-bottom: 8em;\n    position: absolute;\n    top: 0;\n    width: 100%;\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby[data-v-33f88de8] {\n      display: none;\n}\n@media only screen and (max-width: 768px) {\n.bottom-container .photographer-profile-det .mobile-street-links-nearby[data-v-33f88de8] {\n          display: block;\n}\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link[data-v-33f88de8] {\n        margin-bottom: 10px;\n        width: 100%;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link a[data-v-33f88de8]:first-child {\n          border-top-left-radius: 6px;\n          border-bottom-left-radius: 6px;\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link a[data-v-33f88de8]:last-child {\n          border-top-right-radius: 6px;\n          border-bottom-right-radius: 6px;\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .street-view-link-button[data-v-33f88de8] {\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n          -webkit-box-flex: 1;\n              -ms-flex-positive: 1;\n                  flex-grow: 1;\n          text-align: center;\n          font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n          font-size: 12px;\n          font-weight: bold;\n          color: #ffffff;\n          border: solid 0.5px #b9b9b9;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n              -ms-flex-direction: column;\n                  flex-direction: column;\n          background-color: black;\n          padding: 0.625em 0.9375em;\n          text-decoration: none;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          width: -webkit-max-content;\n          width: -moz-max-content;\n          width: max-content;\n}\n@media only screen and (max-width: 768px) {\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .street-view-link-button[data-v-33f88de8] {\n              display: -webkit-inline-box !important;\n              display: -ms-inline-flexbox !important;\n              display: inline-flex !important;\n              -webkit-box-pack: center;\n                  -ms-flex-pack: center;\n                      justify-content: center;\n              margin-left: auto;\n              margin-right: auto;\n              width: 100%;\n              margin-top: 10px;\n}\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .street-view-link-button .virtual-doll[data-v-33f88de8] {\n            width: 17px;\n            height: 20px;\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .street-view-link-button img[data-v-33f88de8],\n          .bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .street-view-link-button i[data-v-33f88de8] {\n            margin-right: 7px;\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-link-button[data-v-33f88de8] {\n          -webkit-box-flex: 1;\n              -ms-flex-positive: 1;\n                  flex-grow: 1;\n          font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n          font-size: 12px;\n          font-weight: bold;\n          -webkit-box-pack: end;\n              -ms-flex-pack: end;\n                  justify-content: flex-end;\n          color: #ffffff;\n          border: solid 0.5px #b9b9b9;\n          border: 0.5px solid #b9b9b9;\n          background-color: black;\n          padding: 0.625em 0.9375em;\n          text-decoration: none;\n          width: -webkit-max-content;\n          width: -moz-max-content;\n          width: max-content;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n              -ms-flex-direction: column;\n                  flex-direction: column;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n@media only screen and (max-width: 768px) {\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-link-button[data-v-33f88de8] {\n              display: -webkit-inline-box !important;\n              display: -ms-inline-flexbox !important;\n              display: inline-flex !important;\n              -webkit-box-pack: center;\n                  -ms-flex-pack: center;\n                      justify-content: center;\n              margin-left: auto;\n              margin-right: auto;\n              width: 100%;\n              margin-top: 10px;\n}\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-link-button .heli-view-image[data-v-33f88de8] {\n            width: 33px;\n            height: 17px;\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-link-button img[data-v-33f88de8] {\n            height: 17px;\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-botton-flex[data-v-33f88de8] {\n          -webkit-box-flex: 1;\n              -ms-flex-positive: 1;\n                  flex-grow: 1;\n          font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n          font-size: 12px;\n          font-weight: bold;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          color: #ffffff;\n          border: solid 0.5px #b9b9b9;\n          border: 0.5px solid #b9b9b9;\n          background-color: black;\n          padding: 0.625em 0.9375em;\n          text-decoration: none;\n          width: -webkit-max-content;\n          width: -moz-max-content;\n          width: max-content;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n@media only screen and (max-width: 768px) {\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-botton-flex[data-v-33f88de8] {\n              display: -webkit-inline-box !important;\n              display: -ms-inline-flexbox !important;\n              display: inline-flex !important;\n              -webkit-box-pack: center;\n                  -ms-flex-pack: center;\n                      justify-content: center;\n              margin-left: auto;\n              margin-right: auto;\n              width: 100%;\n              margin-top: 10px;\n}\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-botton-flex .heli-view-image[data-v-33f88de8] {\n            width: 33px;\n            height: 17px;\n            margin-right: 12px;\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-botton-flex img[data-v-33f88de8] {\n            height: 17px;\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link .get-directions-botton-flex i[data-v-33f88de8] {\n            margin-right: 12px;\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .street-view-link i[data-v-33f88de8] {\n          font-size: 18px;\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .nearby-and-maps-links[data-v-33f88de8] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.bottom-container .photographer-profile-det .mobile-street-links-nearby .nearby-and-maps-links .nearby-button[data-v-33f88de8] {\n          width: 100%;\n          font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n          font-size: 12px;\n          font-weight: 800;\n          border: solid 0.5px #b9b9b9;\n          background-image: -webkit-gradient(linear, left top, right top, color-stop(75%, #000000), color-stop(25%, #bd10e0));\n          color: #b9b9b9;\n          text-decoration: none;\n          padding: 8px;\n          border-radius: 6px;\n}\n.bottom-container .photographer-profile-det .photographer-profile-det-container[data-v-33f88de8] {\n      width: 100%;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      height: 2.5em;\n      margin-bottom: 0.6875em;\n      -ms-flex-wrap: nowrap;\n          flex-wrap: nowrap;\n}\n@media only screen and (max-width: 768px) {\n.bottom-container .photographer-profile-det .photographer-profile-det-container[data-v-33f88de8] {\n          height: auto;\n          -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n}\n}\n.bottom-container .photographer-profile-det .photographer-profile-det-container img[data-v-33f88de8] {\n        height: 1.5em;\n        width: 1.5em;\n        -o-object-fit: cover;\n           object-fit: cover;\n        border-radius: 100%;\n}\n.bottom-container .photographer-profile-det .photographer-profile-det-container .no-profile-image[data-v-33f88de8] {\n        width: 1.5em;\n        height: 1.5em;\n        border-radius: 100%;\n        background: #ffffff;\n        font-size: 20px;\n        color: black;\n        text-align: center;\n        line-height: 1.5em;\n        font-weight: bold;\n}\n.bottom-container .photographer-profile-det .photographer-profile-det-container .nearby-and-maps-links[data-v-33f88de8] {\n        width: calc(100vw / 3);\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n@media only screen and (max-width: 768px) {\n.bottom-container .photographer-profile-det .photographer-profile-det-container .nearby-and-maps-links[data-v-33f88de8] {\n            display: none;\n}\n}\n.bottom-container .photographer-profile-det .photographer-profile-det-container .nearby-and-maps-links .nearby-button[data-v-33f88de8] {\n          width: 100%;\n          font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n          font-size: 12px;\n          font-weight: 800;\n          border: solid 0.5px #b9b9b9;\n          background-image: -webkit-gradient(linear, left top, right top, color-stop(75%, #000000), color-stop(25%, #bd10e0));\n          color: #b9b9b9;\n          text-decoration: none;\n          padding: 8px;\n          border-radius: 6px;\n}\n.bottom-container .photographer-profile-det .photographer-profile-det-container .name-container[data-v-33f88de8] {\n        margin: auto 0.8em auto 0px;\n        font-size: 0.9em;\n        text-transform: capitalize;\n        font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-weight: 500;\n}\n@media only screen and (max-width: 768px) {\n.bottom-container .photographer-profile-det .photographer-profile-det-container .name-container[data-v-33f88de8] {\n            font-size: 0.6875em;\n}\n}\n.bottom-container .photographer-profile-det .photographer-profile-det-container .distance[data-v-33f88de8] {\n        color: #ffffff;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: end;\n            -ms-flex-pack: end;\n                justify-content: flex-end;\n        width: calc(100vw / 3);\n        font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n        font-size: 0.8125em;\n}\n.bottom-container .photographer-profile-det .photographer-profile-det-container .distance .loc-detail[data-v-33f88de8] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n.bottom-container .photographer-profile-det .photographer-profile-det-container .distance .loc-detail pre b[data-v-33f88de8] {\n            font-weight: bold;\n}\n@media only screen and (max-width: 768px) {\n.bottom-container .photographer-profile-det .photographer-profile-det-container .distance[data-v-33f88de8] {\n            -webkit-box-flex: 1;\n                -ms-flex-positive: 1;\n                    flex-grow: 1;\n}\n}\n.bottom-container .photographer-profile-det .photographer-profile-det-container .distance i[data-v-33f88de8] {\n          font-size: 1em;\n          margin-right: 5px;\n}\n.bottom-container .photographer-profile-det .photographer-profile-det-container .photographer-profile-user[data-v-33f88de8] {\n        width: calc(100vw / 3);\n        color: #ffffff;\n}\n.bottom-container .photographer-profile-det .photographer-profile-det-container .photographer-profile-user img[data-v-33f88de8] {\n          margin-right: 0.8em;\n}\n@media only screen and (max-width: 768px) {\n.bottom-container .photographer-profile-det .photographer-profile-det-container .photographer-profile-user[data-v-33f88de8] {\n            -webkit-box-flex: 1;\n                -ms-flex-positive: 1;\n                    flex-grow: 1;\n}\n}\n.bottom-container .photographer-profile-det .photographer-profile-det-container .photographer-profile[data-v-33f88de8] {\n        color: #9b9b9b;\n        width: calc(100vw / 3);\n}\n@media only screen and (max-width: 768px) {\n.bottom-container .photographer-profile-det .photographer-profile-det-container .photographer-profile[data-v-33f88de8] {\n            -webkit-box-flex: 1;\n                -ms-flex-positive: 1;\n                    flex-grow: 1;\n}\n}\n.bottom-container .photographer-profile-det .caption[data-v-33f88de8] {\n      text-align: left;\n      margin-top: 1.25em;\n      margin-bottom: 1.25em;\n      font-size: 1.1875em !important;\n      font-weight: bold;\n      color: #ffffff;\n      font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n}\n.bottom-container .photographer-profile-det .enable-loc[data-v-33f88de8] {\n      margin: 1.2em 0 0 0;\n      padding-left: 0.5em;\n      text-align: left;\n      font-size: 1em;\n      color: #ffffff;\n      font-family: MontSerrat-Regular;\n}\n.bottom-container .photographer-profile-det .enable-loc i[data-v-33f88de8] {\n        font-size: 1em;\n}\n.bottom-container .photographer-profile-det hr[data-v-33f88de8] {\n      margin-top: 1.2em;\n}\n.user-footer-bottom[data-v-33f88de8] {\n  position: fixed;\n  bottom: 0;\n  bottom: -50px;\n  width: 100vw;\n  z-index: 200;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  color: #ffffff;\n  background-color: #151515;\n  opacity: 0.8;\n  height: 50px;\n  padding: 5px;\n}\n@media only screen and (min-width: 768px) {\n.user-footer-bottom[data-v-33f88de8] {\n      background-color: transparent;\n      bottom: -50px;\n}\n}\n.user-footer-bottom .wav-icon-footer[data-v-33f88de8] {\n    height: 14px;\n}\n@media only screen and (min-width: 768px) {\n.user-footer-bottom .wav-icon-footer[data-v-33f88de8] {\n        height: 10px;\n}\n}\n.user-footer-bottom .user_account[data-v-33f88de8] {\n    width: 1.75em;\n}\n.user-footer-bottom i[data-v-33f88de8] {\n    font-size: 18px;\n}\n.user-footer-bottom button[data-v-33f88de8] {\n    outline: none;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.user-footer-bottom .footer-icons[data-v-33f88de8] {\n    cursor: pointer;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n}\n.user-footer-bottom .footer-icons span[data-v-33f88de8] {\n      font-size: 10px;\n      cursor: pointer;\n}\n.user-footer-bottom .option-container[data-v-33f88de8] {\n    cursor: pointer;\n    width: 56px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.user-footer-bottom .search-icon-text[data-v-33f88de8] {\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n}\n.near-height[data-v-33f88de8] {\n  margin-bottom: 2em;\n  padding-top: 1.0625em;\n  font-size: 0.875em;\n  background-color: #151515;\n  font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n}\n.disable-select[data-v-33f88de8] {\n  scroll-behavior: smooth;\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Chrome/Safari/Opera */\n  /* Konqueror */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version, currently supported by any browser but < IE9 */\n}\n.custom-select[data-v-33f88de8] {\n  position: relative;\n  outline: none;\n  margin-right: 1em;\n}\n.custom-select__label[data-v-33f88de8] {\n  outline: none;\n  font-size: 0.919em;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n}\n@media screen and (max-width: 600px) {\n.custom-select__label[data-v-33f88de8] {\n      color: #9b9b9b;\n}\n}\n@media screen and (min-width: 601px) {\n.custom-select__label[data-v-33f88de8] {\n      color: #ffffff;\n      font-weight: bold;\n}\n}\n.custom-select__label-down-arrow[data-v-33f88de8] {\n  padding-left: 0.313em;\n}\n@media screen and (max-width: 600px) {\n.custom-select__label-down-arrow[data-v-33f88de8] {\n      height: 1.5em;\n}\n}\n@media screen and (min-width: 601px) {\n.custom-select__label-down-arrow[data-v-33f88de8] {\n      height: 1.1em;\n}\n}\n@media screen and (min-width: 601px) {\n.custom-select__label-down-arrow_mobile[data-v-33f88de8] {\n    display: none;\n}\n}\n@media screen and (max-width: 600px) {\n.custom-select__label-down-arrow_desktop[data-v-33f88de8] {\n    display: none;\n}\n}\n.custom-select__options[data-v-33f88de8] {\n  position: absolute;\n  top: 1.5em;\n  right: 0;\n  background: #ffffff;\n  -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);\n          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);\n  padding: 0.7em 1em;\n  border-radius: 8px;\n}\n.custom-select__option[data-v-33f88de8] {\n  cursor: pointer;\n  font-size: 0.818em;\n  padding-top: 0.05em;\n  padding-bottom: 0.05em;\n}\n.custom-select__option_selected[data-v-33f88de8] {\n  font-weight: 500;\n  color: #333333;\n}\n.custom-select__option_disabled[data-v-33f88de8] {\n  color: #999999;\n}\n.media-top-section[data-v-33f88de8] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding-top: 90px;\n  padding-bottom: 90px;\n  background-color: #151515;\n}\n@media screen and (max-width: 768px) {\n.media-top-section[data-v-33f88de8] {\n      padding-top: 60px;\n}\n}\n.media-top-section .top-section[data-v-33f88de8] {\n    position: relative;\n    overflow: hidden;\n    padding: 10px;\n}\n.media-top-section .top-section .photo-details[data-v-33f88de8] {\n      display: none;\n}\n@media screen and (max-width: 768px) {\n.media-top-section .top-section .photo-details[data-v-33f88de8] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n              -ms-flex-direction: column;\n                  flex-direction: column;\n          color: white;\n          -webkit-box-flex: 1;\n              -ms-flex-positive: 1;\n                  flex-grow: 1;\n          text-align: left;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          padding-bottom: 20px;\n}\n.media-top-section .top-section .photo-details .caption[data-v-33f88de8] {\n            font-size: 14px !important;\n            font-weight: 600;\n            margin-bottom: 10px;\n            line-height: 1.2;\n            text-align: center;\n}\n.media-top-section .top-section .photo-details .location[data-v-33f88de8] {\n            font-size: 11px !important;\n            line-height: 1.03;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n}\n.media-top-section .top-section .photo-details .nearby-button-mobile[data-v-33f88de8] {\n            width: 100%;\n            font-family: \"MontSerrat\";\n            font-weight: 700;\n            padding: 8px;\n            background-color: #5b5b5b;\n            border-radius: 6px;\n            text-align: center;\n            color: white;\n            text-decoration: none;\n            margin-top: 10px;\n}\n.media-top-section .top-section .photo-details .photographer-details[data-v-33f88de8] {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-pack: justify;\n                -ms-flex-pack: justify;\n                    justify-content: space-between;\n            width: 100%;\n            font-size: 10px !important;\n            padding: 16px;\n}\n}\n.media-top-section .top-section .photo-details-description[data-v-33f88de8] {\n      background-color: black;\n      border-radius: 10px;\n      padding-top: 10px;\n      padding-bottom: 20px;\n      margin-bottom: -10px;\n}\n.media-top-section .top-section .video-card[data-v-33f88de8] {\n      width: 100vw;\n      height: 65vh;\n}\n.media-top-section .top-section .image-card[data-v-33f88de8] {\n      border-radius: 12px;\n      position: relative;\n      overflow: hidden;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      width: 1130px;\n      height: 65vh;\n}\n.media-top-section .top-section .image-card .image-card-image[data-v-33f88de8] {\n        width: 100%;\n        height: auto;\n}\n@media screen and (max-width: 768px) {\n.media-top-section .top-section .image-card .image-card-image[data-v-33f88de8] {\n            width: auto;\n            height: 100%;\n}\n}\n@media screen and (max-width: 1130px) {\n.media-top-section .top-section .image-card[data-v-33f88de8] {\n          width: 100%;\n          height: 47vh;\n}\n}\n.media-top-section .like-share-container[data-v-33f88de8] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 20px 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.media-top-section .like-share-container .icon-container[data-v-33f88de8] {\n      height: 45px;\n      width: 45px;\n      background-color: rgba(0, 0, 0, 0.5);\n      border-radius: 50%;\n      color: white;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.media-top-section .like-share-container .icon-container i[data-v-33f88de8] {\n        font-size: 30px;\n}\n.media-top-section .like-share-container .icon-container .share-icon[data-v-33f88de8] {\n        height: 30px;\n        width: 30px;\n}\n@media screen and (max-width: 768px) {\n.media-top-section .like-share-container .icon-container[data-v-33f88de8] {\n          height: 30px;\n          width: 30px;\n}\n.media-top-section .like-share-container .icon-container i[data-v-33f88de8] {\n            font-size: 18px;\n}\n.media-top-section .like-share-container .icon-container .share-icon[data-v-33f88de8] {\n            height: 18px;\n            width: 18px;\n}\n}\n.media-top-section .control-section[data-v-33f88de8] {\n    width: 100%;\n    background-color: transparent;\n    padding: 22px 0px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    max-width: 1130px;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n@media screen and (max-width: 768px) {\n.media-top-section .control-section[data-v-33f88de8] {\n        margin-top: -10px;\n        padding: 20px 0 10px 0;\n        background-color: black;\n        border-radius: 0 0 10px 10px;\n        margin-bottom: 5px;\n}\n}\n.media-top-section .control-section .location-details[data-v-33f88de8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n}\n@media screen and (max-width: 768px) {\n.media-top-section .control-section .location-details[data-v-33f88de8] {\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n}\n}\n.media-top-section .control-section .control-item[data-v-33f88de8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      margin-right: 20px;\n      color: white;\n}\n@media screen and (max-width: 768px) {\n.media-top-section .control-section .control-item[data-v-33f88de8] {\n          font-size: 11px;\n}\n}\n.media-top-section .control-section .control-item label[data-v-33f88de8] {\n        cursor: pointer;\n}\n.media-top-section .control-section .control-item img[data-v-33f88de8] {\n        height: 36px;\n        width: auto;\n}\n@media screen and (max-width: 768px) {\n.media-top-section .control-section .control-item img[data-v-33f88de8] {\n            height: 20px;\n}\n}\n.media-top-section .control-section .control-item i[data-v-33f88de8] {\n        font-size: 36px;\n}\n@media screen and (max-width: 768px) {\n.media-top-section .control-section .control-item i[data-v-33f88de8] {\n            font-size: 20px;\n}\n}\n.media-top-section .control-section a[data-v-33f88de8] {\n      text-decoration: none;\n      color: white;\n}\n.media-top-section .control-section .nearby-places[data-v-33f88de8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n@media screen and (max-width: 768px) {\n.media-top-section .control-section .nearby-places[data-v-33f88de8] {\n          display: none;\n}\n}\n.media-top-section .control-section .nearby-places .nearby-button[data-v-33f88de8] {\n        font-family: \"MontSerrat\";\n        font-weight: 700;\n        padding: 1.25rem 4.5rem;\n        background-color: #5b5b5b;\n        border-radius: 6px;\n}\n.media-top-section .control-section .nearby-places .feedback[data-v-33f88de8] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-right: 20px;\n        color: white;\n}\n.media-top-section .control-section .nearby-places .feedback img[data-v-33f88de8] {\n          height: 25px;\n          width: auto;\n}\n.media-top-section .control-section .nearby-places .feedback i[data-v-33f88de8] {\n          font-size: 36px;\n}\n.search-top-city-container[data-v-33f88de8] {\n  z-index: 999;\n  top: 0;\n  width: 100%;\n  position: fixed;\n  color: white;\n  background-color: #2c2c2c;\n  -webkit-transition: top 1s;\n  transition: top 1s;\n}\n.search-top-city-container .toolbar-content-container[data-v-33f88de8] {\n    position: relative;\n    width: 100%;\n    padding: 0.625rem;\n    background-color: #000000;\n    color: white;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.search-top-city-container .toolbar-content-container .cursor[data-v-33f88de8] {\n      cursor: pointer;\n}\n.search-top-city-container .toolbar-content-container .fullscreen-mode-text[data-v-33f88de8] {\n      font-size: 11px;\n      display: none;\n      cursor: pointer;\n}\n@media only screen and (max-width: 768px) {\n.search-top-city-container .toolbar-content-container .fullscreen-mode-text[data-v-33f88de8] {\n          font-size: 11px;\n          display: block;\n}\n}\n.search-top-city-container .toolbar-content-container .list-view-text[data-v-33f88de8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      font-size: 16px;\n      font-weight: bold;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      font-family: MontSerrat;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n}\n.search-top-city-container .toolbar-content-container .list-view-text .search-component[data-v-33f88de8] {\n        display: block;\n}\n@media screen and (max-width: 1024px) {\n.search-top-city-container .toolbar-content-container .list-view-text .search-component[data-v-33f88de8] {\n            display: none;\n}\n}\n.search-top-city-container .toolbar-content-container .list-view-text .logo-color[data-v-33f88de8] {\n        font-family: MontSerrat;\n        color: #bd10e0;\n}\n.search-top-city-container .toolbar-content-container .heading-text[data-v-33f88de8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: baseline;\n          -ms-flex-align: baseline;\n              align-items: baseline;\n}\n@media only screen and (min-width: 1024px) {\n.search-top-city-container .toolbar-content-container .heading-text[data-v-33f88de8] {\n          display: none;\n}\n}\n.search-top-city-container .header-section-3[data-v-33f88de8] {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.search-top-city-container .header-section-3 .pill-container[data-v-33f88de8] {\n      display: none;\n      border-radius: 2rem;\n      border: 0.5px solid #b9b9b9;\n}\n@media only screen and (min-width: 768px) {\n.search-top-city-container .header-section-3 .pill-container[data-v-33f88de8] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n}\n.search-top-city-container .header-section-3 .pill[data-v-33f88de8] {\n      padding: 1rem 2rem 0.4rem 2rem;\n}\n.search-top-city-container .header-section-3 .pill *[data-v-33f88de8] {\n        cursor: pointer;\n        padding: 0;\n        margin: 0;\n}\n.search-top-city-container .pills-description[data-v-33f88de8] {\n    margin-top: 5px;\n    display: none;\n}\n@media only screen and (min-width: 768px) {\n.search-top-city-container .pills-description[data-v-33f88de8] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n}\n.search-top-city-container .pills-description .description-item[data-v-33f88de8] {\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n      font-size: 12px;\n}\n.search-top-city-container .search-city-relative[data-v-33f88de8] {\n    position: relative;\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.search-top-city-container .search-city-relative i[data-v-33f88de8] {\n      opacity: 0.6;\n      color: white;\n      font-size: 1.286em;\n}\n.search-top-city-container .search-city-relative .i-1[data-v-33f88de8] {\n      left: 20px;\n}\n.search-top-city-container .search-city-relative .i-2[data-v-33f88de8] {\n      left: 65px;\n}\n.search-top-city-container .search-city-relative .i-3[data-v-33f88de8] {\n      right: 3em;\n}\n.search-top-city-container .search-city-relative .i-4[data-v-33f88de8] {\n      right: 22px;\n}\n.search-top-city-container-hide[data-v-33f88de8] {\n  display: none;\n  -webkit-transition: top 2s ease 0s;\n  transition: top 2s ease 0s;\n}\n.go-back-icon-and-fullscreen-mobile[data-v-33f88de8] {\n  display: none;\n  font-family: Montserrat;\n  padding: 3px;\n  text-decoration: none;\n  color: white;\n}\n.go-back-icon-and-fullscreen-mobile i[data-v-33f88de8] {\n    font-size: 12px;\n    margin-right: 5px;\n}\n@media only screen and (min-width: 768px) {\n.go-back-icon-and-fullscreen-mobile[data-v-33f88de8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      font-weight: bold;\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n}\n.go-back-icon-and-fullscreen-mobile .logo[data-v-33f88de8] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: baseline;\n            -ms-flex-align: baseline;\n                align-items: baseline;\n        color: #bd10e0;\n}\n}\n.sticky-footer[data-v-33f88de8] {\n  position: fixed;\n  bottom: 0;\n  padding: 15px 0px;\n  background-color: #d9d9d9;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-family: \"MontSerrat-Regular\";\n  z-index: 999;\n  width: 100%;\n}\n@media screen and (max-width: 786px) {\n.sticky-footer[data-v-33f88de8] {\n      padding: 10px 0px;\n}\n}\n.sticky-footer .logo[data-v-33f88de8] {\n    text-decoration: none;\n    color: black;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    padding: 0px 10px 0 0;\n}\n.sticky-footer .logo img[data-v-33f88de8] {\n      height: 18px;\n}\n@media screen and (max-width: 786px) {\n.sticky-footer .logo[data-v-33f88de8] {\n        font-size: 11px;\n}\n.sticky-footer .logo img[data-v-33f88de8] {\n          height: 14px;\n}\n}\n.sticky-footer .list-view-btn[data-v-33f88de8] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    color: #000;\n}\n@media screen and (max-width: 768px) {\n.sticky-footer .list-view-btn[data-v-33f88de8] {\n        font-size: 11px;\n}\n.sticky-footer .list-view-btn i[data-v-33f88de8] {\n          font-size: 18px;\n}\n}\n.sticky-footer .navigations[data-v-33f88de8] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 0px 20px;\n    border-right: 1px solid #979797;\n    margin-right: 10px;\n}\n.sticky-footer .photo-description[data-v-33f88de8] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    width: 100%;\n    padding: 0px 20px;\n    color: black;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    text-align: left;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n}\n.sticky-footer .photo-description .caption[data-v-33f88de8] {\n      font-size: 24px !important;\n      font-weight: 600;\n      line-height: 1.2;\n      max-width: 600px;\n}\n.sticky-footer .photo-description .location[data-v-33f88de8] {\n      font-size: 18px !important;\n      font-weight: 600;\n      line-height: 1.03;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n@media screen and (max-width: 786px) {\n.sticky-footer .photo-description[data-v-33f88de8] {\n        display: none;\n}\n}\n.sticky-footer .check-price-btn[data-v-33f88de8] {\n    padding: 12px 30px;\n    border-radius: 4px;\n    background-color: #655fff;\n    font-family: \"Montserrat\";\n    font-size: 14px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 2;\n    letter-spacing: normal;\n    text-align: center;\n    color: #fff;\n    text-decoration: none;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n}\n@media screen and (max-width: 768px) {\n.sticky-footer .check-price-btn[data-v-33f88de8] {\n        font-size: 12px;\n        padding: 4px 16px;\n        margin-left: auto;\n}\n}\n@media screen and (max-width: 360px) {\n.sticky-footer .check-price-btn[data-v-33f88de8] {\n        font-size: 10px;\n        margin-left: auto;\n}\n}\n.sticky-footer .read-review-btn[data-v-33f88de8] {\n    padding: 12px 30px;\n    border-radius: 4px;\n    background-color: black;\n    font-family: \"Montserrat\";\n    font-size: 14px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 2;\n    letter-spacing: normal;\n    text-align: center;\n    color: #fff;\n    text-decoration: none;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n}\n@media screen and (max-width: 768px) {\n.sticky-footer .read-review-btn[data-v-33f88de8] {\n        font-size: 12px;\n        padding: 4px 16px;\n}\n}\n@media screen and (max-width: 360px) {\n.sticky-footer .read-review-btn[data-v-33f88de8] {\n        font-size: 10px;\n        margin-left: auto;\n}\n}\n.sticky-footer .travel-list-btn[data-v-33f88de8] {\n    font-family: \"Montserrat\";\n    font-size: 14px;\n    font-weight: bold;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    padding: 14px 30px;\n    border-radius: 4px;\n    margin-left: 10px;\n    margin-right: 20px;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n}\n@media screen and (max-width: 768px) {\n.sticky-footer .travel-list-btn[data-v-33f88de8] {\n        font-size: 12px;\n        line-height: 2;\n        padding: 4px 16px;\n        margin-right: 15px;\n}\n.sticky-footer .travel-list-btn i[data-v-33f88de8] {\n          display: none;\n}\n}\n@media screen and (max-width: 360px) {\n.sticky-footer .travel-list-btn[data-v-33f88de8] {\n        font-size: 10px;\n        margin-left: auto;\n}\n}\n.sticky-footer .checked[data-v-33f88de8] {\n    background-color: black;\n    border: 1px solid #f5a623;\n    color: #f5a623;\n}\n.sticky-footer .checked i[data-v-33f88de8] {\n      color: #f5a623;\n      font-size: 12px;\n}\n.sticky-footer .add[data-v-33f88de8] {\n    background-color: #bd10e0;\n    color: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".quoteText{font-size:18px}.quoteAuthor,.quoteText{font-family:MontSerrat-Regular;color:#fff}.quoteAuthor{font-size:16px;font-weight:500}.loader-new{height:280px;width:550px;padding:10px;-webkit-transform:translate(25%);transform:translate(25%)}.loader-new .container{width:100%}.loader-new .container,.loader-new .container .loader-icon{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%}.loader-new .container .loader-icon{-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-right:25px}.loader-new .container .loader-quote{color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:left;padding-left:25px}.loader-new .container .line{width:2px;background-color:#fff;height:100%}@media only screen and (max-width:768px){.loader-new{height:auto;max-width:280px;-webkit-transform:translate(0);transform:translate(0)}.loader-new .container{-ms-flex-wrap:wrap;flex-wrap:wrap;height:auto}.loader-new .container .loader-icon{width:100%;height:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-right:0;padding-bottom:25px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.loader-new .container .loader-quote{height:auto;width:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:center;padding-left:0;padding-top:15px}.loader-new .container .line{height:2px;width:100%;background-color:#fff}}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/loader.vue"],"names":[],"mappings":"AACA,WAEE,cAAgB,CAEjB,AACD,wBAJE,+BAAkC,AAElC,UAAe,CAOhB,AALD,aAEE,eAAgB,AAChB,eAAiB,CAElB,AACD,YACE,aAAc,AACd,YAAa,AACb,aAAc,AACd,iCAAkC,AAC1B,wBAA0B,CACnC,AACD,uBAKI,UAAY,CACf,AACD,2DANI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,WAAa,CAYhB,AATD,oCAKM,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAoB,CACzB,AACD,qCACM,WAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,YAAa,AACb,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,gBAAiB,AACjB,iBAAmB,CACxB,AACD,6BAEM,UAAW,AACX,sBAAwB,AACxB,WAAa,CAClB,AACD,yCACA,YACM,YAAa,AACb,gBAAiB,AACjB,+BAAgC,AACxB,sBAAwB,CACrC,AACD,uBACQ,mBAAoB,AAChB,eAAgB,AACpB,WAAa,CACpB,AACD,oCACU,WAAY,AACZ,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAmB,AACnB,oBAAqB,AACrB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACzC,AACD,qCACU,YAAa,AACb,WAAY,AACZ,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,kBAAmB,AACnB,eAAkB,AAClB,gBAAkB,CAC3B,AACD,6BACU,WAAY,AACZ,WAAY,AACZ,qBAAwB,CACjC,CACA","file":"loader.vue","sourcesContent":["\n.quoteText {\n  font-family: \"MontSerrat-Regular\";\n  font-size: 18px;\n  color: #ffffff;\n}\n.quoteAuthor {\n  font-family: \"MontSerrat-Regular\";\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n}\n.loader-new {\n  height: 280px;\n  width: 550px;\n  padding: 10px;\n  -webkit-transform: translate(25%);\n          transform: translate(25%);\n}\n.loader-new .container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 100%;\n    width: 100%;\n}\n.loader-new .container .loader-icon {\n      height: 100%;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      padding-right: 25px;\n}\n.loader-new .container .loader-quote {\n      color: white;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      height: 100%;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      text-align: left;\n      padding-left: 25px;\n}\n.loader-new .container .line {\n      height: 100%;\n      width: 2px;\n      background-color: white;\n      height: 100%;\n}\n@media only screen and (max-width: 768px) {\n.loader-new {\n      height: auto;\n      max-width: 280px;\n      -webkit-transform: translate(0);\n              transform: translate(0);\n}\n.loader-new .container {\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n        height: auto;\n}\n.loader-new .container .loader-icon {\n          width: 100%;\n          height: auto;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          padding-right: 0px;\n          padding-bottom: 25px;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n}\n.loader-new .container .loader-quote {\n          height: auto;\n          width: 100%;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n              -ms-flex-direction: column;\n                  flex-direction: column;\n          text-align: center;\n          padding-left: 0px;\n          padding-top: 15px;\n}\n.loader-new .container .line {\n          height: 2px;\n          width: 100%;\n          background-color: white;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(658);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("4b7e3a8a", content, true, {});

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(670);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("3475195a", content, true, {});

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(672);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("0f4fd49a", content, true, {});

/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(679)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(825),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-045f387e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 822:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(693)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(841),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 825:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slideShowContainer",
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        return _vm.keyboardLeftClick($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
        if ('button' in $event && $event.button !== 2) { return null; }
        return _vm.keyboardRightClick($event)
      }]
    }
  }, [_c('div', {
    staticClass: "header pointer"
  }, [_c('span', {
    staticClass: "close-btn pointer",
    on: {
      "click": this.$props.toggleSlideShow
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")]), _c('label', {
    staticClass: "pl-1"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white",
      "width": "33.33%"
    }
  }, [_vm._v(_vm._s(_vm.currentIndex + 1 + " / " + this.$props.imageArray.length))]), _vm._v(" "), _c('div', {
    staticClass: "like-share-container"
  }, [_c('div', {
    staticClass: "icon-container pointer",
    on: {
      "click": _vm.addLike
    }
  }, [_c('i', {
    staticClass: "material-icons",
    style: (_vm.getImageDescription.isLiked ? 'color:#ff0000' : '')
  }, [_vm._v(_vm._s(_vm.getImageDescription.isLiked ? "favorite" : "favorite_outline"))])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container ml-2 pointer",
    on: {
      "click": function($event) {
        return _vm.share(
          _vm.getImageDescription.photoId,
          _vm.getImageDescription.caption === '' ?
          'n' :
          _vm.getImageDescription.caption
        )
      }
    }
  }, [_c('img', {
    staticClass: "share-icon",
    attrs: {
      "src": "/static/img/ic-reply.svg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-container"
  }, [_c('v-carousel', {
    attrs: {
      "hide-delimiters": "",
      "height": _vm.screenW >= 800 ? 'auto' : 400,
      "cycle": false
    },
    model: {
      value: (_vm.currentIndex),
      callback: function($$v) {
        _vm.currentIndex = $$v
      },
      expression: "currentIndex"
    }
  }, _vm._l((this.$props.imageArray), function(item, i) {
    return _c('v-carousel-item', {
      key: i,
      attrs: {
        "lazy": true
      }
    }, [_c('div', [_c('img', {
      staticClass: "slide-image",
      attrs: {
        "src": _vm.listviewImage(("" + (item.photoId)), item),
        "alt": "image",
        "width": "auto"
      }
    })])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "photo-description"
  }, [_c('div', {
    staticClass: "photographer-profile-det-container"
  }, [_c('div', {
    class: _vm.getImageDescription.uploader !== 'admin' ?
      'pointer photographer-profile-user' :
      'photographer-profile',
    staticStyle: {
      "display": "flex"
    }
  }, [(_vm.getImageDescription.uploader !== 'admin') ? _c('img', {
    attrs: {
      "src": _vm.getImageDescription.mediaSourceInformation.photoGrapherPic,
      "alt": "profile-photo"
    },
    on: {
      "click": function($event) {
        _vm.getImageDescription.uploader !== 'admin' ?
          _vm.$router.push(
            ("/profile?selected_tab=checkins&profile_id=" + (_vm.getImageDescription.mediaSourceInformation.photoGrapherId))
          ) :
          ''
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "name-container text-xs-left"
  }, [_c('div', [_c('span', {
    on: {
      "click": function($event) {
        _vm.getImageDescription.uploader !== 'admin' ?
          _vm.$router.push(
            ("/profile?selected_tab=checkins&profile_id=" + (_vm.getImageDescription.mediaSourceInformation.photoGrapherId))
          ) :
          ''
      }
    }
  }, [_vm._v(_vm._s(_vm.getImageDescription.mediaSourceInformation.photoGrapherName))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.$modal.show('license-modal')
      }
    }
  }, [_vm._v("©")])])])])]), _vm._v(" "), _c('label', {
    staticClass: "photo-caption"
  }, [_vm._v(_vm._s(_vm.getImageDescription.caption))])])])
},staticRenderFns: []}

/***/ }),

/***/ 839:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.pageLoader) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.top_sectionArr[_vm.current_top_index]) ? _c('div', [(_vm.showSlideShow) ? _c('slideShow', {
    attrs: {
      "toggleSlideShow": _vm.closeSlideShow,
      "imageArray": _vm.top_sectionArr
    },
    on: {
      "like": _vm.changeCnt
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.fullScreen) ? _c('div', {
    staticClass: "search-top-city-container",
    attrs: {
      "id": "sticky-search-bar"
    }
  }, [_c('div', {
    staticClass: "toolbar-content-container"
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('a', {
    staticClass: "go-back-icon-and-fullscreen-mobile",
    attrs: {
      "href": "https://www.withaview.co"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.filterViewType))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "list-view-text",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "search-component"
  }, [_c('searchContainer')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "header-section-3"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    },
    on: {
      "click": function($event) {
        _vm.isLoggedIn
          ?
          _vm.$router.push({
            path: '/profile',
            query: {
              profile_Id: _vm.user.uid,
              selected_tab: 'checkins',
            },
          }) :
          _vm.$router.push("/login")
      }
    }
  }, [_c('div', {
    staticClass: "pill-container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "0.5px solid #b6b6b6",
      "width": "1px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pill pointer"
  }, [(!_vm.isLoggedIn && this.screenW < 600) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")]) : _vm._e(), _vm._v(" "), (!_vm.isLoggedIn && this.screenW > 600) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("perm_identity")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('img', {
    staticStyle: {
      "height": "1.75rem",
      "width": "1.75rem",
      "border-radius": "100%"
    },
    attrs: {
      "src": this.$store.state.auth.user.photoURL
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "pills-description"
  }, [_c('label', {
    staticClass: "description-item pointer",
    on: {
      "click": function($event) {
        _vm.isLoggedIn
          ?
          _vm.$router.push({
            path: '/profile',
            query: {
              profile_Id: _vm.user.uid,
              selected_tab: 'checkins',
            },
          }) :
          _vm.$router.push("/login")
      }
    }
  }, [_vm._v("Travel list")]), _vm._v(" "), _c('label', {
    staticClass: "description-item pointer",
    on: {
      "click": function($event) {
        _vm.isLoggedIn
          ?
          _vm.$router.push({
            path: '/profile',
            query: {
              profile_Id: _vm.user.uid,
              selected_tab: 'checkins',
            },
          }) :
          _vm.$router.push("/login")
      }
    }
  }, [_vm._v("Profile")])])])])])]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.imageInfo).length !== 0) ? _c('div', {
    staticClass: "disable-select"
  }, [_c('div', [_c('div', {
    staticClass: "image-details-container",
    attrs: {
      "id": "image-details-container"
    },
    on: {
      "scroll": _vm.getScrollPos
    }
  }, [_c('div', {
    staticClass: "media-top-section"
  }, [_c('div', {
    staticClass: "top-section"
  }, [_c('span', {
    staticClass: "photo-details photo-details-description"
  }, [_c('span', {
    staticClass: "caption"
  }, [_vm._v("\n                    " + _vm._s(this.top_sectionArr[_vm.current_top_index].caption ?
    this.top_sectionArr[_vm.current_top_index].caption :
    "") + "\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_c('pre', {
    class: _vm.getSpotType(_vm.top_sectionArr[_vm.current_top_index]) == 'Spot' ?
      'spotTypeSpot' :
      'spotTypeOthers'
  }, [_vm._v(_vm._s(_vm.getSpotType(_vm.top_sectionArr[_vm.current_top_index])) + " ")]), _vm._v(" "), (_vm.top_sectionArr[_vm.current_top_index].hasGeohash) ? _c('pre', [_vm._v("in " + _vm._s(_vm.getCity(_vm.top_sectionArr[_vm.current_top_index])))]) : _vm._e()])]), _vm._v(" "), (
    _vm.top_sectionArr[_vm.current_top_index].resourceType === 'image'
  ) ? _c('div', {
    staticClass: "image-card pointer",
    on: {
      "click": function($event) {
        _vm.showSlideShow = !_vm.showSlideShow
      }
    }
  }, [(_vm.imgLoader) ? _c('img', {
    staticClass: "logo-loader",
    attrs: {
      "src": "/static/img/loader/loading-viewZzz.svg",
      "height": "70px",
      "width": "70px"
    }
  }) : _vm._e(), _vm._v(" "), (
    !_vm.fullScreen &&
    this.top_sectionArr[_vm.current_top_index].resourceType ===
    'image'
  ) ? _c('img', {
    staticClass: "image-card-image",
    attrs: {
      "src": _vm.getImageBackground(
        this.top_sectionArr[_vm.current_top_index].photoId,
        this.screenH,
        this.screenW,
        this.top_sectionArr[_vm.current_top_index],
        _vm.top_sectionArr[_vm.current_top_index].keywords.includes(
          'extabs'
        )
      )
    },
    on: {
      "load": function($event) {
        _vm.imgLoader = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.top_sectionArr.length > 1 &&
        _vm.top_sectionArr[0].resourceType === 'image'
      ),
      expression: "\n                        top_sectionArr.length > 1 &&\n                        top_sectionArr[0].resourceType === 'image'\n                      "
    }],
    staticClass: "arrow-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.restartAnim('desc')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons arrow-buttons"
  }, [_vm._v("keyboard_arrow_left")])]), _vm._v(" "), (!_vm.fullScreen) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.top_sectionArr.length > 1 &&
        _vm.top_sectionArr[0].resourceType === 'image'
      ),
      expression: "\n                        top_sectionArr.length > 1 &&\n                        top_sectionArr[0].resourceType === 'image'\n                      "
    }],
    staticClass: "arrow-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.restartAnim('inc')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons arrow-buttons"
  }, [_vm._v("keyboard_arrow_right")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "like-share-container"
  }, [_c('div', {
    staticClass: "icon-container pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeCnt(_vm.top_sectionArr[_vm.current_top_index], false)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons",
    style: (_vm.top_sectionArr[_vm.current_top_index].isLiked ?
      'color:#ff0000' :
      '')
  }, [_vm._v(_vm._s(_vm.top_sectionArr[_vm.current_top_index].isLiked ?
    "favorite" :
    "favorite_outline"))])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container ml-2 pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.share(
          _vm.top_sectionArr[_vm.current_top_index].photoId,
          _vm.top_sectionArr[_vm.current_top_index].caption === '' ?
          'n' :
          _vm.top_sectionArr[_vm.current_top_index].caption
        )
      }
    }
  }, [_c('img', {
    staticClass: "share-icon",
    attrs: {
      "src": "/static/img/ic-reply.svg"
    }
  })])])]) : _c('div', {
    staticClass: "video-card"
  }, [_c('div', {
    staticClass: "video-player",
    staticStyle: {
      "position": "relative",
      "height": "100%",
      "width": "100%"
    }
  }, [(
    _vm.top_sectionArr[_vm.current_top_index].photoId.match(
      '^vmvdo'
    )
  ) ? _c('iframe', {
    staticStyle: {
      "top": "0",
      "bottom": "0",
      "height": "90%",
      "width": "100%",
      "right": "0"
    },
    attrs: {
      "src": _vm.getVideoLink(
        this.top_sectionArr[_vm.current_top_index].photoId,
        this.top_sectionArr[_vm.current_top_index].photoSourceLink
      ),
      "frameborder": "0",
      "allow": "autoplay; fullscreen",
      "allowfullscreen": ""
    },
    on: {
      "load": function($event) {
        _vm.imgLoader = false
      }
    }
  }) : _c('youtube', {
    staticClass: "video-player-youtube",
    attrs: {
      "id": "yt_video",
      "video-id": _vm.getVideoId(
        this.top_sectionArr[_vm.current_top_index].photoId,
        this.top_sectionArr[_vm.current_top_index].photoSourceLink
      ),
      "player-vars": _vm.youtubeVideoParameter,
      "mute": _vm.muted,
      "player-width": "100%",
      "player-height": "90%"
    },
    on: {
      "pause": _vm.pause,
      "ready": _vm.ready,
      "playing": _vm.playing
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "control-section"
  }, [_c('div', {
    staticClass: "location-details"
  }, [(
    _vm.top_sectionArr[_vm.current_top_index].resourceType ===
    'image'
  ) ? _c('div', {
    staticClass: "control-item",
    on: {
      "click": function($event) {
        _vm.showSlideShow = !_vm.showSlideShow
      }
    }
  }, [_c('img', {
    staticClass: "pointer ml-1",
    attrs: {
      "src": "/static/img/icons/ic-slideshow.svg"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Slideshow")])]) : _c('div', {
    staticClass: "control-item"
  }, [_c('i', {
    staticClass: "material-icons pointer",
    style: (!_vm.fullScreen ? '' : 'color:#febd35'),
    on: {
      "click": function($event) {
        _vm.fullScreen = !_vm.fullScreen
      }
    }
  }, [_vm._v(_vm._s(!_vm.fullScreen ? "zoom_out_map" : "fullscreen_exit"))]), _vm._v(" "), _c('label', [_vm._v("Fullscreen")])]), _vm._v(" "), _c('a', {
    class: _vm.top_sectionArr[_vm.current_top_index].hasPanoramaView ?
      'get-directions-link-button control-item' :
      'get-directions-botton-flex control-item',
    attrs: {
      "href": _vm.getGoogleEarthLink(),
      "target": _vm.newBrowserTab(),
      "rel": "noopener"
    }
  }, [_c('img', {
    staticClass: "heli-view-image",
    attrs: {
      "src": "/static/img/drone-white.svg",
      "alt": "helicopter"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Drone view")])]), _vm._v(" "), (_vm.top_sectionArr[_vm.current_top_index].hasPanoramaView) ? _c('a', {
    staticClass: "street-view-link-button control-item",
    attrs: {
      "href": _vm.top_sectionArr[_vm.current_top_index].streetViewURL,
      "target": _vm.newBrowserTab(),
      "rel": "noopener"
    }
  }, [_c('img', {
    staticClass: "virtual-doll",
    attrs: {
      "src": "/static/img/street-view-doll-white.svg",
      "alt": "doll"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Virtual tour")])]) : _vm._e(), _vm._v(" "), (_vm.top_sectionArr[_vm.current_top_index].hasPanoramaView) ? _c('div', [_c('a', {
    class: _vm.top_sectionArr[_vm.current_top_index].hasPanoramaView ?
      'get-directions-link-button control-item' :
      'get-directions-botton-flex control-item',
    attrs: {
      "href": _vm.getDirectionLink(),
      "target": _vm.newBrowserTab(),
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("directions")]), _vm._v("Directions\n                        ")])]) : _c('div', [_c('a', {
    staticClass: "get-directions-botton-flex control-item",
    attrs: {
      "href": _vm.top_sectionArr[_vm.current_top_index].streetViewURL,
      "target": _vm.newBrowserTab()
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("directions")]), _vm._v("Directions\n                        ")])]), _vm._v(" "), (
    _vm.top_sectionArr[_vm.current_top_index].resourceType ===
    'video'
  ) ? _c('div', [(
    _vm.top_sectionArr[_vm.current_top_index].photoId.match(
      '^ytvdo'
    )
  ) ? _c('div', {
    class: _vm.audioClasses(),
    on: {
      "click": function($event) {
        _vm.muted = !_vm.muted
      }
    }
  }, [(_vm.muted) ? _c('label', [_vm._v("Turn sound on")]) : _vm._e(), _vm._v(" "), (_vm.muted) ? _c('i', {
    staticClass: "material-icons white--text"
  }, [_vm._v("volume_off")]) : _c('i', {
    staticClass: "material-icons white--text"
  }, [_vm._v("volume_up")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nearby-places"
  }, [_c('FeedbackFish', {
    attrs: {
      "projectId": "583bd8bafa525e"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "feedback"
  }, [_c('img', {
    staticClass: "pointer feedback-speech-bubble",
    attrs: {
      "src": __webpack_require__(594),
      "data-feedback-fish": "",
      "data-feedback-fish-position": _vm.top_sectionArr[_vm.current_top_index].photoId,
      "data-feedback-fish-userid": _vm.isLoggedIn ? _vm.user.email : ''
    }
  }), _vm._v(" "), _c('label', [_vm._v("Feeback")])]), _vm._v(" "), (_vm.nearBy.length > 1) ? _c('a', {
    staticClass: "nearby-button",
    attrs: {
      "href": "#nearby-spots"
    }
  }, [_vm._v("DISCOVER NEARBY PLACES")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "photo-details"
  }, [(_vm.nearBy.length > 1) ? _c('a', {
    staticClass: "nearby-button-mobile",
    attrs: {
      "href": "#nearby-spots"
    }
  }, [_vm._v("DISCOVER NEARBY PLACES")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "photographer-details"
  }, [_c('div', {
    class: _vm.top_sectionArr[_vm.current_top_index].uploader !== 'admin' ?
      'pointer photographer-profile-user' :
      'photographer-profile',
    staticStyle: {
      "display": "flex"
    }
  }, [(
    _vm.top_sectionArr[_vm.current_top_index].uploader !== 'admin'
  ) ? _c('img', {
    attrs: {
      "src": _vm.top_sectionArr[_vm.current_top_index]
        .mediaSourceInformation.photoGrapherPic,
      "alt": "profile-photo"
    },
    on: {
      "click": function($event) {
        _vm.top_sectionArr[_vm.current_top_index].uploader !== 'admin' ?
          _vm.$router.push(
            ("/profile?selected_tab=checkins&profile_id=" + (_vm.top_sectionArr[_vm.current_top_index].mediaSourceInformation.photoGrapherId))
          ) :
          ''
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "name-container text-xs-left"
  }, [_c('div', [_c('span', {
    on: {
      "click": function($event) {
        _vm.top_sectionArr[_vm.current_top_index].uploader !==
          'admin' ?
          _vm.$router.push(
            ("/profile?selected_tab=checkins&profile_id=" + (_vm.top_sectionArr[_vm.current_top_index].mediaSourceInformation.photoGrapherId))
          ) :
          ''
      }
    }
  }, [_vm._v(_vm._s(_vm.cropUsername(
    _vm.top_sectionArr[_vm.current_top_index]
    .mediaSourceInformation.photoGrapherName
  )))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.$modal.show('license-modal')
      }
    }
  }, [_vm._v("©")])])])]), _vm._v(" "), _c('FeedbackFish', {
    attrs: {
      "projectId": "583bd8bafa525e"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pointer feedback-speech-bubble",
    attrs: {
      "src": __webpack_require__(594),
      "height": "25px",
      "data-feedback-fish": "",
      "data-feedback-fish-position": _vm.top_sectionArr[_vm.current_top_index].photoId,
      "data-feedback-fish-userid": _vm.isLoggedIn ? _vm.user.email : ''
    }
  })], 1)])])]), _vm._v(" "), (
    this.top_sectionArr[_vm.current_top_index].resourceType == 'video'
  ) ? _c('div', {
    staticClass: "details-container"
  }, [(_vm.fullScreen) ? _c('div', {
    staticClass: "top-section-container"
  }, [(
    _vm.top_sectionArr[_vm.current_top_index].photoId.match('^vmvdo')
  ) ? _c('iframe', {
    staticStyle: {
      "top": "0",
      "bottom": "0",
      "height": "90%",
      "width": "100%",
      "right": "0"
    },
    attrs: {
      "src": _vm.getVideoLink(
        this.top_sectionArr[_vm.current_top_index].photoId,
        this.top_sectionArr[_vm.current_top_index].photoSourceLink
      ),
      "frameborder": "0",
      "allow": "autoplay; fullscreen",
      "allowfullscreen": ""
    },
    on: {
      "load": function($event) {
        _vm.imgLoader = false
      }
    }
  }) : _c('youtube', {
    staticClass: "video-player-youtube",
    attrs: {
      "id": "yt_video",
      "video-id": _vm.getVideoId(
        this.top_sectionArr[_vm.current_top_index].photoId,
        this.top_sectionArr[_vm.current_top_index].photoSourceLink
      ),
      "player-vars": _vm.youtubeVideoParameter,
      "mute": _vm.muted,
      "player-width": "100%",
      "player-height": "90%"
    },
    on: {
      "pause": _vm.pause,
      "ready": _vm.ready,
      "playing": _vm.playing
    }
  }), _vm._v(" "), (_vm.showFooter) ? _c('div', {
    staticClass: "fullscreen-footer",
    style: (_vm.fullScreen ? 'z-index:2000' : '')
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "like-share-fullscreen-container pointer"
  }, [_c('i', {
    staticClass: "material-icons pointer",
    style: (!_vm.fullScreen ? 'font-size: 1.4em' : 'color:#febd35'),
    on: {
      "click": function($event) {
        _vm.fullScreen = !_vm.fullScreen
      }
    }
  }, [_vm._v(_vm._s(!_vm.fullScreen ? "zoom_out_map" : "fullscreen_exit"))]), _vm._v(" "), _c('FeedbackFish', {
    attrs: {
      "projectId": "583bd8bafa525e"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pointer feedback-speech-bubble",
    attrs: {
      "src": __webpack_require__(594),
      "height": "25px",
      "data-feedback-fish": "",
      "data-feedback-fish-position": _vm.top_sectionArr[_vm.current_top_index].photoId,
      "data-feedback-fish-userid": _vm.isLoggedIn ? _vm.user.email : ''
    }
  })], 1)])]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.nearBy.length > 1 &&
    this.top_sectionArr[_vm.current_top_index].resourceType == 'image'
  ) ? _c('div', {
    staticClass: "near-height",
    attrs: {
      "id": "nearby-spots"
    }
  }, [_c('div', {
    staticClass: "nearby-images"
  }, [(
    _vm.nearBy[0] !== _vm.$router.currentRoute.params.id &&
    _vm.nearBy.length !== 1
  ) ? _c('div', {
    staticClass: "text-xs-left"
  }, [_vm._v("\n                  Nearby spots\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "scrollmenu",
    attrs: {
      "id": "nearby"
    },
    on: {
      "scroll": function($event) {
        return _vm.getScroll()
      }
    }
  }, _vm._l((_vm.nearBy), function(image, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (image.photoId != _vm.$route.params.id),
        expression: "image.photoId != $route.params.id"
      }],
      key: index,
      staticClass: "a-tag",
      style: ({
        paddingRight: ("" + (index === _vm.nearBy.length - 1 ? '20px' : '0px')),
        paddingLeft: ("" + (index === 0 ? '0px' : '20px')),
      })
    }, [(!image.photoId.match('^vmvdo')) ? _c('div', {
      on: {
        "click": function($event) {
          _vm.$router.push(("/id/" + (image.photoId) + "?inapp=true"));
          _vm.$forceUpdate();
        }
      }
    }, [_c('v-lazy-image', {
      staticClass: "pointer",
      staticStyle: {
        "object-fit": "cover"
      },
      attrs: {
        "src": _vm.nearbyViewzzzImage(image.photoId, image)
      }
    })], 1) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.nearBy.length === 0) ? _c('div') : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm.fullScreen) ? _c('div', {
    staticClass: "sticky-footer"
  }, [_c('div', {
    staticClass: "navigations"
  }, [(_vm.showHomeIcon) ? _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "https://www.withaview.co/"
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Home")])]) : _c('button', {
    staticClass: "list-view-btn",
    on: {
      "click": function($event) {
        return _vm.goToHome()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v(" reorder")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.goToHome()
      }
    }
  }, [_vm._v("List")])])]), _vm._v(" "), _c('div', {
    staticClass: "photo-description"
  }, [_c('span', {
    staticClass: "caption pb-2"
  }, [_vm._v("\n            " + _vm._s(this.top_sectionArr[_vm.current_top_index].caption ?
    this.top_sectionArr[_vm.current_top_index].caption :
    "") + "\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_c('pre', {
    class: _vm.getSpotType(_vm.top_sectionArr[_vm.current_top_index]) == 'Spot' ?
      'spotTypeSpot' :
      'spotTypeOthers'
  }, [_vm._v(_vm._s(_vm.getSpotType(_vm.top_sectionArr[_vm.current_top_index])) + " ")]), _vm._v(" "), (_vm.top_sectionArr[_vm.current_top_index].hasGeohash) ? _c('pre', [_vm._v("in " + _vm._s(_vm.getCity(_vm.top_sectionArr[_vm.current_top_index])))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%",
      "align-items": "center",
      "justify-content": "flex-end",
      "width": "100%",
      "display": "flex"
    }
  }, [(_vm.top_sectionArr[_vm.current_top_index].propertyLink) ? _c('a', {
    staticClass: "check-price-btn",
    attrs: {
      "href": _vm.top_sectionArr[_vm.current_top_index].propertyLink,
      "target": _vm.screenW > 768 ? '_blank' : '_self',
      "nofollow": ""
    }
  }, [_vm._v("Check Price")]) : _vm._e(), _vm._v(" "), (_vm.top_sectionArr[_vm.current_top_index].fourSquareVenueUrl) ? _c('a', {
    staticClass: "read-review-btn",
    attrs: {
      "href": _vm.top_sectionArr[_vm.current_top_index].fourSquareVenueUrl,
      "target": _vm.screenW > 768 ? '_blank' : '_self',
      "nofollow": ""
    }
  }, [_vm._v("Read review")]) : _vm._e(), _vm._v(" "), _c('button', {
    class: ("travel-list-btn " + (_vm.top_sectionArr[_vm.current_top_index].isCheckedin ? 'checked' : 'add'))
  }, [_c('i', {
    staticClass: "material-icons mr-2"
  }, [_vm._v("\n              " + _vm._s(_vm.top_sectionArr[_vm.current_top_index].isCheckedin ? "check" : "add") + "\n            ")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.changeCntCheckin(_vm.top_sectionArr[_vm.current_top_index])
      }
    }
  }, [_vm._v(_vm._s(_vm.top_sectionArr[_vm.current_top_index].isCheckedin ?
    "On my travel list" :
    "Save to travel list"))])])])]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/wav-logo.png",
      "alt": "logo",
      "height": "30px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-decoration-none",
    attrs: {
      "href": "https://www.withaview.co"
    }
  }, [_c('img', {
    staticClass: "hidden-md-and-up mt-2",
    attrs: {
      "src": "/static/img/icons/wav-logo.png",
      "height": "24px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pill pointer",
    staticStyle: {
      "color": "#b6b6b6",
      "flex-grow": "1"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("note_add")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', [_c('img', {
    attrs: {
      "loading": "lazy",
      "height": "24",
      "src": __webpack_require__(595)
    }
  })])
}]}

/***/ }),

/***/ 841:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "align-items": "center",
      "justify-content": "center",
      "width": "100vw",
      "z-index": "1000",
      "height": "100vh",
      "position": "fixed",
      "background-color": "#000000"
    },
    attrs: {
      "onload": this.getQuotes()
    }
  }, [_c('div', {
    staticClass: "loader-new"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-quote"
  }, [_c('p', {
    staticClass: "quoteText"
  }, [_vm._v(_vm._s(_vm.currentQuote.text))]), _vm._v(" "), _c('p', {
    staticClass: "quoteAuthor"
  }, [_vm._v(_vm._s(_vm.currentQuote.author))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loader/loading-viewZzz.svg",
      "height": "30"
    }
  })])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/v/1733832636781/js/5.a8f77a96ca52b8912153.js